
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire10c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire10c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.4";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.4" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.4";

});



parcelRegister("dkmhp", function(module, exports) {

$parcel$export(module.exports, "setLiveMcSession", () => $9b3e6cedef55f70c$export$8d686397921f30df);
$parcel$export(module.exports, "authAPI", () => $9b3e6cedef55f70c$export$39813f5a3cc2bc5a);
$parcel$export(module.exports, "aiAPI", () => $9b3e6cedef55f70c$export$b0134ec2fe112f5f);
$parcel$export(module.exports, "adminAPI", () => $9b3e6cedef55f70c$export$c7e9064c62c3dc60);
$parcel$export(module.exports, "mcAPI", () => $9b3e6cedef55f70c$export$ca44924af4371096);
$parcel$export(module.exports, "setAuthToken", () => $9b3e6cedef55f70c$export$3c4602e16d9ace38);
$parcel$export(module.exports, "getCurrentUser", () => $9b3e6cedef55f70c$export$e5432d4c8eb97ea7);
$parcel$export(module.exports, "setCurrentUser", () => $9b3e6cedef55f70c$export$64e99e757b084e7c);
parcelRequire("fmRoT");
var $7we3r = parcelRequire("7we3r");
const $9b3e6cedef55f70c$var$API_BASE_URL = "https://www.matemeal.com/api";
const $9b3e6cedef55f70c$var$api = (0, $7we3r.default).create({
    baseURL: $9b3e6cedef55f70c$var$API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});
// ── Żywa sesja MC ──────────────────────────────────────────────────────────────
// Token SSO Lidla żyje ~5 minut, więc kopia sesji zapisana w bazie jest nieświeża
// niemal zawsze — a backend (_resolve_session) woli sesję z nagłówka X-MC-Session
// i dopiero w jej braku schodzi do bazy. Bez tego nagłówka cała ta gałąź była
// martwa i mc-recover/mc-push jechały na wygasłej kopii („Sesja MC wygasła").
// Sesję wstrzykuje App.jsx za każdym razem, gdy wtyczka odda świeże ciasteczka.
let $9b3e6cedef55f70c$var$liveMcSession = null;
const $9b3e6cedef55f70c$export$8d686397921f30df = (session)=>{
    $9b3e6cedef55f70c$var$liveMcSession = session && session.wp_logged_in_value && session.lidl_sso_token ? session : null;
};
// btoa przewraca się na znakach spoza Latin-1, a ciasteczka MC bywają URL-enkodowane
const $9b3e6cedef55f70c$var$encodeSession = (session)=>btoa(unescape(encodeURIComponent(JSON.stringify(session))));
$9b3e6cedef55f70c$var$api.interceptors.request.use((config)=>{
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    // Tylko endpointy AI rozmawiają z MC — nie ma po co obciążać reszty ~2 KB nagłówka
    if ($9b3e6cedef55f70c$var$liveMcSession && (config.url || '').startsWith('/ai/')) try {
        config.headers['X-MC-Session'] = $9b3e6cedef55f70c$var$encodeSession($9b3e6cedef55f70c$var$liveMcSession);
    } catch  {
    // Sesja nie do zakodowania — backend użyje kopii z bazy
    }
    return config;
}, (error)=>Promise.reject(error));
$9b3e6cedef55f70c$var$api.interceptors.response.use((response)=>response, (error)=>{
    if (error.response?.status === 401) {
        const token = localStorage.getItem('token');
        const url = error.config?.url || '';
        if (token && !url.includes('/auth/login') && !url.includes('/auth/register')) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/';
        }
    }
    return Promise.reject(error);
});
const $9b3e6cedef55f70c$export$39813f5a3cc2bc5a = {
    register: (userData)=>$9b3e6cedef55f70c$var$api.post('/auth/register', userData),
    login: (credentials)=>$9b3e6cedef55f70c$var$api.post('/auth/login', credentials),
    profile: ()=>$9b3e6cedef55f70c$var$api.get('/auth/profile'),
    updateProfile: (data)=>$9b3e6cedef55f70c$var$api.put('/auth/profile', data),
    refresh: ()=>$9b3e6cedef55f70c$var$api.post('/auth/refresh'),
    forgotPassword: (email)=>$9b3e6cedef55f70c$var$api.post('/auth/forgot-password', {
            email: email
        }),
    verifyResetCode: (email, code, pass)=>$9b3e6cedef55f70c$var$api.post('/auth/verify-reset-code', {
            email: email,
            code: code,
            new_password: pass
        }),
    deleteAccount: (password)=>$9b3e6cedef55f70c$var$api.delete('/auth/account', {
            data: {
                password: password
            }
        }),
    logout: ()=>{
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    }
};
const $9b3e6cedef55f70c$export$b0134ec2fe112f5f = {
    saveMCSession: (cookieString)=>$9b3e6cedef55f70c$var$api.post('/ai/mc-session', {
            cookie_string: cookieString
        }),
    getMCSession: ()=>$9b3e6cedef55f70c$var$api.get('/ai/mc-session'),
    deleteMCSession: ()=>$9b3e6cedef55f70c$var$api.delete('/ai/mc-session'),
    parseRecipe: (text)=>$9b3e6cedef55f70c$var$api.post('/ai/parse-recipe', {
            text: text
        }),
    getConversionStatus: ()=>$9b3e6cedef55f70c$var$api.get('/ai/conversion-status'),
    getSavedRecipes: ()=>$9b3e6cedef55f70c$var$api.get('/ai/saved-recipes'),
    saveRecipe: (data)=>$9b3e6cedef55f70c$var$api.post('/ai/saved-recipes', data),
    updateSavedRecipe: (id, data)=>$9b3e6cedef55f70c$var$api.put(`/ai/saved-recipes/${id}`, data),
    deleteSavedRecipe: (id)=>$9b3e6cedef55f70c$var$api.delete(`/ai/saved-recipes/${id}`),
    pushRecipeToMC: (mcPayload, lang = 'pl')=>$9b3e6cedef55f70c$var$api.post('/ai/mc-push', {
            mc_payload: mcPayload,
            lang: lang
        }),
    // Wtyczka abortuje fetch do MC po 12 s, a MC potrafi utworzyć przepis mimo to —
    // wtedy szukamy go po tytule na liście własnych przepisów i odzyskujemy ID
    recoverMcPush: (title, mcPayload, lang = 'pl', withinMinutes = 30)=>$9b3e6cedef55f70c$var$api.post('/ai/mc-recover', {
            title: title,
            mc_payload: mcPayload,
            lang: lang,
            within_minutes: withinMinutes
        }),
    rebuildMcPayload: (recipe, lang = 'pl')=>$9b3e6cedef55f70c$var$api.post('/ai/mc-rebuild-payload', {
            recipe: recipe,
            lang: lang
        }),
    importUrl: (url)=>$9b3e6cedef55f70c$var$api.post('/ai/import-url', {
            url: url
        }),
    ocrImage: (file)=>{
        const fd = new FormData();
        fd.append('image', file);
        return $9b3e6cedef55f70c$var$api.post('/ai/ocr-image', fd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    // Zdjęcie potrawy → miniatura przepisu na MC. Upload jest osobny od wysyłki:
    // najpierw pliki lądują w mediach MC (mc-image), a ID podpinamy pod przepis
    // dopiero gdy już powstał (mc-attach-image).
    uploadMcImage: (file, lang = 'pl')=>{
        const fd = new FormData();
        fd.append('image', file);
        fd.append('lang', lang);
        return $9b3e6cedef55f70c$var$api.post('/ai/mc-image', fd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    attachMcImage: (recipeId, mcPayload, media, lang = 'pl')=>$9b3e6cedef55f70c$var$api.post('/ai/mc-attach-image', {
            recipe_id: recipeId,
            mc_payload: mcPayload,
            media: media,
            lang: lang
        }),
    // Wysyłka w tle: serwer sam wysyła, dopytuje MC i domyka publikację, więc kartę
    // można zamknąć. Zwraca job_id do odpytywania o stan.
    pushMcAsync: (mcPayload, lang = 'pl', media = null)=>$9b3e6cedef55f70c$var$api.post('/ai/mc-push-async', {
            mc_payload: mcPayload,
            lang: lang,
            media: media
        }),
    mcPushStatus: (jobId)=>$9b3e6cedef55f70c$var$api.get(`/ai/mc-push-status/${jobId}`)
};
const $9b3e6cedef55f70c$export$c7e9064c62c3dc60 = {
    getStats: ()=>$9b3e6cedef55f70c$var$api.get('/admin/stats'),
    listUsers: ()=>$9b3e6cedef55f70c$var$api.get('/admin/users'),
    createUser: (data)=>$9b3e6cedef55f70c$var$api.post('/admin/users', data),
    updateUser: (id, data)=>$9b3e6cedef55f70c$var$api.put(`/admin/users/${id}`, data),
    deleteUser: (id)=>$9b3e6cedef55f70c$var$api.delete(`/admin/users/${id}`),
    resetPassword: (id, pass)=>$9b3e6cedef55f70c$var$api.put(`/admin/users/${id}/reset-password`, {
            new_password: pass
        }),
    resetConversions: (id)=>$9b3e6cedef55f70c$var$api.post(`/admin/users/${id}/reset-conversions`),
    getUserRecipes: (id)=>$9b3e6cedef55f70c$var$api.get(`/admin/users/${id}/recipes`),
    deleteRecipe: (id)=>$9b3e6cedef55f70c$var$api.delete(`/admin/recipes/${id}`),
    exportRecipes: ()=>$9b3e6cedef55f70c$var$api.get('/admin/recipes-export'),
    importRecipes: (data, mode)=>$9b3e6cedef55f70c$var$api.post(`/admin/recipes-import?mode=${mode}`, data)
};
const $9b3e6cedef55f70c$export$ca44924af4371096 = {
    convertRecipe: async (data, onProgress)=>{
        const token = localStorage.getItem('token');
        const base = "https://www.matemeal.com/api";
        const res = await fetch(`${base}/ai/mc-convert`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...token ? {
                    Authorization: `Bearer ${token}`
                } : {}
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) {
            const text = await res.text();
            return {
                success: false,
                error: `Serwer zwr\xf3ci\u{142} ${res.status}: ${text.slice(0, 200)}`
            };
        }
        const reader = res.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        while(true){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            buffer += decoder.decode(value, {
                stream: true
            });
            const blocks = buffer.split('\n\n');
            buffer = blocks.pop();
            for (const block of blocks){
                const line = block.split('\n').find((l)=>l.startsWith('data: '));
                if (!line) continue;
                try {
                    const event = JSON.parse(line.slice(6));
                    if (onProgress) onProgress(event);
                    if (event.stage === 'done') return event.result;
                    if (event.stage === 'error') return {
                        success: false,
                        error: event.message,
                        limit_reached: event.limit_reached
                    };
                } catch  {}
            }
        }
        return {
            success: false,
            error: "Nieprawid\u0142owa odpowied\u017A serwera"
        };
    },
    repairRecipe: async (data)=>{
        const token = localStorage.getItem('token');
        const base = "https://www.matemeal.com/api";
        const res = await fetch(`${base}/ai/mc-repair`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...token ? {
                    Authorization: `Bearer ${token}`
                } : {}
            },
            body: JSON.stringify(data)
        });
        const text = await res.text();
        try {
            return JSON.parse(text);
        } catch  {
            return {
                success: false,
                error: `Serwer zwr\xf3ci\u{142} ${res.status}: ${text.slice(0, 200)}`
            };
        }
    },
    fixSteps: async (data)=>{
        const token = localStorage.getItem('token');
        const base = "https://www.matemeal.com/api";
        const res = await fetch(`${base}/ai/mc-fix-steps`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...token ? {
                    Authorization: `Bearer ${token}`
                } : {}
            },
            body: JSON.stringify(data)
        });
        const text = await res.text();
        try {
            return JSON.parse(text);
        } catch  {
            return {
                success: false,
                error: `Serwer zwr\xf3ci\u{142} ${res.status}: ${text.slice(0, 200)}`
            };
        }
    }
};
const $9b3e6cedef55f70c$export$3c4602e16d9ace38 = (token)=>{
    localStorage.setItem('token', token);
};
const $9b3e6cedef55f70c$export$e5432d4c8eb97ea7 = ()=>{
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
};
const $9b3e6cedef55f70c$export$64e99e757b084e7c = (user)=>{
    localStorage.setItem('user', JSON.stringify(user));
};
var $9b3e6cedef55f70c$export$2e2bcd8739ae039 = $9b3e6cedef55f70c$var$api;

});
parcelRegister("fmRoT", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("7we3r")).default);

var $7we3r = parcelRequire("7we3r");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $7we3r.default);

});
parcelRegister("7we3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $57966c7e0affc4cb$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $blSvA = parcelRequire("blSvA");

var $8cmY2 = parcelRequire("8cmY2");

var $dIGMp = parcelRequire("dIGMp");

var $lAKPy = parcelRequire("lAKPy");

var $7L4QX = parcelRequire("7L4QX");

var $35BUy = parcelRequire("35BUy");

var $jOwpo = parcelRequire("jOwpo");

var $6HVMZ = parcelRequire("6HVMZ");

var $JEeti = parcelRequire("JEeti");

var $dxy9O = parcelRequire("dxy9O");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");

var $lnWCo = parcelRequire("lnWCo");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $ewFRw.default)(defaultConfig);
    const instance = (0, $jJbMR.default)((0, $ewFRw.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $gKvUL.default).extend(instance, (0, $ewFRw.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $gKvUL.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $lk5EI.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $blSvA.default));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $ewFRw.default);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $dIGMp.default);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $lAKPy.default);
$57966c7e0affc4cb$var$axios.isCancel = (0, $7L4QX.default);
$57966c7e0affc4cb$var$axios.VERSION = (0, $35BUy.VERSION);
$57966c7e0affc4cb$var$axios.toFormData = (0, $jOwpo.default);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $6HVMZ.default);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $JEeti.default);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $dxy9O.default);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $lk5EI.default);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $bxxyx.default);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $8cmY2.default)((0, $gKvUL.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $jZ6wW.default).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $lnWCo.default);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c319b2c832c2914a$export$2e2bcd8739ae039);

var $jJbMR = parcelRequire("jJbMR");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== 'object') return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($c319b2c832c2914a$var$toStringTag in val) && !($c319b2c832c2914a$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 * 
 * @param {*} value The value to test
 * 
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 * 
 * @param {*} formData The formData to test
 * 
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== 'undefined' ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            value: (0, $jJbMR.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable
};

});
parcelRegister("jJbMR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5cb5cefd6507f7e$export$2e2bcd8739ae039);
'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("ewFRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93486d2307f31c3$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $7GD7a = parcelRequire("7GD7a");

var $bv3QM = parcelRequire("bv3QM");

var $bxxyx = parcelRequire("bxxyx");

var $6YCMk = parcelRequire("6YCMk");
'use strict';
const $a93486d2307f31c3$var$validators = (0, $bv3QM.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $83RYu.default)(),
            response: new (0, $83RYu.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $lk5EI.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $bv3QM.default).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $gKvUL.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $bv3QM.default).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $bv3QM.default).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $gKvUL.default).merge(headers.common, headers[config.method]);
        headers && (0, $gKvUL.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $bxxyx.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $6YCMk.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $dlZEJ.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $dlZEJ.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $lk5EI.default)(this.defaults, config);
        const fullPath = (0, $7GD7a.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $cbIsf.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $gKvUL.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $lk5EI.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $gKvUL.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $lk5EI.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df8fedf1c1e4428$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $l9LQd = parcelRequire("l9LQd");
'use strict';
/**
 * It replaces URL-encoded forms of `:`, `$`, `,`, and spaces with
 * their plain counterparts (`:`, `$`, `,`, `+`).
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    const _options = (0, $gKvUL.default).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $gKvUL.default).isURLSearchParams(params) ? params.toString() : new (0, $l9LQd.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("l9LQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66f8c7b4f247caf$export$2e2bcd8739ae039);

var $jOwpo = parcelRequire("jOwpo");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $jOwpo.default)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;

});
parcelRegister("jOwpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6cbd383b18c9625$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $5vpyF = parcelRequire("5vpyF");

var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $gKvUL.default).isPlainObject(thing) || (0, $gKvUL.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $gKvUL.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $gKvUL.default).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $gKvUL.default).toFlatObject((0, $gKvUL.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $5vpyF.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $gKvUL.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $gKvUL.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $gKvUL.default).isSpecCompliantForm(formData);
    if (!(0, $gKvUL.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $gKvUL.default).isDate(value)) return value.toISOString();
        if ((0, $gKvUL.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $gKvUL.default).isBlob(value)) throw new (0, $6HVMZ.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $gKvUL.default).isArrayBuffer(value) || (0, $gKvUL.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $gKvUL.default).isReactNative(formData) && (0, $gKvUL.default).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $gKvUL.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $gKvUL.default).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $gKvUL.default).isFileList(value) || (0, $gKvUL.default).endsWith(key, '[]')) && (arr = (0, $gKvUL.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $gKvUL.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $gKvUL.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $gKvUL.default).forEach(value, function each(el, key) {
            const result = !((0, $gKvUL.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $gKvUL.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;

});
parcelRegister("6HVMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2395edb77acf3a$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
     * Create an Error with the specified message, config, error code, request and response.
     *
     * @param {string} message The error message.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [config] The config.
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     *
     * @returns {Error} The created error.
     */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $gKvUL.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;

});

parcelRegister("5vpyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4023ac50ad132196$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("83RYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de878cd737ef277$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $gKvUL.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8d10189805ccc0$export$2e2bcd8739ae039);

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $blSvA = parcelRequire("blSvA");

var $dIGMp = parcelRequire("dIGMp");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $dIGMp.default)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $bxxyx.default).from(config.headers);
    // Transform request data
    config.data = (0, $7YJ0v.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $jZ6wW.default).getAdapter(config.adapter || (0, $blSvA.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $7YJ0v.default).call(config, config.transformResponse, response);
        response.headers = (0, $bxxyx.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7L4QX.default)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $7YJ0v.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $bxxyx.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("7YJ0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf10c777cce5f4f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $blSvA = parcelRequire("blSvA");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $blSvA.default);
    const context = response || config;
    const headers = (0, $bxxyx.default).from(context.headers);
    let data = context.data;
    (0, $gKvUL.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("blSvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $843bf0209bc94df8$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $6YCMk = parcelRequire("6YCMk");

var $jOwpo = parcelRequire("jOwpo");

var $lcuqa = parcelRequire("lcuqa");

var $g65xr = parcelRequire("g65xr");

var $8cmY2 = parcelRequire("8cmY2");
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $gKvUL.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $gKvUL.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $6YCMk.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $gKvUL.default).isObject(data);
            if (isObjectPayload && (0, $gKvUL.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $gKvUL.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $8cmY2.default)(data)) : data;
            if ((0, $gKvUL.default).isArrayBuffer(data) || (0, $gKvUL.default).isBuffer(data) || (0, $gKvUL.default).isStream(data) || (0, $gKvUL.default).isFile(data) || (0, $gKvUL.default).isBlob(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if ((0, $gKvUL.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $gKvUL.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $lcuqa.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $gKvUL.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $jOwpo.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $gKvUL.default).isResponse(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if (data && (0, $gKvUL.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $6HVMZ.default).from(e, (0, $6HVMZ.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $g65xr.default).classes.FormData,
        Blob: (0, $g65xr.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $gKvUL.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;

});
parcelRegister("6YCMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $51466d41a76e5b4b$export$2e2bcd8739ae039);
'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};

});

parcelRegister("lcuqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f250f62cadb740$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jOwpo = parcelRequire("jOwpo");

var $g65xr = parcelRequire("g65xr");
'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $jOwpo.default)(data, new (0, $g65xr.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $g65xr.default).isNode && (0, $gKvUL.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRegister("g65xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb8180acb278e187$export$2e2bcd8739ae039);

var $44xkq = parcelRequire("44xkq");

var $7pJXT = parcelRequire("7pJXT");
var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$7pJXT,
    ...(0, $44xkq.default)
};

});
parcelRegister("44xkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f71637df772b183$export$2e2bcd8739ae039);

var $9ww2p = parcelRequire("9ww2p");

var $bzEBu = parcelRequire("bzEBu");

var $7HTwA = parcelRequire("7HTwA");
var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9ww2p.default,
        FormData: $bzEBu.default,
        Blob: $7HTwA.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("9ww2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eeff4490c995137$export$2e2bcd8739ae039);

var $l9LQd = parcelRequire("l9LQd");
'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $l9LQd.default);

});

parcelRegister("bzEBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d275a264afb13f$export$2e2bcd8739ae039);
'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("7HTwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c79e94740631e4$export$2e2bcd8739ae039);
'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("7pJXT", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export(module.exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("8cmY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8142930b3b943f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $gKvUL.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $gKvUL.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $gKvUL.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $gKvUL.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $gKvUL.default).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $gKvUL.default).isFormData(formData) && (0, $gKvUL.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $gKvUL.default).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;

});


parcelRegister("bxxyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $866cce54f6bdfb0c$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $lDriZ = parcelRequire("lDriZ");
'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $gKvUL.default).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value).replace(/[\r\n]+$/, '');
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $gKvUL.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $gKvUL.default).isString(value)) return;
    if ((0, $gKvUL.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $gKvUL.default).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $gKvUL.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $gKvUL.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $gKvUL.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $gKvUL.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $gKvUL.default).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $lDriZ.default)(header), valueOrRewrite);
        else if ((0, $gKvUL.default).isObject(header) && (0, $gKvUL.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $gKvUL.default).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $gKvUL.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $gKvUL.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $gKvUL.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $gKvUL.default).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $gKvUL.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            const key = (0, $gKvUL.default).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $gKvUL.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $gKvUL.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $gKvUL.default).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $gKvUL.default).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;

});
parcelRegister("lDriZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc026bbf9ee156f1$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $gKvUL.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});



parcelRegister("7L4QX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a60afef8b0dd173$export$2e2bcd8739ae039);
'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("dIGMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd0919e266b4fda$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
class $9fd0919e266b4fda$var$CanceledError extends (0, $6HVMZ.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $6HVMZ.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;

});

parcelRegister("jZ6wW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c8c7960873e9ee$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $5vpyF = parcelRequire("5vpyF");

var $at5cb = parcelRequire("at5cb");

var $jFSbX = parcelRequire("jFSbX");

var $6HVMZ = parcelRequire("6HVMZ");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $5vpyF.default),
    xhr: (0, $at5cb.default),
    fetch: {
        get: $jFSbX.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $gKvUL.default).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $gKvUL.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $gKvUL.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $6HVMZ.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $gKvUL.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $6HVMZ.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};

});
parcelRegister("at5cb", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f0a48d5eb7919b$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $6YCMk = parcelRequire("6YCMk");

var $6HVMZ = parcelRequire("6HVMZ");

var $dIGMp = parcelRequire("dIGMp");

var $32jg5 = parcelRequire("32jg5");

var $g65xr = parcelRequire("g65xr");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");
const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $eHGD2.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $bxxyx.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $bxxyx.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $kk0E9.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $6HVMZ.default)('Request aborted', (0, $6HVMZ.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $6HVMZ.default)(msg, (0, $6HVMZ.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $6YCMk.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $6HVMZ.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $6HVMZ.default).ETIMEDOUT : (0, $6HVMZ.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $gKvUL.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $gKvUL.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $2gEvX.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $2gEvX.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $dIGMp.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $32jg5.default)(_config.url);
        if (protocol && (0, $g65xr.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $6HVMZ.default)('Unsupported protocol ' + protocol + ':', (0, $6HVMZ.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb62d5372993dcf$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $6HVMZ.default)('Request failed with status code ' + response.status, [
        (0, $6HVMZ.default).ERR_BAD_REQUEST,
        (0, $6HVMZ.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("32jg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $23607f53e4fda918$export$2e2bcd8739ae039);
'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("2gEvX", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", () => $1a6c80b567b74091$export$c1b28109d46c3592);
$parcel$export(module.exports, "progressEventDecorator", () => $1a6c80b567b74091$export$d9fadd12586c18d6);
$parcel$export(module.exports, "asyncDecorator", () => $1a6c80b567b74091$export$5d35863c355a22a9);

var $6paAk = parcelRequire("6paAk");

var $dkklI = parcelRequire("dkklI");

var $gKvUL = parcelRequire("gKvUL");
const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $6paAk.default)(50, 250);
    return (0, $dkklI.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $gKvUL.default).asap(()=>fn(...args));

});
parcelRegister("6paAk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a9d49cd0e6b8acc$export$2e2bcd8739ae039);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;

});

parcelRegister("dkklI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3ced92bc7bdc99$export$2e2bcd8739ae039);
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;

});


parcelRegister("eHGD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab4625fac3104691$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $889er = parcelRequire("889er");

var $8JRzs = parcelRequire("8JRzs");

var $7GD7a = parcelRequire("7GD7a");

var $lk5EI = parcelRequire("lk5EI");

var $bxxyx = parcelRequire("bxxyx");

var $cbIsf = parcelRequire("cbIsf");
var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $lk5EI.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $bxxyx.default).from(headers);
    newConfig.url = (0, $cbIsf.default)((0, $7GD7a.default)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $gKvUL.default).isFormData(data)) {
        if ((0, $g65xr.default).hasStandardBrowserEnv || (0, $g65xr.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $gKvUL.default).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $g65xr.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $gKvUL.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $889er.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $8JRzs.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("889er", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb63b558e1fb85a$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $g65xr.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $g65xr.default).origin), (0, $g65xr.default).navigator && /(msie|trident)/i.test((0, $g65xr.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("8JRzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $65cc14c0704b5541$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $g65xr = parcelRequire("g65xr");
var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $gKvUL.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $gKvUL.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, $gKvUL.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $gKvUL.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("7GD7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $598acbfafd2c63c5$export$2e2bcd8739ae039);

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
'use strict';
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $ckHwb.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $fE4ul.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("ckHwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa91c1a59edb5d9$export$2e2bcd8739ae039);
'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("fE4ul", function(module, exports) {

$parcel$export(module.exports, "default", () => $b63e12c1e0b9e0be$export$2e2bcd8739ae039);
'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("lk5EI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f85fda54cd977b19$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $bxxyx.default) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $gKvUL.default).isPlainObject(target) && (0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge({}, source);
        else if ((0, $gKvUL.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $gKvUL.default).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $gKvUL.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $gKvUL.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("jFSbX", function(module, exports) {

$parcel$export(module.exports, "getFetch", () => $e52be20a9fc15e96$export$3105c6651375d4fa);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $dLozx = parcelRequire("dLozx");

var $hhnAb = parcelRequire("hhnAb");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");

var $kk0E9 = parcelRequire("kk0E9");
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $gKvUL.default);
const $e52be20a9fc15e96$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $gKvUL.default).global);
const { ReadableStream: $e52be20a9fc15e96$var$ReadableStream, TextEncoder: $e52be20a9fc15e96$var$TextEncoder } = (0, $gKvUL.default).global;
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    env = (0, $gKvUL.default).merge.call({
        skipUndefined: true
    }, $e52be20a9fc15e96$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction($e52be20a9fc15e96$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $e52be20a9fc15e96$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $e52be20a9fc15e96$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const body = new $e52be20a9fc15e96$var$ReadableStream();
        const hasContentType = new Request((0, $g65xr.default).origin, {
            body: body,
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $gKvUL.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $6HVMZ.default)(`Response type '${type}' is not supported`, (0, $6HVMZ.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $gKvUL.default).isBlob(body)) return body.size;
        if ((0, $gKvUL.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $g65xr.default).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $gKvUL.default).isArrayBufferView(body) || (0, $gKvUL.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $gKvUL.default).isURLSearchParams(body)) body = body + '';
        if ((0, $gKvUL.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $gKvUL.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $eHGD2.default)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $dLozx.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $gKvUL.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $2gEvX.progressEventDecorator)(requestContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onUploadProgress)));
                    data = (0, $hhnAb.trackStream)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $gKvUL.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $gKvUL.default).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $2gEvX.progressEventDecorator)(responseContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onDownloadProgress), true)) || [];
                response = new Response((0, $hhnAb.trackStream)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $gKvUL.default).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $kk0E9.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $bxxyx.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $6HVMZ.default)('Network Error', (0, $6HVMZ.default).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $6HVMZ.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;

});
parcelRegister("dLozx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a052b9a6636aacdc$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");

var $6HVMZ = parcelRequire("6HVMZ");

var $gKvUL = parcelRequire("gKvUL");
const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $6HVMZ.default) ? err : new (0, $dIGMp.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $6HVMZ.default)(`timeout of ${timeout}ms exceeded`, (0, $6HVMZ.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $gKvUL.default).asap(unsubscribe);
        return signal;
    }
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;

});

parcelRegister("hhnAb", function(module, exports) {

$parcel$export(module.exports, "trackStream", () => $c9465135abb26626$export$b0119225647bd83);
const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("bv3QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f59389941e7907$export$2e2bcd8739ae039);

var $35BUy = parcelRequire("35BUy");

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $35BUy.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $6HVMZ.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $6HVMZ.default).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $6HVMZ.default)('options must be an object', (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $6HVMZ.default)('option ' + opt + ' must be ' + result, (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $6HVMZ.default)('Unknown option ' + opt, (0, $6HVMZ.default).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});
parcelRegister("35BUy", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $23ff3f1a5c7912d5$export$a4ad2735b021c132);
const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.14.0";

});



parcelRegister("lAKPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb81495929d8a282$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $dIGMp.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {

$parcel$export(module.exports, "default", () => $089369673aa7c1c3$export$2e2bcd8739ae039);
'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("dxy9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db8da59db12cd94$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $gKvUL.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("lnWCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f919374d785e9fb8$export$2e2bcd8739ae039);
const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;

});




var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $dkmhp = parcelRequire("dkmhp");
// Most między aplikacją Android (Capacitor) a istniejącym kontraktem zdarzeń
// wtyczki Chrome: odpowiadamy na MC_EXT_GET_SESSION i ogłaszamy sesję przez
// MC_EXT_SESSION_RESULT dokładnie jak content script rozszerzenia — tylko
// ciasteczka czytamy z natywnego CookieManagera (plugin McSession), a nie
// z chrome.cookies. Dzięki temu App.jsx nie musi wiedzieć, skąd sesja pochodzi.
// W przeglądarce (poza apką) cały moduł jest wyłączony.
const $5a6742a4b36362a4$var$getCapacitor = ()=>typeof window !== 'undefined' ? window.Capacitor : undefined;
const $5a6742a4b36362a4$export$1efe58f5634014d1 = ()=>{
    const cap = $5a6742a4b36362a4$var$getCapacitor();
    return !!(cap && cap.isNativePlatform && cap.isNativePlatform());
};
const $5a6742a4b36362a4$var$mcPlugin = ()=>$5a6742a4b36362a4$var$getCapacitor()?.Plugins?.McSession;
// To samo dopasowanie kluczy co getMcSession() we wtyczce i _parse_mc_cookie_string
// w backendzie — sesja ma identyczny kształt niezależnie od źródła.
function $5a6742a4b36362a4$var$parseCookieString(str) {
    if (!str) return null;
    const map = {};
    str.split(/;\s*/).forEach((part)=>{
        const i = part.indexOf('=');
        if (i > 0) map[part.slice(0, i)] = part.slice(i + 1);
    });
    const names = Object.keys(map);
    const wpKey = names.find((k)=>k.startsWith('wordpress_logged_in_'));
    const lidlKey = names.find((k)=>k === 'lidl_sso_id_token' || k === 'lidl_sso_token' || k.startsWith('lidl_sso') || k.startsWith('lidl_connect') || k.startsWith('lidl_'));
    if (!wpKey || !lidlKey) return null;
    return {
        all_cookies_str: str,
        php_session_id: map.PHPSESSID || '',
        wp_logged_in_key: wpKey,
        wp_logged_in_value: map[wpKey],
        lidl_sso_key: lidlKey,
        lidl_sso_token: map[lidlKey],
        gclb: map.GCLB || ''
    };
}
function $5a6742a4b36362a4$var$announceSession(session) {
    document.dispatchEvent(new CustomEvent('MC_EXT_SESSION_RESULT', {
        detail: {
            session: session
        }
    }));
}
let $5a6742a4b36362a4$var$lastRefreshAt = 0;
async function $5a6742a4b36362a4$var$readAndAnnounce() {
    const plugin = $5a6742a4b36362a4$var$mcPlugin();
    if (!plugin) return null;
    try {
        // Token SSO Lidla żyje ~5 min — zwykły odczyt ciasteczek z dysku bywa
        // przeterminowany. refresh() przeładowuje stronę MC w niewidocznym WebView
        // i odświeża token; throttle, żeby nie mielić sieci przy serii pingów.
        const useRefresh = Date.now() - $5a6742a4b36362a4$var$lastRefreshAt > 45000;
        if (useRefresh) $5a6742a4b36362a4$var$lastRefreshAt = Date.now();
        const { cookies: cookies } = useRefresh ? await plugin.refresh() : await plugin.getCookies();
        const session = $5a6742a4b36362a4$var$parseCookieString(cookies);
        if (session) $5a6742a4b36362a4$var$announceSession(session);
        return session;
    } catch  {
        return null;
    }
}
let $5a6742a4b36362a4$var$initialized = false;
function $5a6742a4b36362a4$export$a7ac1466a98bfa17() {
    if (!$5a6742a4b36362a4$export$1efe58f5634014d1() || $5a6742a4b36362a4$var$initialized) return;
    $5a6742a4b36362a4$var$initialized = true;
    document.addEventListener('MC_EXT_GET_SESSION', ()=>{
        $5a6742a4b36362a4$var$readAndAnnounce();
    });
    // Cykliczne odświeżanie trzyma token żywym, gdy apka jest długo otwarta —
    // applySession w App.jsx deduplikuje, więc identyczna sesja nic nie kosztuje.
    setInterval($5a6742a4b36362a4$var$readAndAnnounce, 240000);
}
async function $5a6742a4b36362a4$export$2f67b24ad905835c(lang, hint) {
    const plugin = $5a6742a4b36362a4$var$mcPlugin();
    if (!plugin) return null;
    const mcLang = lang === 'de' ? 'de-de' : 'pl-pl';
    try {
        const { cookies: cookies } = await plugin.connect({
            lang: mcLang,
            hint: hint || ''
        });
        $5a6742a4b36362a4$var$lastRefreshAt = Date.now();
        const session = $5a6742a4b36362a4$var$parseCookieString(cookies);
        if (session) $5a6742a4b36362a4$var$announceSession(session);
        return session;
    } catch  {
        return null;
    }
}




var $acw62 = parcelRequire("acw62");
const $45edc04dea201a66$export$150b732325d14d04 = {
    pl: {
        // === GLOBAL ===
        loading: "\u0141adowanie...",
        cancel: 'Anuluj',
        save: 'Zapisz',
        close: 'Zamknij',
        send: "Wy\u015Blij",
        delete: "Usu\u0144",
        edit: 'Edytuj',
        back: "Wr\xf3\u0107",
        // === AUTH — Login ===
        'login.title': 'Logowanie',
        'login.username': 'Email',
        'login.password': "Has\u0142o",
        'login.submit': 'Zaloguj',
        'login.no_account': 'Nie masz konta?',
        'login.register_link': "Zarejestruj si\u0119",
        'login.forgot': "Zapomnia\u0142em has\u0142a",
        'login.success': 'Zalogowano!',
        'login.error': "Nieprawid\u0142owe dane logowania",
        // === AUTH — Register ===
        'register.title': 'Rejestracja',
        'register.name': "Imi\u0119 i nazwisko",
        'register.email': 'Email',
        'register.password': "Has\u0142o",
        'register.confirm_password': "Potwierd\u017A has\u0142o",
        'register.submit': 'Zarejestruj',
        'register.has_account': "Masz ju\u017C konto?",
        'register.login_link': "Zaloguj si\u0119",
        'register.success': "Rejestracja udana! Mo\u017Cesz si\u0119 zalogowa\u0107.",
        'register.error': "Rejestracja nie powiod\u0142a si\u0119.",
        'register.passwords_mismatch': "Has\u0142a nie s\u0105 identyczne",
        // === AUTH — Reset password ===
        'reset.title': "Reset has\u0142a",
        'reset.intro': "Podaj adres email powi\u0105zany z Twoim kontem. Wy\u015Blemy na niego 6-cyfrowy kod.",
        'reset.email_label': 'Adres email',
        'reset.email_placeholder': 'twoj@email.pl',
        'reset.sending': "Wysy\u0142am...",
        'reset.send_code': "Wy\u015Blij kod",
        'reset.code_sent': "Kod wys\u0142any na",
        'reset.code_label': 'Kod z emaila (6 cyfr)',
        'reset.new_password': "Nowe has\u0142o",
        'reset.confirm_password': "Potwierd\u017A nowe has\u0142o",
        'reset.confirm_placeholder': "powt\xf3rz has\u0142o",
        'reset.min_chars': "min. 6 znak\xf3w",
        'reset.changing': 'Zmieniam...',
        'reset.change': "Zmie\u0144 has\u0142o",
        'reset.resend': "Wy\u015Blij kod ponownie",
        'reset.success': "Has\u0142o zmienione \u2014 jeste\u015B zalogowany!",
        'reset.passwords_mismatch': "Has\u0142a nie s\u0105 identyczne",
        'reset.too_short': "Has\u0142o musi mie\u0107 co najmniej 6 znak\xf3w",
        'reset.error_email': "B\u0142\u0105d wysy\u0142ania emaila",
        'reset.error_code': "B\u0142\u0105d weryfikacji kodu",
        // === HEADER ===
        'header.help': "Jak zacz\u0105\u0107?",
        'header.admin': 'Admin',
        'header.login': 'Zaloguj',
        'header.register': 'Zarejestruj',
        'header.logout_success': 'Wylogowano!',
        // === Konto ===
        'account.title': 'Moje konto',
        'account.username': "Nazwa u\u017Cytkownika",
        'account.email': 'Email',
        'account.logout': 'Wyloguj',
        'account.danger_title': 'Strefa niebezpieczna',
        'account.delete_desc': "Trwale usu\u0144 konto wraz ze wszystkimi zapisanymi przepisami. Tej operacji nie mo\u017Cna cofn\u0105\u0107.",
        'account.delete_btn': "Usu\u0144 konto",
        'account.delete_warn': "Tej operacji nie mo\u017Cna cofn\u0105\u0107. Wszystkie Twoje dane i zapisane przepisy zostan\u0105 trwale usuni\u0119te.",
        'account.delete_password_label': "Potwierd\u017A has\u0142em",
        'account.delete_confirm_btn': "Usu\u0144 konto na zawsze",
        'account.deleting': 'Usuwanie...',
        'account.deleted': "Twoje konto zosta\u0142o usuni\u0119te.",
        'account.delete_error': "Nie uda\u0142o si\u0119 usun\u0105\u0107 konta.",
        // === HERO ===
        'hero.title': "Konwerter przepis\xf3w Monsieur Cuisine",
        'hero.sub': "Wklej sw\xf3j przepis, a AI przekonwertuje go na format MC Smart \u2014 z temperaturami, czasami i pr\u0119dko\u015Bciami. Gotowy przepis wy\u015Blesz jednym klikni\u0119ciem na swoje konto.",
        'hero.feat1': "Wklej w\u0142asny przepis",
        'hero.feat2': 'AI skonwertuje na MC',
        'hero.feat3': "Wy\u015Blij na konto MC",
        'hero.cta_login': "Zaloguj si\u0119 i zacznij",
        'hero.cta_help': "Jak to dzia\u0142a?",
        // === FOOTER ===
        'footer.tagline': "Konwerter przepis\xf3w Monsieur Cuisine Smart",
        'footer.help': 'Pomoc',
        'footer.contact': 'Kontakt',
        'footer.privacy': "Polityka prywatno\u015Bci",
        'footer.security': "Bezpiecze\u0144stwo:",
        'footer.security_text': "Przepisy generowane s\u0105 przez AI. Zawsze sprawd\u017A parametry przed uruchomieniem na urz\u0105dzeniu. Autor nie ponosi odpowiedzialno\u015Bci za ewentualne szkody.",
        'footer.affiliate': 'Affiliate disclaimer:',
        'footer.affiliate_text': "Aplikacja zawiera linki partnerskie wspieraj\u0105ce rozw\xf3j projektu.",
        'footer.rights': "Wszelkie prawa zastrze\u017Cone.",
        // === CONTACT MODAL ===
        'contact.tab_contact': 'Kontakt',
        'contact.tab_bug': "Zg\u0142o\u015B b\u0142\u0105d",
        'contact.intro_bug': "Znalaz\u0142e\u015B b\u0142\u0105d? Opisz go poni\u017Cej.",
        'contact.intro_contact': "Masz pytanie lub sugesti\u0119? Napisz do nas.",
        'contact.topic': 'Temat',
        'contact.email': "Tw\xf3j e-mail",
        'contact.email_optional': '(opcjonalnie)',
        'contact.message': "Wiadomo\u015B\u0107",
        'contact.send': "Wy\u015Blij",
        'contact.sent_title': "Wiadomo\u015B\u0107 wys\u0142ana!",
        'contact.sent_text': "Odezwiemy si\u0119 wkr\xf3tce.",
        'contact.bug_topic': "Zg\u0142oszenie b\u0142\u0119du",
        'contact.generic_topic': "Wiadomo\u015B\u0107",
        // === RECIPE CONVERTER ===
        'conv.title': "Konwerter przepis\xf3w Monsieur Cuisine",
        'conv.title_short': 'Konwerter',
        'conv.sub': "Wklej sw\xf3j przepis \u2014 AI przekonwertuje go na format MC Smart",
        'conv.mc_connected': "Po\u0142\u0105czono z Monsieur Cuisine",
        'conv.mc_locale_title': "Wersja j\u0119zykowa konta MC (gdzie maj\u0105 trafia\u0107 przepisy)",
        'conv.mc_connected_mobile': "Konto MC po\u0142\u0105czone",
        'conv.mobile_no_session': "Konwerter dzia\u0142a na telefonie. Wysy\u0142anie przepis\xf3w na MC dost\u0119pne tylko na komputerze z rozszerzeniem Chrome.",
        'conv.mobile_hint': "Na telefonie: skonwertuj przepis, skopiuj jako Tekst i wklej r\u0119cznie w aplikacji MC \u2014 lub u\u017Cyj komputera \u017Ceby wys\u0142a\u0107 jednym klikni\u0119ciem.",
        'conv.install_ext': "Aby wysy\u0142a\u0107 przepisy na konto MC \u2014 zainstaluj rozszerzenie",
        'conv.url_label': 'Masz link do swojego przepisu? Zaimportuj go z adresu URL',
        'conv.url_placeholder': 'np. https://...',
        'conv.url_btn': 'Importuj',
        'conv.url_loading': 'Pobieram...',
        'conv.url_error': "Nie uda\u0142o si\u0119 zaimportowa\u0107 przepisu z tego adresu",
        'conv.url_ok': "Przepis zaimportowany \u2014 sprawd\u017A tekst poni\u017Cej i kliknij Konwertuj",
        'conv.image_label': "Masz przepis na zdj\u0119ciu lub screenshocie? Wczytaj go",
        'conv.image_btn': "Wgraj zdj\u0119cie / screenshot",
        'conv.image_loading': "Odczytuj\u0119 tekst...",
        'conv.image_hint': "Mo\u017Cesz te\u017C wklei\u0107 zrzut ekranu (Ctrl+V) w pole poni\u017Cej.",
        'conv.image_ok': "Tekst odczytany \u2014 sprawd\u017A go poni\u017Cej i kliknij Konwertuj",
        'conv.image_err': "Nie uda\u0142o si\u0119 odczyta\u0107 tekstu ze zdj\u0119cia",
        'conv.dish_btn': "Dodaj zdj\u0119cie potrawy",
        'conv.dish_loading': "Wysy\u0142am zdj\u0119cie...",
        'conv.dish_ok': "Zdj\u0119cie gotowe \u2014 trafi na MC razem z przepisem",
        'conv.dish_remove': "Usu\u0144",
        'conv.dish_hint': "Opcjonalnie. Zdj\u0119cie b\u0119dzie miniatur\u0105 przepisu na Twoim koncie MC.",
        'conv.dish_err': "Nie uda\u0142o si\u0119 wys\u0142a\u0107 zdj\u0119cia \u2014 przepis wy\u015Blemy bez miniatury",
        'conv.bg_waiting': "Wysy\u0142am na MC \u2014 mo\u017Cesz zamkn\u0105\u0107 stron\u0119, dam zna\u0107 po powrocie:",
        'conv.bg_done': 'Gotowe na MC:',
        'conv.paste_label': 'Wklej przepis w dowolnej formie',
        'conv.paste_placeholder': `Wklej sw\xf3j przepis lub napisz go w\u{142}asnymi s\u{142}owami...

np.
'Pomidorowa z bazyli\u{105}
1 cebula, 2 z\u{105}bki czosnku, 500g pomidor\xf3w z puszki, 500ml bulionu
Cebul\u{119} i czosnek zeszkli\u{107} na oliwie. Doda\u{107} pomidory, bulion, gotowa\u{107} 20 min. Zmiksowa\u{107}. Doda\u{107} bazyli\u{119}.'`,
        'conv.limit_exhausted': 'Limit wyczerpany',
        'conv.limit_renews': "odnowi si\u0119",
        'conv.limit_usage': "konwersji w tym miesi\u0105cu",
        'conv.limit_left': "pozosta\u0142o",
        'conv.converting': "Konwertuj\u0119...",
        'conv.convert_btn': 'Konwertuj na format MC',
        'conv.reset': 'Zacznij od nowa',
        'conv.warning': "Zawsze sprawd\u017A przepis przed u\u017Cyciem na urz\u0105dzeniu.",
        'conv.error_empty': "Wklej przepis przed konwersj\u0105.",
        'conv.error_conv': "B\u0142\u0105d konwersji",
        'conv.error_net': "B\u0142\u0105d sieci",
        'conv.error_ext': 'Brak potwierdzenia z rozszerzenia \u2014 przepis m\xf3g\u0142 mimo to trafi\u0107 na MC. Sprawd\u017A \u201EMoje przepisy" na monsieur-cuisine.com, zanim wy\u015Blesz ponownie.',
        'conv.error_send': "B\u0142\u0105d wysy\u0142ania do MC.",
        'conv.checking_mc': "Rozszerzenie przekroczy\u0142o czas, ale MC bywa wolne \u2014 sprawdzam, czy przepis mimo to powsta\u0142. Nie zamykaj strony.",
        'conv.checking_srv': "Wysy\u0142ka trwa \u2014 serwery Monsieur Cuisine tworz\u0105 przepis ok. 2 minut. Pilnujemy tego za Ciebie: mo\u017Cesz zamkn\u0105\u0107 stron\u0119, link b\u0119dzie czeka\u0142 po powrocie.",
        'conv.checking_mc_btn': "Sprawdzam MC\u2026",
        'conv.recovered': "Wys\u0142ano! Rozszerzenie zg\u0142osi\u0142o przekroczenie czasu, ale przepis jest na Twoim koncie MC.",
        'conv.error_no_mc_session': "Konto MC niepo\u0142\u0105czone. Zaloguj si\u0119 na monsieur-cuisine.com na komputerze z zainstalowanym rozszerzeniem Chrome.",
        'conv.error_save': "B\u0142\u0105d zapisywania",
        'conv.error_load': "B\u0142\u0105d wczytywania przepisu",
        'conv.saved_mc': 'Przepis zapisany na koncie MC!',
        'conv.sent_excl': "Wys\u0142ano!",
        'conv.open_mc': "Otw\xf3rz przepis na MC",
        'conv.save': 'Zapisz przepis',
        'conv.save_ok': "Przepis zapisany w przepi\u015Bniku!",
        'conv.repair_hint': 'Opcjonalnie: zaznacz krok z b\u0142\u0119dem (checkbox), opisz problem i kliknij "Popraw przepis". Kroki z ikon\u0105 \u2696\uFE0F to wa\u017Cenie na wadze MC \u2014 nie maj\u0105 parametr\xf3w maszyny.',
        'conv.repair_placeholder': 'Opisz co jest nie tak. Np. "W kroku 4 brakuje pr\u0119dko\u015Bci i czasu" lub "Krok 3 powinien by\u0107 miksowaniem na pr\u0119d. 5 przez 30s"',
        'conv.repair_btn': 'Popraw przepis',
        'conv.repairing': 'Poprawiam...',
        'conv.repair_ok': 'Przepis poprawiony!',
        'conv.repair_answer_placeholder': "Twoja odpowied\u017A...",
        'conv.repair_send': 'Odpowiedz',
        'conv.repair_cancel': 'Anuluj',
        'conv.repair_save_ask': "Zapisa\u0107 poprawion\u0105 wersj\u0119?",
        'conv.repair_save_yes': "Tak, zapisz (zast\u0105p poprzedni\u0105)",
        'conv.repair_save_no': "Nie, pomi\u0144",
        'conv.step_weigh': "Wa\u017Cenie MC",
        'conv.step_manual': "R\u0119cznie",
        'conv.empty_hint1': 'Wklej przepis i kliknij',
        'conv.empty_hint2': '\u201EKonwertuj na format MC"',
        'conv.empty_hint3': "AI dostosuje przepis do urz\u0105dzenia MC Smart \u2014 doda temperatury, czasy i pr\u0119dko\u015Bci.",
        'conv.empty_mc_note': "Aby wysy\u0142a\u0107 przepisy na konto MC, zainstaluj rozszerzenie Chrome i zaloguj si\u0119 na monsieur-cuisine.com.",
        'conv.mc_connect_note': "Aby wysy\u0142a\u0107 przepisy na konto MC, po\u0142\u0105cz aplikacj\u0119 ze swoim kontem Monsieur Cuisine.",
        'conv.mc_connect_btn': "Po\u0142\u0105cz z Monsieur Cuisine",
        'conv.mc_connect_hint': "Zaloguj si\u0119 na swoje konto Monsieur Cuisine \u2014 aplikacja po\u0142\u0105czy si\u0119 automatycznie.",
        'conv.mobile_no_session@app': "Konto MC niepo\u0142\u0105czone \u2014 u\u017Cyj przycisku \u201EPo\u0142\u0105cz z Monsieur Cuisine\u201D, aby wysy\u0142a\u0107 przepisy prosto z aplikacji.",
        'conv.image_hint@app': "Mo\u017Cesz te\u017C zrobi\u0107 zdj\u0119cie przepisu aparatem \u2014 rozpoznany tekst trafi do pola poni\u017Cej.",
        'conv.error_ext@app': "Brak potwierdzenia wysy\u0142ki \u2014 przepis m\xf3g\u0142 mimo to trafi\u0107 na MC. Sprawd\u017A \u201EMoje przepisy\u201D na monsieur-cuisine.com, zanim wy\u015Blesz ponownie.",
        'conv.error_no_mc_session@app': "Konto MC niepo\u0142\u0105czone. Kliknij \u201EPo\u0142\u0105cz z Monsieur Cuisine\u201D w konwerterze i zaloguj si\u0119 na swoje konto.",
        'help.start.s3.desc_a@app': "Po\u0142\u0105cz konto Monsieur Cuisine (zak\u0142adka",
        'help.start.s3.desc_tab@app': "Po\u0142\u0105czenie z MC",
        'help.start.s3.desc_b@app': '), a potem kliknij',
        'help.start.alert@app': "Konto MC \u0142\u0105czysz bezpo\u015Brednio w aplikacji \u2014 zobacz zak\u0142adk\u0119 \u201EPo\u0142\u0105czenie z MC\u201D. Bez rozszerze\u0144 i bez komputera.",
        'help.conv.l1@app': "Skopiuj ca\u0142y tekst swojego przepisu",
        'help.conv.l2@app': "Wklej go w pole konwertera \u2014 albo zr\xf3b zdj\u0119cie przepisu aparatem",
        'help.conv.h4@app': "Zapis i wysy\u0142ka",
        'help.conv.share.l2_b@app': "\u2014 po\u0142\u0105cz konto w zak\u0142adce \u201EPo\u0142\u0105czenie z MC\u201D",
        'help.conv.share.l3@app': "Po\u0142\u0105czenie robisz raz \u2014 potem wysy\u0142asz przepisy jednym klikni\u0119ciem",
        'help.prob.h1@app': "Problemy z po\u0142\u0105czeniem MC",
        'help.prob.p3.l1@app': "Kliknij \u201EPo\u0142\u0105cz z Monsieur Cuisine\u201D w konwerterze i zaloguj si\u0119 ponownie",
        'help.prob.p3.l2@app': "Wysy\u0142ka b\u0119dzie zn\xf3w aktywna \u2014 aplikacja od\u015Bwie\u017Ca sesj\u0119 w tle",
        'help.prob.p9.q@app': "Mog\u0119 konwertowa\u0107 przepisy bez konta MC?",
        'help.prob.p9.desc@app': "Konto MateMeal jest wymagane do konwersji. Do wysy\u0142ania przepis\xf3w po\u0142\u0105cz konto Monsieur Cuisine w aplikacji (zak\u0142adka \u201EPo\u0142\u0105czenie z MC\u201D).",
        'conv.image_camera': "Zr\xf3b zdj\u0119cie",
        'help.tab.app': "Po\u0142\u0105czenie z MC",
        'help.app.lead': "W aplikacji nie potrzebujesz rozszerzenia Chrome \u2014 konto Monsieur Cuisine \u0142\u0105czysz bezpo\u015Brednio w apce.",
        'help.app.alert': "Po\u0142\u0105czenie robisz tylko raz. Aplikacja sama od\u015Bwie\u017Ca sesj\u0119 w tle.",
        'help.app.h1': "Jak po\u0142\u0105czy\u0107 konto MC",
        'help.app.s1.title': "Zaloguj si\u0119 do Matemeal",
        'help.app.s1.desc': "U\u017Cyj swojego zwyk\u0142ego konta Matemeal \u2014 tego samego co na stronie.",
        'help.app.s2.title': "Kliknij \u201EPo\u0142\u0105cz z Monsieur Cuisine\u201D",
        'help.app.s2.desc': "Przycisk znajdziesz w konwerterze. Otworzy si\u0119 okno logowania Monsieur Cuisine (konto Lidl).",
        'help.app.s3.title': "Zaloguj si\u0119 na konto MC",
        'help.app.s3.desc': "Po udanym logowaniu okno zamknie si\u0119 samo i wysy\u0142ka przepis\xf3w b\u0119dzie aktywna.",
        'help.app.note': "Wysy\u0142ka przepisu na konto MC trwa zwykle oko\u0142o 2 minut \u2014 w tym czasie mo\u017Cesz normalnie korzysta\u0107 z aplikacji.",
        'help.app.sec.l1': "Dane logowania Lidl wpisujesz wy\u0142\u0105cznie na stronie Monsieur Cuisine \u2014 aplikacja ich nie widzi i nie zapisuje.",
        'help.app.sec.l2': "Aplikacja przechowuje tylko sesj\u0119 (ciasteczka), dok\u0142adnie tak jak przegl\u0105darka.",
        'help.app.sec.l3': "Konto MC mo\u017Cesz od\u0142\u0105czy\u0107 w ka\u017Cdej chwili, wylogowuj\u0105c si\u0119 ze strony Monsieur Cuisine.",
        'conv.safety': "Sprawd\u017A parametry przed wys\u0142aniem. Autor nie ponosi odpowiedzialno\u015Bci za dzia\u0142anie przepisu na urz\u0105dzeniu.",
        'conv.recipe_default': 'Przepis MC',
        'conv.difficulty_hard': 'Trudny',
        'conv.difficulty_medium': "\u015Aredni",
        'conv.difficulty_easy': "\u0141atwy",
        'conv.save_changes': 'Zapisz zmiany',
        'conv.editing': 'Edytujesz przepis',
        'conv.unsaved': 'niezapisane zmiany',
        'conv.edit': 'Edytuj',
        'conv.send_mc': "Wy\u015Blij na MC",
        'conv.sending_mc': "Wysy\u0142anie\u2026",
        'conv.sent_mc': "Wys\u0142ano na MC",
        'conv.servings': 'porcje',
        'conv.steps_count': "krok\xf3w",
        'conv.ingredients': "Sk\u0142adniki",
        'conv.add': '+ Dodaj',
        'conv.steps_title': 'Kroki Monsieur Cuisine',
        'conv.step_title_ph': "Tytu\u0142 kroku",
        'conv.step_desc_ph': 'Opis kroku',
        'conv.temp': 'Temp',
        'conv.speed': "Pr\u0119d.",
        'conv.time': 'Czas',
        'conv.fix_selected': 'Popraw zaznaczone',
        'conv.fixing': 'Poprawiam...',
        'conv.fix_placeholder': "Co jest nie tak? (opcjonalnie) np. brak pieczenia, z\u0142a temperatura...",
        'conv.fix_selected_label': 'Zaznaczono',
        'conv.fix_step': 'krok',
        'conv.fix_steps_few': 'kroki',
        'conv.fix_steps_many': "krok\xf3w",
        'conv.fix_to_fix': 'do poprawy',
        'conv.nutrients': "Warto\u015Bci od\u017Cywcze (na porcj\u0119)",
        'conv.protein': "Bia\u0142ko",
        'conv.carbs': "W\u0119gl.",
        'conv.fat': "T\u0142uszcz",
        'conv.tips': "Wskaz\xf3wki:",
        'conv.ing_name_ph': 'Nazwa',
        'conv.ing_qty_ph': "Ilo\u015B\u0107",
        // === SAVED RECIPES ===
        'saved.title': 'Zapisane przepisy',
        'saved.title_short': 'Zapisane',
        'saved.preview': "Podgl\u0105d",
        'saved.load': 'Wczytaj',
        'saved.load_to_conv': 'Wczytaj do konwertera',
        'saved.open_mc': "Otw\xf3rz na MC",
        'saved.no_data': "Nie mo\u017Cna wczyta\u0107 danych przepisu.",
        // === EXTENSION MODAL ===
        'ext.title': 'Instalacja rozszerzenia Chrome',
        'ext.step1': 'Kliknij \u201EDodaj do Chrome" poni\u017Cej i zatwierd\u017A instalacj\u0119',
        'ext.step2': "Zaloguj si\u0119 na monsieur-cuisine.com w przegl\u0105darce Chrome",
        'ext.step3': "Wr\xf3\u0107 do MateMeal i od\u015Bwie\u017C stron\u0119 \u2014 pojawi si\u0119 zielony status po\u0142\u0105czenia",
        'ext.security': "Rozszerzenie pobiera wy\u0142\u0105cznie ciasteczka sesji MC niezb\u0119dne do komunikacji z API. \u017Badne dane nie s\u0105 przesy\u0142ane poza Twoj\u0105 przegl\u0105dark\u0119.",
        'ext.banner_text': "Zainstaluj Matemeal Connector \u2014 wysy\u0142aj przepisy jednym klikni\u0119ciem na konto Monsieur Cuisine.",
        'ext.banner_cta': 'Dodaj do Chrome',
        // === COOKIE BANNER ===
        'cookie.text': "Ta aplikacja u\u017Cywa lokalnego przechowywania ciasteczek sesji Monsieur Cuisine wy\u0142\u0105cznie w celu wysy\u0142ania przepis\xf3w na Twoje konto MC. \u017Badne dane nie s\u0105 udost\u0119pniane podmiotom trzecim.",
        'cookie.accept': 'Rozumiem',
        'copyright.text': "Konwertuj wy\u0142\u0105cznie przepisy w\u0142asne lub takie, z kt\xf3rych korzystasz w ramach dozwolonego u\u017Cytku osobistego (dyrektywa 2001/29/WE i prawo krajowe). MateMeal nie zach\u0119ca do kopiowania ani rozpowszechniania przepis\xf3w os\xf3b trzecich \u2014 za tre\u015Bci, kt\xf3re wysy\u0142asz, odpowiadasz samodzielnie.",
        'copyright.accept': 'Rozumiem',
        // === HELP GUIDE ===
        'help.title': "Jak u\u017Cywa\u0107 MateMeal?",
        'help.tab.start': "Jak zacz\u0105\u0107?",
        'help.tab.extension': 'Rozszerzenie Chrome',
        'help.tab.convert': "Konwersja przepis\xf3w",
        'help.tab.problems': 'Problemy?',
        'help.start.lead': "MateMeal przekszta\u0142ca dowolny przepis na format Monsieur Cuisine Smart \u2014 z temperaturami, pr\u0119dko\u015Bciami i czasami. Mo\u017Cesz wys\u0142a\u0107 gotowy przepis jednym klikni\u0119ciem na swoje konto MC.",
        'help.start.h1': 'Trzy kroki do pierwszego przepisu',
        'help.start.s1.title': "Utw\xf3rz konto i zaloguj si\u0119",
        'help.start.s1.desc_a': 'Kliknij',
        'help.start.s1.desc_strong': 'Zarejestruj',
        'help.start.s1.desc_b': "w prawym g\xf3rnym rogu. Konto jest potrzebne do zapisywania przepis\xf3w i synchronizacji z MC.",
        'help.start.s2.title': 'Wklej przepis i kliknij \u201EKonwertuj na format MC"',
        'help.start.s2.desc': "Wklej w\u0142asny przepis albo napisz go w\u0142asnymi s\u0142owami. AI doda wszystkie parametry maszyny.",
        'help.start.s3.title': "Wy\u015Blij przepis na swoje konto Monsieur Cuisine",
        'help.start.s3.desc_a': "Zainstaluj rozszerzenie Chrome (zak\u0142adka",
        'help.start.s3.desc_tab': 'Rozszerzenie Chrome',
        'help.start.s3.desc_b': "), zaloguj si\u0119 na monsieur-cuisine.com i kliknij",
        'help.start.s3.desc_strong': "Wy\u015Blij na MC",
        'help.start.alert': "Rozszerzenie Chrome jest potrzebne do po\u0142\u0105czenia z kontem MC i wysy\u0142ania przepis\xf3w na urz\u0105dzenie. Dzia\u0142a tylko na komputerze.",
        'help.start.h2': "Co mo\u017Cesz wkleja\u0107?",
        'help.start.l1': "W\u0142asne przepisy zapisane w dowolnej formie",
        'help.start.l2': 'Rodzinne przepisy z zeszytu (przepisane)',
        'help.start.l3': "Inne przepisy wy\u0142\u0105cznie w ramach dozwolonego u\u017Cytku osobistego",
        'help.start.l4': "W\u0142asny opis przepisu napisany w swoim j\u0119zyku",
        'help.start.l5': "Sk\u0142adniki i kroki opisane dowolnie \u2014 AI sam rozezna struktur\u0119",
        'help.ext.lead': "Rozszerzenie Chrome \u0142\u0105czy MateMeal z Twoim kontem Monsieur Cuisine. Po instalacji przepisy wysy\u0142aj\u0105 si\u0119 jednym klikni\u0119ciem \u2014 bez kopiowania i wklejania.",
        'help.ext.alert': "Rozszerzenie Matemeal Connector jest dost\u0119pne w Chrome Web Store. Zainstaluj je jednym klikni\u0119ciem \u2014 \u017Caden tryb programisty nie jest wymagany.",
        'help.ext.mobile.title': 'Korzystasz z telefonu?',
        'help.ext.mobile.desc_a': 'Chrome na Androidzie i iOS',
        'help.ext.mobile.desc_strong': "nie obs\u0142uguje rozszerze\u0144",
        'help.ext.mobile.desc_b': "\u2014 na telefonie mo\u017Cesz:",
        'help.ext.mobile.l1_a': "Konwertowa\u0107 przepisy",
        'help.ext.mobile.l1_strong': 'na MC Smart',
        'help.ext.mobile.l1_b': " i zapisywa\u0107 je w swoim profilu",
        'help.ext.mobile.l2': "Wysy\u0142anie przepis\xf3w na konto MC dost\u0119pne tylko na komputerze z rozszerzeniem Chrome",
        'help.ext.h1': 'Instalacja krok po kroku',
        'help.ext.s1.title': "Znajd\u017A folder rozszerzenia",
        'help.ext.s1.desc': "W katalogu aplikacji MateMeal znajd\u017A folder:",
        'help.ext.s2.title': 'Zainstaluj Matemeal Connector z Chrome Web Store',
        'help.ext.s2.desc_a': "Kliknij link poni\u017Cej i zatwierd\u017A instalacj\u0119:",
        'help.ext.s2.desc_b': "i naci\u015Bnij Enter.",
        'help.ext.s3.title': "W\u0142\u0105cz tryb programisty",
        'help.ext.s3.desc_a': "W prawym g\xf3rnym rogu strony chrome://extensions w\u0142\u0105cz prze\u0142\u0105cznik",
        'help.ext.s3.desc_strong': 'Tryb programisty',
        'help.ext.s3.desc_b': '(Developer mode).',
        'help.ext.s4.title': "Za\u0142aduj rozpakowane rozszerzenie",
        'help.ext.s4.desc_a': 'Kliknij przycisk',
        'help.ext.s4.desc_strong': "Za\u0142aduj rozpakowane",
        'help.ext.s4.desc_b': "(Load unpacked) i wska\u017C folder",
        'help.ext.s4.desc_c': ". Rozszerzenie pojawi si\u0119 na li\u015Bcie jako MC Recipe Converter.",
        'help.ext.s5.title': "Zaloguj si\u0119 na Monsieur Cuisine",
        'help.ext.s5.desc': "Otw\xf3rz monsieur-cuisine.com w nowej karcie i zaloguj si\u0119 na swoje konto. To wystarczy \u2014 rozszerzenie automatycznie wykryje sesj\u0119.",
        'help.ext.s6.title': "Wr\xf3\u0107 do MateMeal i od\u015Bwie\u017C stron\u0119",
        'help.ext.s6.desc_a': "Naci\u015Bnij",
        'help.ext.s6.desc_b': "na stronie MateMeal. W konwerterze powinien pojawi\u0107 si\u0119 zielony komunikat",
        'help.ext.s6.desc_c': '\u201EPo\u0142\u0105czono z Monsieur Cuisine".',
        'help.ext.ok_alert': "Gotowe! Przy ka\u017Cdym uruchomieniu przegl\u0105darki rozszerzenie automatycznie synchronizuje sesj\u0119 \u2014 nie musisz nic powtarza\u0107.",
        'help.ext.security.title': "Bezpiecze\u0144stwo",
        'help.ext.security.l1': "Rozszerzenie odczytuje wy\u0142\u0105cznie ciasteczka sesji monsieur-cuisine.com",
        'help.ext.security.l2': "\u017Badne dane nie s\u0105 wysy\u0142ane do zewn\u0119trznych serwer\xf3w poza MC i MateMeal",
        'help.ext.security.l3': "Has\u0142o do MC nigdy nie jest odczytywane ani przechowywane",
        'help.conv.lead': "AI analizuje przepis i t\u0142umaczy ka\u017Cdy krok na operacje Monsieur Cuisine Smart: wa\u017Cenie sk\u0142adnik\xf3w, rozdrabnianie, podgrzewanie, gotowanie, blendowanie.",
        'help.conv.h1': "Jak wklei\u0107 przepis?",
        'help.conv.l1': "Zaznacz ca\u0142y tekst swojego przepisu i skopiuj (Ctrl+C)",
        'help.conv.l2': 'Wklej (Ctrl+V) w pole tekstowe konwertera',
        'help.conv.l3_a': 'Kliknij',
        'help.conv.l3_strong': 'Konwertuj na format MC',
        'help.conv.h2': 'Co AI robi z przepisem?',
        'help.conv.card1.title': "Wa\u017Cenie",
        'help.conv.card1.desc': "Ka\u017Cdy sk\u0142adnik trafia do oddzielnego kroku wa\u017Cenia na wadze MC",
        'help.conv.card2.title': 'Temperatury',
        'help.conv.card2.desc': "AI dobiera temperatur\u0119 do rodzaju operacji (sma\u017Cenie, gotowanie, topienie)",
        'help.conv.card3.title': "Pr\u0119dko\u015Bci",
        'help.conv.card3.desc': "Pr\u0119dko\u015B\u0107 miksowania zale\u017Cy od konsystencji: siekanie 7-8, mieszanie 2-3",
        'help.conv.card4.title': 'Czasy',
        'help.conv.card4.desc': 'Czasy gotowania, miksowania i podgrzewania dobrane do typu potrawy',
        'help.conv.h3': 'Edycja i poprawianie',
        'help.conv.edit.l1_a': 'Kliknij',
        'help.conv.edit.l1_strong': 'Edytuj',
        'help.conv.edit.l1_b': "aby zmieni\u0107 tytu\u0142, sk\u0142adniki lub opisy krok\xf3w",
        'help.conv.edit.l2_a': "Zaznacz b\u0142\u0119dne kroki (checkbox przy ka\u017Cdym kroku) i kliknij",
        'help.conv.edit.l2_strong': 'Popraw zaznaczone',
        'help.conv.edit.l2_b': "\u2014 AI wygeneruje je od nowa",
        'help.conv.edit.l3': "W trybie edycji mo\u017Cesz zmienia\u0107 kolejno\u015B\u0107 krok\xf3w strza\u0142kami \u2191\u2193",
        'help.conv.h4': "Co zrobi\u0107 bez rozszerzenia?",
        'help.conv.share.l1_a': "Przepis mo\u017Cesz",
        'help.conv.share.l1_strong': "zapisa\u0107 w koncie MateMeal",
        'help.conv.share.l1_b': "\u2014 kliknij ikon\u0119 zak\u0142adki obok przepisu",
        'help.conv.share.l2_a': 'Aby',
        'help.conv.share.l2_strong': "wys\u0142a\u0107 przepis na urz\u0105dzenie MC",
        'help.conv.share.l2_b': "\u2014 zainstaluj rozszerzenie Chrome (zak\u0142adka Rozszerzenie Chrome)",
        'help.conv.share.l3': "Rozszerzenie jest bezp\u0142atne i instaluje si\u0119 jednym klikni\u0119ciem z Chrome Web Store",
        'help.conv.alert': "Zawsze sprawd\u017A wygenerowany przepis przed u\u017Cyciem na urz\u0105dzeniu. AI stara si\u0119 dobra\u0107 realistyczne parametry, ale przepis mo\u017Ce wymaga\u0107 drobnych korekt.",
        'help.prob.lead': "Najcz\u0119stsze problemy i jak je rozwi\u0105za\u0107.",
        'help.prob.h1': 'Problemy z rozszerzeniem',
        'help.prob.p1.q': '"Brak potwierdzenia z rozszerzenia"',
        'help.prob.p1.desc': "Rozszerzenie nie odes\u0142a\u0142o wyniku na czas \u2014 albo serwer MC odpowiada\u0142 wolno (przepis m\xf3g\u0142 si\u0119 mimo to utworzy\u0107), albo kontekst rozszerzenia wygas\u0142 po jego aktualizacji lub prze\u0142adowaniu.",
        'help.prob.p1.l1': 'Najpierw sprawd\u017A \u201EMoje przepisy" na monsieur-cuisine.com \u2014 przepis bywa wys\u0142any mimo komunikatu',
        'help.prob.p1.l2': "Je\u015Bli go tam nie ma \u2014 naci\u015Bnij F5 i wy\u015Blij ponownie",
        'help.prob.p1.l3_a': "Je\u015Bli problem wraca \u2014 przejd\u017A do",
        'help.prob.p1.l3_b': ", kliknij \u21BB (od\u015Bwie\u017C) przy rozszerzeniu Matemeal Connector, a nast\u0119pnie od\u015Bwie\u017C stron\u0119",
        'help.prob.p2.q': '"Po\u0142\u0105czono z MC" nie pojawia si\u0119 po instalacji rozszerzenia',
        'help.prob.p2.l1_a': "Upewnij si\u0119, \u017Ce jeste\u015B zalogowany na",
        'help.prob.p2.l1_b': "w tej samej przegl\u0105darce",
        'help.prob.p2.l2': "Od\u015Bwie\u017C stron\u0119 MateMeal (F5)",
        'help.prob.p2.l3': "Je\u015Bli nadal brak \u2014 przejd\u017A do MC, wyloguj si\u0119 i zaloguj ponownie, potem wr\xf3\u0107 do MateMeal i od\u015Bwie\u017C",
        'help.prob.p3.q': '"Token MC wygas\u0142 \u2014 zaloguj si\u0119 ponownie"',
        'help.prob.p3.desc': "Sesja Monsieur Cuisine wygas\u0142a (zazwyczaj po kilku dniach nieaktywno\u015Bci).",
        'help.prob.p3.l1': "Otw\xf3rz monsieur-cuisine.com i zaloguj si\u0119 ponownie",
        'help.prob.p3.l2': "Wr\xf3\u0107 do MateMeal i od\u015Bwie\u017C stron\u0119 (F5)",
        'help.prob.p4.q': "Jak przeinstalowa\u0107 rozszerzenie?",
        'help.prob.p4.l1_a': "Otw\xf3rz",
        'help.prob.p4.l1_strong': 'chrome://extensions',
        'help.prob.p4.l1_b': "i znajd\u017A Matemeal Connector na li\u015Bcie",
        'help.prob.p4.l2_a': 'Kliknij',
        'help.prob.p4.l2_strong': "Usu\u0144",
        'help.prob.p4.l2_b': "\u2014 rozszerzenie zostanie odinstalowane",
        'help.prob.p4.l3': "Zainstaluj ponownie z Chrome Web Store i zaloguj si\u0119 na monsieur-cuisine.com",
        'help.prob.h2': "Problemy z konwersj\u0105 AI",
        'help.prob.p5.q': '"B\u0142\u0105d konwersji AI" / "Model przekroczy\u0142 limit token\xf3w"',
        'help.prob.p5.desc': "Przepis jest zbyt d\u0142ugi lub z\u0142o\u017Cony dla modelu AI.",
        'help.prob.p5.l1': "Spr\xf3buj skr\xf3ci\u0107 przepis \u2014 usu\u0144 zb\u0119dne wst\u0119py i komentarze autora",
        'help.prob.p5.l2': "Podziel przepis na dwie cz\u0119\u015Bci i konwertuj ka\u017Cd\u0105 cz\u0119\u015B\u0107 osobno",
        'help.prob.p5.l3': "Spr\xf3buj ponownie za chwil\u0119 \u2014 mo\u017Ce to tymczasowe przeci\u0105\u017Cenie API",
        'help.prob.p6.q': "Wygenerowany przepis ma b\u0142\u0119dne kroki lub parametry",
        'help.prob.p6.l1': "Zaznacz b\u0142\u0119dne kroki (checkbox przy ka\u017Cdym kroku)",
        'help.prob.p6.l2': 'Opcjonalnie wpisz co jest nie tak w polu notatki',
        'help.prob.p6.l3_a': 'Kliknij',
        'help.prob.p6.l3_strong': 'Popraw zaznaczone',
        'help.prob.p6.l3_b': "\u2014 AI wygeneruje te kroki od nowa",
        'help.prob.p6.l4_a': "Je\u015Bli efekt nadal nie jest dobry \u2014 u\u017Cyj trybu",
        'help.prob.p6.l4_strong': 'Edytuj',
        'help.prob.p6.l4_b': "i popraw r\u0119cznie",
        'help.prob.p7.q': "Sk\u0142adniki s\u0105 niepoprawnie po\u0142\u0105czone lub brakuje krok\xf3w wa\u017Cenia",
        'help.prob.p7.desc': "AI czasem \u0142\u0105czy kilka sk\u0142adnik\xf3w w jeden krok. W MC ka\u017Cdy sk\u0142adnik powinien by\u0107 wa\u017Cony osobno.",
        'help.prob.p7.l1': 'Zaznacz problematyczne kroki i kliknij Popraw zaznaczone',
        'help.prob.p7.l2': 'W notatce napisz np. \u201Erozdziel sk\u0142adniki na oddzielne kroki wa\u017Cenia"',
        'help.prob.h3': 'Inne',
        'help.prob.p8.q': "Przepis zosta\u0142 wys\u0142any, ale nie widz\u0119 go na koncie MC",
        'help.prob.p8.l1': "Sprawd\u017A sekcj\u0119 Moje przepisy na monsieur-cuisine.com",
        'help.prob.p8.l2': "Od\u015Bwie\u017C stron\u0119 MC",
        'help.prob.p8.l3': "Je\u015Bli wysy\u0142ka zako\u0144czy\u0142a si\u0119 sukcesem (zielony komunikat + link), przepis jest na koncie \u2014 mo\u017Ce trzeba chwil\u0119 poczeka\u0107",
        'help.prob.p9.q': "Mog\u0119 konwertowa\u0107 przepisy bez konta / bez rozszerzenia?",
        'help.prob.p9.desc': "Konto jest wymagane do konwersji. Rozszerzenie Chrome jest potrzebne do po\u0142\u0105czenia konta MC i wysy\u0142ania przepis\xf3w \u2014 dzia\u0142a tylko na komputerze. Na telefonie mo\u017Cesz konwertowa\u0107 i zapisywa\u0107 przepisy w profilu.",
        'help.prob.contact': "Nie znalaz\u0142e\u015B rozwi\u0105zania?",
        'contact.form.title': 'Napisz do nas',
        'contact.form.subject': 'Temat',
        'contact.form.subject.bug': "Zg\u0142oszenie b\u0142\u0119du",
        'contact.form.subject.help': 'Pomoc',
        'contact.form.subject.other': 'Inne',
        'contact.form.message': "Wiadomo\u015B\u0107",
        'contact.form.reply_email': "Tw\xf3j e-mail (opcjonalnie, do odpowiedzi)",
        'contact.form.send': "Wy\u015Blij",
        'contact.form.sending': "Wysy\u0142anie\u2026",
        'contact.form.success': "Wiadomo\u015B\u0107 wys\u0142ana! Odezwiemy si\u0119 wkr\xf3tce.",
        'contact.form.error': "B\u0142\u0105d wysy\u0142ania. Spr\xf3buj ponownie za chwil\u0119.",
        'contact.form.error_short': "B\u0142\u0105d wysy\u0142ania. Spr\xf3buj ponownie.",
        'contact.form.rate_limit': "Zbyt wiele wiadomo\u015Bci. Spr\xf3buj za godzin\u0119.",
        // === CONVERTING MESSAGES ===
        converting_msgs: [
            'AI przeczyta\u0142 \u201Ei sma\u017Cy\u0107 a\u017C gotowe" i przez chwil\u0119 d\u0142ugo milcza\u0142.',
            'T\u0142umacz\u0119 \u201Ena oko" na liczby. AI patrzy sceptycznie.',
            'Szukam definicji \u201Etroch\u0119 ciep\u0142ej wody". Baza danych milczy.',
            'Przeliczam \u201Eszklank\u0119" \u2014 t\u0119 ze zlewu czy t\u0119 od babci do herbaty?',
            "AI w\u0142a\u015Bnie odkry\u0142, \u017Ce polskie przepisy to bardziej sugestia ni\u017C instrukcja.",
            'Interpretuj\u0119 \u201Edo smaku" jako warto\u015B\u0107 domy\u015Bln\u0105. AI kiwa g\u0142ow\u0105 niepewnie.',
            'Negocjuj\u0119 temperatur\u0119. Przepis m\xf3wi \u201Egor\u0105cy piekarnik". Definicja do ustalenia.',
            'Licz\u0119 ile to jest \u201Espora gar\u015B\u0107". Mam ma\u0142e r\u0119ce, przeliczam z marginesem.',
            'Sprawdzam, czy w przepisie nie ma ukrytego kroku \u201Ewyczuj intuicj\u0105".',
            "AI pyta ile to jest \u0142y\u017Cka. Odpowied\u017A zale\u017Cy od kucharza i jego nastroju.",
            'Ucz\u0119 AI, \u017Ce \u201Epodsma\u017Cy\u0107 chwil\u0119" to mo\u017Ce by\u0107 2 minuty albo 20 \u2014 jak si\u0119 trafi.',
            "Robot kuchenny i AI ustalaj\u0105, czyja wina, je\u015Bli co\u015B nie wyjdzie.",
            'Przeliczam szczypty. Przy \u201Eszczypta po szczycie" AI troch\u0119 si\u0119 pogubi\u0142.',
            'Sprawdzam czy w przepisie nie napisano \u201Edodaj ile trzeba". Napisano.',
            "AI sko\u0144czy\u0142 analiz\u0119 i teraz przekonuje si\u0119 do polskiej kuchni. Idzie mu.",
            'T\u0142umacz\u0119 przepis z zeszytu babci, gdzie co drugie s\u0142owo to \u201Ewiadomo jak".',
            'Szukam sensu w zdaniu \u201Emiesza\u0107 a\u017C si\u0119 po\u0142\u0105czy". \u0141\u0105czy\u0107 z czym dok\u0142adnie?',
            'Sprawdzam \u201Edu\u017Ce jajka" \u2014 nie ma definicji, bior\u0119 \u015Bredni\u0105 statystyczn\u0105.',
            'AI w\u0142a\u015Bnie przeczyta\u0142 krok \u201Ewyczu\u0107 odpowiedni moment". Trwa przetwarzanie.',
            'Przekonuj\u0119 maszyn\u0119, \u017Ce \u201Ea\u017C si\u0119 zrumieni" to nie jest komunikat o b\u0142\u0119dzie.',
            "Sprawdzam pojemno\u015B\u0107 miski. Optymista z przepisu powiedzia\u0142, \u017Ce si\u0119 zmie\u015Bci.",
            'T\u0142umacz\u0119 \u201Edu\u017Co mi\u0142o\u015Bci" \u2014 AI zaproponowa\u0142 150 ml. Brzmi rozs\u0105dnie.',
            'AI natrafi\u0142 na krok \u201Edoprowadzi\u0107 do wrzenia" i pyta od kt\xf3rej strony zacz\u0105\u0107.',
            'Szukam granicy mi\u0119dzy \u201Elekko podsma\u017C" a \u201Eprzypal na wi\xf3r". Cienka linia.',
            'Krok \u201Eodstawi\u0107 do ostygni\u0119cia" \u2014 AI wpisa\u0142 4 godziny. Nikt nie protestuje.',
            'Przepis m\xf3wi \u201E\u015Bwie\u017Ce sk\u0142adniki". AI otworzy\u0142 Wikipedi\u0119 i przeczyta\u0142 wszystko o chlorofilu.',
            'Analizuj\u0119 \u201Egar\u015B\u0107 pietruszki". Przez chwil\u0119 AI my\u015Bla\u0142, \u017Ce to jednostka miary.',
            'AI pr\xf3buje oceni\u0107 czy \u201Ekremowa konsystencja" to 80% czy 85% g\u0142adko\u015Bci.',
            'Krok \u201Eugotowa\u0107 al dente" \u2014 AI w\u0142a\u015Bnie uczy\u0142 si\u0119 w\u0142oskiego. Dos\u0142ownie.',
            'Napotykam \u201Edopraw sol\u0105 i pieprzem" \u2014 AI pyta ile to jest pieprzu. Dobre pytanie.',
            'Sprawdzam czy \u201Epatelnia rozgrzana do dymu" to norma czy wypadek.',
            'AI w\u0142a\u015Bnie przeliczy\u0142 3 \u0142y\u017Cki oliwy. Wynik: 45 ml. Przepis m\xf3wi\u0142 \u201Etroch\u0119".',
            'T\u0142umacz\u0119 \u201Elekko ubij" \u2014 AI zaproponowa\u0142 dok\u0142adnie 37 uderze\u0144. Precyzja wzorowa.',
            "Robot kuchenny czeka. AI pisze instrukcj\u0119. Kto\u015B musi zacz\u0105\u0107.",
            'Analiza sk\u0142adnika \u201Ewoda" \u2014 AI sprawdza czy mineralna, kranowa, czy deszczowa.'
        ]
    },
    // ============================================================
    // ENGLISH
    // ============================================================
    en: {
        loading: 'Loading...',
        cancel: 'Cancel',
        save: 'Save',
        close: 'Close',
        send: 'Send',
        delete: 'Delete',
        edit: 'Edit',
        back: 'Back',
        'login.title': 'Sign In',
        'login.username': 'Email',
        'login.password': 'Password',
        'login.submit': 'Sign In',
        'login.no_account': "Don't have an account?",
        'login.register_link': 'Sign up',
        'login.forgot': 'Forgot password',
        'login.success': 'Signed in!',
        'login.error': 'Invalid credentials',
        'register.title': 'Create Account',
        'register.name': 'Full name',
        'register.email': 'Email',
        'register.password': 'Password',
        'register.confirm_password': 'Confirm password',
        'register.submit': 'Sign up',
        'register.has_account': 'Already have an account?',
        'register.login_link': 'Sign in',
        'register.success': 'Registration successful! You can now sign in.',
        'register.error': 'Registration failed.',
        'register.passwords_mismatch': 'Passwords do not match',
        'reset.title': 'Reset Password',
        'reset.intro': 'Enter the email address linked to your account. We will send a 6-digit code.',
        'reset.email_label': 'Email address',
        'reset.email_placeholder': 'your@email.com',
        'reset.sending': 'Sending...',
        'reset.send_code': 'Send code',
        'reset.code_sent': 'Code sent to',
        'reset.code_label': 'Code from email (6 digits)',
        'reset.new_password': 'New password',
        'reset.confirm_password': 'Confirm new password',
        'reset.confirm_placeholder': 'repeat password',
        'reset.min_chars': 'min. 6 characters',
        'reset.changing': 'Changing...',
        'reset.change': 'Change password',
        'reset.resend': 'Resend code',
        'reset.success': "Password changed \u2014 you are now signed in!",
        'reset.passwords_mismatch': 'Passwords do not match',
        'reset.too_short': 'Password must be at least 6 characters',
        'reset.error_email': 'Error sending email',
        'reset.error_code': 'Code verification failed',
        'header.help': 'How to start?',
        'header.admin': 'Admin',
        'header.login': 'Sign In',
        'header.register': 'Sign Up',
        'header.logout_success': 'Signed out!',
        // === Account ===
        'account.title': 'My account',
        'account.username': 'Username',
        'account.email': 'Email',
        'account.logout': 'Sign out',
        'account.danger_title': 'Danger zone',
        'account.delete_desc': 'Permanently delete your account along with all saved recipes. This action cannot be undone.',
        'account.delete_btn': 'Delete account',
        'account.delete_warn': 'This action cannot be undone. All your data and saved recipes will be permanently deleted.',
        'account.delete_password_label': 'Confirm with password',
        'account.delete_confirm_btn': 'Delete account permanently',
        'account.deleting': 'Deleting...',
        'account.deleted': 'Your account has been deleted.',
        'account.delete_error': 'Failed to delete account.',
        'hero.title': 'Monsieur Cuisine Recipe Converter',
        'hero.sub': "Paste your own recipe and AI will convert it to MC Smart format \u2014 with temperatures, times and speeds. Send it to your MC account with one click.",
        'hero.feat1': 'Paste your own recipe',
        'hero.feat2': 'AI converts to MC',
        'hero.feat3': 'Send to MC account',
        'hero.cta_login': 'Sign in and start',
        'hero.cta_help': 'How does it work?',
        'footer.tagline': 'Monsieur Cuisine Smart Recipe Converter',
        'footer.help': 'Help',
        'footer.contact': 'Contact',
        'footer.privacy': 'Privacy Policy',
        'footer.security': 'Safety:',
        'footer.security_text': 'Recipes are AI-generated. Always verify parameters before using on your device. The author bears no liability for any resulting damage.',
        'footer.affiliate': 'Affiliate disclaimer:',
        'footer.affiliate_text': 'This app contains affiliate links that support project development.',
        'footer.rights': 'All rights reserved.',
        'contact.tab_contact': 'Contact',
        'contact.tab_bug': 'Report a bug',
        'contact.intro_bug': 'Found a bug? Describe it below.',
        'contact.intro_contact': 'Have a question or suggestion? Write to us.',
        'contact.topic': 'Subject',
        'contact.email': 'Your e-mail',
        'contact.email_optional': '(optional)',
        'contact.message': 'Message',
        'contact.send': 'Send',
        'contact.sent_title': 'Message sent!',
        'contact.sent_text': 'We will get back to you soon.',
        'contact.bug_topic': 'Bug report',
        'contact.generic_topic': 'Message',
        'conv.title': 'Monsieur Cuisine Recipe Converter',
        'conv.title_short': 'Converter',
        'conv.sub': "Paste your recipe \u2014 AI will convert it to MC Smart format",
        'conv.mc_connected': 'Connected to Monsieur Cuisine',
        'conv.mc_locale_title': 'MC account language (where recipes should be sent)',
        'conv.mc_connected_mobile': 'MC account connected',
        'conv.mobile_no_session': 'Converter works on mobile. Sending recipes to MC is available only on desktop with the Chrome extension.',
        'conv.mobile_hint': "On mobile: convert the recipe, copy as Text and paste manually in the MC app \u2014 or use a computer to send with one click.",
        'conv.install_ext': "To send recipes to your MC account \u2014 install the extension",
        'conv.url_label': 'Got a link to your own recipe? Import it from a URL',
        'conv.url_placeholder': 'e.g. https://...',
        'conv.url_btn': 'Import',
        'conv.url_loading': 'Fetching...',
        'conv.url_error': 'Could not import a recipe from this address',
        'conv.url_ok': "Recipe imported \u2014 review the text below and click Convert",
        'conv.image_label': 'Got the recipe as a photo or screenshot? Read it in',
        'conv.image_btn': 'Upload photo / screenshot',
        'conv.image_loading': 'Reading text...',
        'conv.image_hint': 'You can also paste a screenshot (Ctrl+V) into the field below.',
        'conv.image_ok': "Text extracted \u2014 review it below and click Convert",
        'conv.image_err': 'Could not read text from the image',
        'conv.dish_btn': 'Add dish photo',
        'conv.dish_loading': 'Uploading photo...',
        'conv.dish_ok': "Photo ready \u2014 it will go to MC with the recipe",
        'conv.dish_remove': 'Remove',
        'conv.dish_hint': 'Optional. The photo becomes the recipe thumbnail on your MC account.',
        'conv.dish_err': "Could not upload the photo \u2014 the recipe will be sent without a thumbnail",
        'conv.bg_waiting': "Sending to MC \u2014 you can close this page, I will report back:",
        'conv.bg_done': 'Ready on MC:',
        'conv.paste_label': 'Paste your recipe in any form',
        'conv.paste_placeholder': `Paste your recipe or write it in your own words...

e.g.
'Tomato soup with basil
1 onion, 2 garlic cloves, 500g canned tomatoes, 500ml broth
Saut\xe9 onion and garlic in olive oil. Add tomatoes, broth, cook 20 min. Blend. Add basil.'`,
        'conv.limit_exhausted': 'Limit reached',
        'conv.limit_renews': 'renews',
        'conv.limit_usage': 'conversions this month',
        'conv.limit_left': 'remaining',
        'conv.converting': 'Converting...',
        'conv.convert_btn': 'Convert to MC format',
        'conv.reset': 'Start over',
        'conv.warning': 'Always verify the recipe before using on your device.',
        'conv.error_empty': 'Please paste a recipe before converting.',
        'conv.error_conv': 'Conversion error',
        'conv.error_net': 'Network error',
        'conv.error_ext': 'No confirmation from the extension \u2014 the recipe may still have reached MC. Check "My recipes" on monsieur-cuisine.com before sending again.',
        'conv.error_send': 'Error sending to MC.',
        'conv.checking_mc': "The extension timed out, but MC can be slow \u2014 checking whether the recipe was created anyway. Please keep this page open.",
        'conv.checking_srv': "Sending in progress \u2014 Monsieur Cuisine servers take about 2 minutes to create a recipe. We are watching it for you: you can close this page, the link will be waiting when you return.",
        'conv.checking_mc_btn': "Checking MC\u2026",
        'conv.recovered': 'Sent! The extension reported a timeout, but the recipe is on your MC account.',
        'conv.error_no_mc_session': 'MC account not connected. Sign in on monsieur-cuisine.com on a computer with the Chrome extension installed.',
        'conv.error_save': 'Error saving',
        'conv.error_load': 'Error loading recipe',
        'conv.saved_mc': 'Recipe saved to MC account!',
        'conv.sent_excl': 'Sent!',
        'conv.open_mc': 'Open recipe on MC',
        'conv.save': 'Save recipe',
        'conv.save_ok': 'Recipe saved to your cookbook!',
        'conv.repair_hint': 'Optional: check a step with an error, describe the issue and click "Fix recipe". Steps with \u2696\uFE0F are MC scale steps \u2014 they have no machine parameters.',
        'conv.repair_placeholder': 'Describe what is wrong. E.g. "Step 4 is missing speed and time" or "Step 3 should be mixing at speed 5 for 30s"',
        'conv.repair_btn': 'Fix recipe',
        'conv.repairing': 'Fixing...',
        'conv.repair_ok': 'Recipe fixed!',
        'conv.repair_answer_placeholder': 'Your answer...',
        'conv.repair_send': 'Send',
        'conv.repair_cancel': 'Cancel',
        'conv.repair_save_ask': 'Save the repaired version?',
        'conv.repair_save_yes': 'Yes, save (replace previous)',
        'conv.repair_save_no': 'No, skip',
        'conv.step_weigh': 'MC Scale',
        'conv.step_manual': 'Manual',
        'conv.empty_hint1': 'Paste a recipe and click',
        'conv.empty_hint2': '"Convert to MC format"',
        'conv.empty_hint3': "AI will adapt the recipe for the MC Smart device \u2014 adding temperatures, times and speeds.",
        'conv.empty_mc_note': 'To send recipes to your MC account, install the Chrome extension and sign in on monsieur-cuisine.com.',
        'conv.mc_connect_note': 'To send recipes to your MC account, connect the app to your Monsieur Cuisine account.',
        'conv.mc_connect_btn': 'Connect to Monsieur Cuisine',
        'conv.mc_connect_hint': "Sign in to your Monsieur Cuisine account \u2014 the app will connect automatically.",
        'conv.mobile_no_session@app': "MC account not connected \u2014 use the \u201CConnect to Monsieur Cuisine\u201D button to send recipes straight from the app.",
        'conv.image_hint@app': "You can also take a photo of a recipe with your camera \u2014 the recognized text will appear in the field below.",
        'conv.error_ext@app': "No sending confirmation \u2014 the recipe may still have reached MC. Check \u201CMy recipes\u201D on monsieur-cuisine.com before sending again.",
        'conv.error_no_mc_session@app': "MC account not connected. Tap \u201CConnect to Monsieur Cuisine\u201D in the converter and sign in to your account.",
        'help.start.s3.desc_a@app': 'Connect your Monsieur Cuisine account (see the',
        'help.start.s3.desc_tab@app': 'MC connection',
        'help.start.s3.desc_b@app': ' tab), then tap',
        'help.start.alert@app': "You connect your MC account directly in the app \u2014 see the \u201CMC connection\u201D tab. No extensions, no computer needed.",
        'help.conv.l1@app': 'Copy the full text of your recipe',
        'help.conv.l2@app': "Paste it into the converter field \u2014 or take a photo of the recipe with your camera",
        'help.conv.h4@app': 'Saving and sending',
        'help.conv.share.l2_b@app': "\u2014 connect your account in the \u201CMC connection\u201D tab",
        'help.conv.share.l3@app': "You connect once \u2014 then you send recipes with a single tap",
        'help.prob.h1@app': 'MC connection issues',
        'help.prob.p3.l1@app': "Tap \u201CConnect to Monsieur Cuisine\u201D in the converter and sign in again",
        'help.prob.p3.l2@app': "Sending will be active again \u2014 the app refreshes the session in the background",
        'help.prob.p9.q@app': 'Can I convert recipes without an MC account?',
        'help.prob.p9.desc@app': "A MateMeal account is required for conversion. To send recipes, connect your Monsieur Cuisine account in the app (see the \u201CMC connection\u201D tab).",
        'conv.image_camera': 'Take a photo',
        'help.tab.app': 'MC connection',
        'help.app.lead': "In the app you don't need the Chrome extension \u2014 you connect your Monsieur Cuisine account directly in the app.",
        'help.app.alert': 'You connect only once. The app refreshes the session in the background.',
        'help.app.h1': 'How to connect your MC account',
        'help.app.s1.title': 'Sign in to Matemeal',
        'help.app.s1.desc': "Use your regular Matemeal account \u2014 the same one as on the website.",
        'help.app.s2.title': "Tap \u201CConnect to Monsieur Cuisine\u201D",
        'help.app.s2.desc': 'You\'ll find the button in the converter. A Monsieur Cuisine (Lidl account) sign-in window will open.',
        'help.app.s3.title': 'Sign in to your MC account',
        'help.app.s3.desc': 'After a successful sign-in the window closes automatically and recipe sending becomes active.',
        'help.app.note': "Sending a recipe to your MC account usually takes about 2 minutes \u2014 you can keep using the app in the meantime.",
        'help.app.sec.l1': "You enter your Lidl credentials only on the Monsieur Cuisine website \u2014 the app never sees or stores them.",
        'help.app.sec.l2': 'The app stores only the session (cookies), exactly like a browser.',
        'help.app.sec.l3': 'You can disconnect your MC account at any time by signing out of the Monsieur Cuisine website.',
        'conv.safety': 'Verify parameters before sending. The author bears no liability for recipe performance on the device.',
        'conv.recipe_default': 'MC Recipe',
        'conv.difficulty_hard': 'Hard',
        'conv.difficulty_medium': 'Medium',
        'conv.difficulty_easy': 'Easy',
        'conv.save_changes': 'Save changes',
        'conv.editing': 'Editing recipe',
        'conv.unsaved': 'unsaved changes',
        'conv.edit': 'Edit',
        'conv.send_mc': 'Send to MC',
        'conv.sending_mc': "Sending\u2026",
        'conv.sent_mc': 'Sent to MC',
        'conv.servings': 'servings',
        'conv.steps_count': 'steps',
        'conv.ingredients': 'Ingredients',
        'conv.add': '+ Add',
        'conv.steps_title': 'Monsieur Cuisine Steps',
        'conv.step_title_ph': 'Step title',
        'conv.step_desc_ph': 'Step description',
        'conv.temp': 'Temp',
        'conv.speed': 'Speed',
        'conv.time': 'Time',
        'conv.fix_selected': 'Fix selected',
        'conv.fixing': 'Fixing...',
        'conv.fix_placeholder': "What's wrong? (optional) e.g. missing baking step, wrong temperature...",
        'conv.fix_selected_label': 'Selected',
        'conv.fix_step': 'step',
        'conv.fix_steps_few': 'steps',
        'conv.fix_steps_many': 'steps',
        'conv.fix_to_fix': 'to fix',
        'conv.nutrients': 'Nutrition (per serving)',
        'conv.protein': 'Protein',
        'conv.carbs': 'Carbs',
        'conv.fat': 'Fat',
        'conv.tips': 'Tips:',
        'conv.ing_name_ph': 'Name',
        'conv.ing_qty_ph': 'Amount',
        'saved.title': 'Saved recipes',
        'saved.title_short': 'Saved',
        'saved.preview': 'Preview',
        'saved.load': 'Load',
        'saved.load_to_conv': 'Load into converter',
        'saved.open_mc': 'Open on MC',
        'saved.no_data': 'Cannot load recipe data.',
        'ext.title': 'Chrome Extension Installation',
        'ext.step1': 'Click "Add to Chrome" below and confirm the installation',
        'ext.step2': 'Sign in on monsieur-cuisine.com in Chrome',
        'ext.step3': "Return to MateMeal and refresh the page \u2014 a green connection status will appear",
        'ext.security': 'The extension only retrieves MC session cookies needed for API communication. No data is sent outside your browser.',
        'ext.banner_text': "Install Matemeal Connector \u2014 send recipes to your Monsieur Cuisine account with one click.",
        'ext.banner_cta': 'Add to Chrome',
        'cookie.text': 'This app uses local storage of Monsieur Cuisine session cookies solely to send recipes to your MC account. No data is shared with third parties.',
        'cookie.accept': 'Got it',
        'copyright.text': "Convert only your own recipes or those you use within permitted private personal use (Directive 2001/29/EC and national law). MateMeal does not encourage copying or distributing third-party recipes \u2014 you are solely responsible for the content you submit.",
        'copyright.accept': 'Got it',
        'help.title': 'How to use MateMeal?',
        'help.tab.start': 'Getting started',
        'help.tab.extension': 'Chrome Extension',
        'help.tab.convert': 'Recipe conversion',
        'help.tab.problems': 'Problems?',
        'help.start.lead': "MateMeal transforms any recipe into Monsieur Cuisine Smart format \u2014 with temperatures, speeds and times. You can send the finished recipe to your MC account with one click.",
        'help.start.h1': 'Three steps to your first recipe',
        'help.start.s1.title': 'Create an account and sign in',
        'help.start.s1.desc_a': 'Click',
        'help.start.s1.desc_strong': 'Sign up',
        'help.start.s1.desc_b': 'in the top right corner. An account is required to save recipes and sync with MC.',
        'help.start.s2.title': 'Paste a recipe and click "Convert to MC format"',
        'help.start.s2.desc': "Paste your own recipe \u2014 or write it in your own words. AI will add all machine parameters.",
        'help.start.s3.title': 'Send the recipe to your Monsieur Cuisine account',
        'help.start.s3.desc_a': 'Install the Chrome extension (tab',
        'help.start.s3.desc_tab': 'Chrome Extension',
        'help.start.s3.desc_b': '), sign in on monsieur-cuisine.com and click',
        'help.start.s3.desc_strong': 'Send to MC',
        'help.start.alert': 'The Chrome extension is needed to connect your MC account and send recipes to your device. Works on desktop only.',
        'help.start.h2': 'What can you paste?',
        'help.start.l1': 'Your own recipes in any form',
        'help.start.l2': 'Family recipes from your notebook (typed out)',
        'help.start.l3': 'Other recipes only within permitted private personal use',
        'help.start.l4': 'Your own recipe description written in your language',
        'help.start.l5': "Ingredients and steps described freely \u2014 AI will figure out the structure",
        'help.ext.lead': "The Chrome extension connects MateMeal to your Monsieur Cuisine account. After installation, recipes are sent with one click \u2014 no copying and pasting.",
        'help.ext.alert': "Matemeal Connector is available in the Chrome Web Store. Install it with one click \u2014 no developer mode required.",
        'help.ext.mobile.title': 'Using a phone?',
        'help.ext.mobile.desc_a': 'Chrome on Android and iOS',
        'help.ext.mobile.desc_strong': 'does not support extensions',
        'help.ext.mobile.desc_b': "\u2014 on mobile you can:",
        'help.ext.mobile.l1_a': 'Convert recipes',
        'help.ext.mobile.l1_strong': 'to MC Smart',
        'help.ext.mobile.l1_b': ' and save them to your profile',
        'help.ext.mobile.l2': 'Sending recipes to MC account is available only on desktop with the Chrome extension',
        'help.ext.h1': 'Step-by-step installation',
        'help.ext.s1.title': 'Find the extension folder',
        'help.ext.s1.desc': 'In the MateMeal app directory, find the folder:',
        'help.ext.s2.title': 'Install Matemeal Connector from Chrome Web Store',
        'help.ext.s2.desc_a': 'Click the link below and confirm the installation:',
        'help.ext.s2.desc_b': 'and press Enter.',
        'help.ext.s3.title': 'Enable Developer mode',
        'help.ext.s3.desc_a': 'In the top right corner of chrome://extensions, enable the',
        'help.ext.s3.desc_strong': 'Developer mode',
        'help.ext.s3.desc_b': 'toggle.',
        'help.ext.s4.title': 'Load the unpacked extension',
        'help.ext.s4.desc_a': 'Click',
        'help.ext.s4.desc_strong': 'Load unpacked',
        'help.ext.s4.desc_b': 'and point to the',
        'help.ext.s4.desc_c': 'folder. The extension will appear as MC Recipe Converter.',
        'help.ext.s5.title': 'Sign in to Monsieur Cuisine',
        'help.ext.s5.desc': "Open monsieur-cuisine.com in a new tab and sign in to your account. That is enough \u2014 the extension will automatically detect the session.",
        'help.ext.s6.title': 'Return to MateMeal and refresh',
        'help.ext.s6.desc_a': 'Press',
        'help.ext.s6.desc_b': 'on the MateMeal page. The converter should show a green message',
        'help.ext.s6.desc_c': '"Connected to Monsieur Cuisine".',
        'help.ext.ok_alert': "Done! Each time you launch the browser, the extension automatically syncs the session \u2014 no need to repeat anything.",
        'help.ext.security.title': 'Security',
        'help.ext.security.l1': 'The extension reads only monsieur-cuisine.com session cookies',
        'help.ext.security.l2': 'No data is sent to external servers other than MC and MateMeal',
        'help.ext.security.l3': 'Your MC password is never read or stored',
        'help.conv.lead': 'AI analyses the recipe and translates each step into Monsieur Cuisine Smart operations: weighing ingredients, chopping, heating, cooking, blending.',
        'help.conv.h1': 'How to paste a recipe?',
        'help.conv.l1': 'Select the entire text of your own recipe and copy (Ctrl+C)',
        'help.conv.l2': 'Paste (Ctrl+V) into the converter text field',
        'help.conv.l3_a': 'Click',
        'help.conv.l3_strong': 'Convert to MC format',
        'help.conv.h2': 'What does AI do with the recipe?',
        'help.conv.card1.title': 'Weighing',
        'help.conv.card1.desc': 'Each ingredient gets a separate weighing step on the MC scale',
        'help.conv.card2.title': 'Temperatures',
        'help.conv.card2.desc': 'AI selects temperature based on operation type (frying, boiling, melting)',
        'help.conv.card3.title': 'Speeds',
        'help.conv.card3.desc': 'Mixing speed depends on consistency: chopping 7-8, stirring 2-3',
        'help.conv.card4.title': 'Times',
        'help.conv.card4.desc': 'Cooking, mixing and heating times matched to the dish type',
        'help.conv.h3': 'Editing and fixing',
        'help.conv.edit.l1_a': 'Click',
        'help.conv.edit.l1_strong': 'Edit',
        'help.conv.edit.l1_b': 'to change the title, ingredients or step descriptions',
        'help.conv.edit.l2_a': 'Check faulty steps (checkbox next to each step) and click',
        'help.conv.edit.l2_strong': 'Fix selected',
        'help.conv.edit.l2_b': "\u2014 AI will regenerate them",
        'help.conv.edit.l3': "In edit mode you can reorder steps using the \u2191\u2193 arrows",
        'help.conv.h4': 'What to do without the extension?',
        'help.conv.share.l1_a': 'You can',
        'help.conv.share.l1_strong': 'save the recipe to your MateMeal account',
        'help.conv.share.l1_b': "\u2014 click the bookmark icon next to the recipe",
        'help.conv.share.l2_a': 'To',
        'help.conv.share.l2_strong': 'send the recipe to your MC device',
        'help.conv.share.l2_b': "\u2014 install the Chrome extension (Extension tab)",
        'help.conv.share.l3': 'The extension is free and installs with one click from the Chrome Web Store',
        'help.conv.alert': 'Always verify the generated recipe before using on your device. AI tries to choose realistic parameters, but the recipe may need minor adjustments.',
        'help.prob.lead': 'Common problems and how to fix them.',
        'help.prob.h1': 'Extension problems',
        'help.prob.p1.q': '"No confirmation from the extension"',
        'help.prob.p1.desc': "The extension did not return a result in time \u2014 either the MC server was slow (the recipe may have been created anyway), or the extension context expired after an update or reload.",
        'help.prob.p1.l1': 'First check "My recipes" on monsieur-cuisine.com \u2014 the recipe is sometimes sent despite the message',
        'help.prob.p1.l2': "If it is not there \u2014 press F5 and send again",
        'help.prob.p1.l3_a': "If the problem persists \u2014 go to",
        'help.prob.p1.l3_b': ", click \u21BB (reload) next to Matemeal Connector, then refresh the page",
        'help.prob.p2.q': '"Connected to MC" does not appear after installing the extension',
        'help.prob.p2.l1_a': 'Make sure you are signed in to',
        'help.prob.p2.l1_b': 'in the same browser',
        'help.prob.p2.l2': 'Refresh the MateMeal page (F5)',
        'help.prob.p2.l3': "If still missing \u2014 go to MC, sign out and sign in again, then return to MateMeal and refresh",
        'help.prob.p3.q': '"MC token expired \u2014 please sign in again"',
        'help.prob.p3.desc': 'The Monsieur Cuisine session expired (usually after a few days of inactivity).',
        'help.prob.p3.l1': 'Open monsieur-cuisine.com and sign in again',
        'help.prob.p3.l2': 'Return to MateMeal and refresh the page (F5)',
        'help.prob.p4.q': 'How do I reinstall the extension?',
        'help.prob.p4.l1_a': 'Open',
        'help.prob.p4.l1_strong': 'chrome://extensions',
        'help.prob.p4.l1_b': 'and find Matemeal Connector on the list',
        'help.prob.p4.l2_a': 'Click',
        'help.prob.p4.l2_strong': 'Remove',
        'help.prob.p4.l2_b': "\u2014 the extension will be uninstalled",
        'help.prob.p4.l3': 'Reinstall from the Chrome Web Store and sign in on monsieur-cuisine.com',
        'help.prob.h2': 'AI conversion problems',
        'help.prob.p5.q': '"AI conversion error" / "Model exceeded token limit"',
        'help.prob.p5.desc': 'The recipe is too long or complex for the AI model.',
        'help.prob.p5.l1': "Try shortening the recipe \u2014 remove unnecessary introductions and author comments",
        'help.prob.p5.l2': 'Split the recipe into two parts and convert each separately',
        'help.prob.p5.l3': "Try again in a moment \u2014 it may be a temporary API overload",
        'help.prob.p6.q': 'The generated recipe has wrong steps or parameters',
        'help.prob.p6.l1': 'Check the faulty steps (checkbox next to each step)',
        'help.prob.p6.l2': 'Optionally type what is wrong in the notes field',
        'help.prob.p6.l3_a': 'Click',
        'help.prob.p6.l3_strong': 'Fix selected',
        'help.prob.p6.l3_b': "\u2014 AI will regenerate those steps",
        'help.prob.p6.l4_a': "If still not good \u2014 use",
        'help.prob.p6.l4_strong': 'Edit',
        'help.prob.p6.l4_b': 'mode and fix manually',
        'help.prob.p7.q': 'Ingredients are incorrectly merged or weighing steps are missing',
        'help.prob.p7.desc': 'AI sometimes merges several ingredients into one step. In MC each ingredient should be weighed separately.',
        'help.prob.p7.l1': 'Check the problematic steps and click Fix selected',
        'help.prob.p7.l2': 'In the note write e.g. "split ingredients into separate weighing steps"',
        'help.prob.h3': 'Other',
        'help.prob.p8.q': 'Recipe was sent but I cannot see it on my MC account',
        'help.prob.p8.l1': 'Check the My Recipes section on monsieur-cuisine.com',
        'help.prob.p8.l2': 'Refresh the MC page',
        'help.prob.p8.l3': "If the send succeeded (green message + link), the recipe is on the account \u2014 it may need a moment to sync",
        'help.prob.p9.q': 'Can I convert recipes without an account / without the extension?',
        'help.prob.p9.desc': "An account is required for conversion. The Chrome extension is needed to connect your MC account and send recipes \u2014 desktop only. On mobile you can convert and save recipes to your profile.",
        'help.prob.contact': 'Did not find a solution?',
        'contact.form.title': 'Contact us',
        'contact.form.subject': 'Subject',
        'contact.form.subject.bug': 'Bug report',
        'contact.form.subject.help': 'Help',
        'contact.form.subject.other': 'Other',
        'contact.form.message': 'Message',
        'contact.form.reply_email': 'Your email (optional, for reply)',
        'contact.form.send': 'Send',
        'contact.form.sending': "Sending\u2026",
        'contact.form.success': 'Message sent! We will get back to you soon.',
        'contact.form.error': 'Send error. Please try again in a moment.',
        'contact.form.error_short': 'Send error. Please try again.',
        'contact.form.rate_limit': 'Too many messages. Try again in an hour.',
        converting_msgs: [
            'AI read "fry until done" and went quiet for a very long time.',
            'Translating "by eye" into numbers. AI looks skeptical.',
            'Looking up the definition of "a bit of warm water". Database is silent.',
            'Converting "a cup" \u2014 the measuring cup or grandma\'s teacup?',
            'AI just discovered that recipes are more of a suggestion than instructions.',
            'Interpreting "to taste" as a default value. AI nods uncertainly.',
            'Negotiating temperature. Recipe says "hot oven". Definition pending.',
            'Counting how much "a generous handful" is. I have small hands, adding margin.',
            'Checking if there\'s a hidden step "sense it intuitively".',
            'AI asks how big a tablespoon is. Answer depends on the cook\'s mood.',
            'Teaching AI that "saut\xe9 briefly" can be 2 minutes or 20 \u2014 as it happens.',
            'Kitchen machine and AI debating whose fault it is if something goes wrong.',
            'Converting pinches. At "a pinch upon a pinch" AI got a bit confused.',
            'Checking if the recipe says "add as much as needed". It does.',
            'AI finished the analysis and is warming up to home cooking. Going well.',
            'Translating from grandma\'s notebook where every other word is "you know how".',
            'Looking for meaning in "stir until combined". Combined with what, exactly?',
            'Checking "large eggs" \u2014 no definition found, taking statistical average.',
            'AI just read step "sense the right moment". Still processing.',
            'Convincing the machine that "until golden" is not an error message.',
            'Checking bowl capacity. The optimist who wrote the recipe said it would fit.',
            'Translating "lots of love" \u2014 AI suggested 150 ml. Sounds reasonable.',
            'AI encountered "bring to a rolling boil" and is researching what rolling means.',
            'Locating the line between "lightly browned" and "carbon". It\'s a fine one.',
            '"Let rest until cool" \u2014 AI entered 4 hours. Nobody objected.',
            'Recipe says "fresh ingredients". AI has been reading about chlorophyll for 3 minutes.',
            'Analysing "a handful of parsley". AI briefly thought it was a unit of measure.',
            'AI is trying to quantify "creamy texture". Current estimate: 83% smooth.',
            'Step says "cook al dente" \u2014 AI just looked up Italian. Literally.',
            '"Season with salt and pepper" \u2014 AI asks how much pepper. Valid question.',
            'Checking if "pan smoking hot" is intentional or a fire hazard.',
            'AI calculated 3 tablespoons of olive oil: 45 ml. Recipe said "a splash".',
            'Translating "beat lightly" \u2014 AI proposed exactly 37 strokes. Very precise.',
            'Kitchen machine is waiting. AI is writing instructions. Someone has to go first.',
            'Analysing ingredient "water" \u2014 AI checking: sparkling, still, or tap?'
        ]
    },
    // ============================================================
    // GERMAN
    // ============================================================
    de: {
        loading: 'Laden...',
        cancel: 'Abbrechen',
        save: 'Speichern',
        close: "Schlie\xdfen",
        send: 'Senden',
        delete: "L\xf6schen",
        edit: 'Bearbeiten',
        back: "Zur\xfcck",
        'login.title': 'Anmelden',
        'login.username': 'E-Mail',
        'login.password': 'Passwort',
        'login.submit': 'Anmelden',
        'login.no_account': 'Kein Konto?',
        'login.register_link': 'Registrieren',
        'login.forgot': 'Passwort vergessen',
        'login.success': 'Angemeldet!',
        'login.error': "Ung\xfcltige Anmeldedaten",
        'register.title': 'Konto erstellen',
        'register.name': 'Vor- und Nachname',
        'register.email': 'E-Mail',
        'register.password': 'Passwort',
        'register.confirm_password': "Passwort best\xe4tigen",
        'register.submit': 'Registrieren',
        'register.has_account': 'Bereits ein Konto?',
        'register.login_link': 'Anmelden',
        'register.success': "Registrierung erfolgreich! Sie k\xf6nnen sich jetzt anmelden.",
        'register.error': 'Registrierung fehlgeschlagen.',
        'register.passwords_mismatch': "Passw\xf6rter stimmen nicht \xfcberein",
        'reset.title': "Passwort zur\xfccksetzen",
        'reset.intro': "Geben Sie die mit Ihrem Konto verkn\xfcpfte E-Mail-Adresse ein. Wir senden einen 6-stelligen Code.",
        'reset.email_label': 'E-Mail-Adresse',
        'reset.email_placeholder': 'ihre@email.de',
        'reset.sending': 'Wird gesendet...',
        'reset.send_code': 'Code senden',
        'reset.code_sent': 'Code gesendet an',
        'reset.code_label': 'Code aus der E-Mail (6 Ziffern)',
        'reset.new_password': 'Neues Passwort',
        'reset.confirm_password': "Neues Passwort best\xe4tigen",
        'reset.confirm_placeholder': 'Passwort wiederholen',
        'reset.min_chars': 'mind. 6 Zeichen',
        'reset.changing': "Wird ge\xe4ndert...",
        'reset.change': "Passwort \xe4ndern",
        'reset.resend': 'Code erneut senden',
        'reset.success': "Passwort ge\xe4ndert \u2014 Sie sind jetzt angemeldet!",
        'reset.passwords_mismatch': "Passw\xf6rter stimmen nicht \xfcberein",
        'reset.too_short': 'Das Passwort muss mindestens 6 Zeichen lang sein',
        'reset.error_email': 'Fehler beim Senden der E-Mail',
        'reset.error_code': 'Code-Verifizierung fehlgeschlagen',
        'header.help': 'Wie anfangen?',
        'header.admin': 'Admin',
        'header.login': 'Anmelden',
        'header.register': 'Registrieren',
        'header.logout_success': 'Abgemeldet!',
        // === Konto ===
        'account.title': 'Mein Konto',
        'account.username': 'Benutzername',
        'account.email': 'E-Mail',
        'account.logout': 'Abmelden',
        'account.danger_title': 'Gefahrenzone',
        'account.delete_desc': "Konto und alle gespeicherten Rezepte dauerhaft l\xf6schen. Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.",
        'account.delete_btn': "Konto l\xf6schen",
        'account.delete_warn': "Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden. Alle Ihre Daten und gespeicherten Rezepte werden dauerhaft gel\xf6scht.",
        'account.delete_password_label': "Mit Passwort best\xe4tigen",
        'account.delete_confirm_btn': "Konto endg\xfcltig l\xf6schen",
        'account.deleting': "Wird gel\xf6scht...",
        'account.deleted': "Ihr Konto wurde gel\xf6scht.",
        'account.delete_error': "Konto konnte nicht gel\xf6scht werden.",
        'hero.title': 'Monsieur Cuisine Rezeptkonverter',
        'hero.sub': "Eigenes Rezept einf\xfcgen \u2014 die KI wandelt es in das MC Smart-Format um \u2014 mit Temperaturen, Zeiten und Geschwindigkeiten. Das fertige Rezept mit einem Klick auf Ihr Konto senden.",
        'hero.feat1': "Eigenes Rezept einf\xfcgen",
        'hero.feat2': 'KI konvertiert zu MC',
        'hero.feat3': 'Ans MC-Konto senden',
        'hero.cta_login': 'Anmelden und starten',
        'hero.cta_help': 'Wie funktioniert es?',
        'footer.tagline': 'Monsieur Cuisine Smart Rezeptkonverter',
        'footer.help': 'Hilfe',
        'footer.contact': 'Kontakt',
        'footer.privacy': "Datenschutzerkl\xe4rung",
        'footer.security': 'Sicherheit:',
        'footer.security_text': "Rezepte werden von einer KI generiert. \xdcberpr\xfcfen Sie immer die Parameter, bevor Sie das Ger\xe4t verwenden. Der Autor haftet nicht f\xfcr etwaige Sch\xe4den.",
        'footer.affiliate': 'Affiliate-Hinweis:',
        'footer.affiliate_text': "Diese App enth\xe4lt Partnerlinks, die die Projektentwicklung unterst\xfctzen.",
        'footer.rights': 'Alle Rechte vorbehalten.',
        'contact.tab_contact': 'Kontakt',
        'contact.tab_bug': 'Fehler melden',
        'contact.intro_bug': 'Einen Fehler gefunden? Beschreiben Sie ihn unten.',
        'contact.intro_contact': 'Haben Sie eine Frage oder einen Vorschlag? Schreiben Sie uns.',
        'contact.topic': 'Betreff',
        'contact.email': 'Ihre E-Mail',
        'contact.email_optional': '(optional)',
        'contact.message': 'Nachricht',
        'contact.send': 'Senden',
        'contact.sent_title': 'Nachricht gesendet!',
        'contact.sent_text': 'Wir melden uns bald.',
        'contact.bug_topic': 'Fehlermeldung',
        'contact.generic_topic': 'Nachricht',
        'conv.title': 'Monsieur Cuisine Rezeptkonverter',
        'conv.title_short': 'Konverter',
        'conv.sub': "Eigenes Rezept einf\xfcgen \u2014 die KI wandelt es ins MC Smart-Format um",
        'conv.mc_connected': 'Verbunden mit Monsieur Cuisine',
        'conv.mc_locale_title': 'MC-Konto-Sprache (wohin Rezepte gesendet werden)',
        'conv.mc_connected_mobile': 'MC-Konto verbunden',
        'conv.mobile_no_session': "Konverter funktioniert auf dem Handy. Rezepte an MC senden nur am Computer mit Chrome-Erweiterung m\xf6glich.",
        'conv.mobile_hint': "Auf dem Handy: Rezept konvertieren, als Text kopieren und manuell in der MC-App einf\xfcgen \u2014 oder am Computer mit einem Klick senden.",
        'conv.install_ext': "Um Rezepte ans MC-Konto zu senden \u2014 Erweiterung installieren",
        'conv.url_label': 'Link zu Ihrem eigenen Rezept? Per URL importieren',
        'conv.url_placeholder': 'z. B. https://...',
        'conv.url_btn': 'Importieren',
        'conv.url_loading': 'Lade...',
        'conv.url_error': 'Rezept konnte von dieser Adresse nicht importiert werden',
        'conv.url_ok': "Rezept importiert \u2014 Text unten pr\xfcfen und auf Konvertieren klicken",
        'conv.image_label': 'Rezept als Foto oder Screenshot? Hier einlesen',
        'conv.image_btn': 'Foto / Screenshot hochladen',
        'conv.image_loading': 'Text wird gelesen...',
        'conv.image_hint': "Sie k\xf6nnen auch einen Screenshot (Strg+V) in das Feld unten einf\xfcgen.",
        'conv.image_ok': "Text erkannt \u2014 unten pr\xfcfen und auf Konvertieren klicken",
        'conv.image_err': 'Text konnte aus dem Bild nicht gelesen werden',
        'conv.dish_btn': "Foto des Gerichts hinzuf\xfcgen",
        'conv.dish_loading': 'Foto wird hochgeladen...',
        'conv.dish_ok': "Foto bereit \u2014 es geht mit dem Rezept an MC",
        'conv.dish_remove': 'Entfernen',
        'conv.dish_hint': 'Optional. Das Foto wird zum Rezept-Thumbnail in Ihrem MC-Konto.',
        'conv.dish_err': "Foto konnte nicht hochgeladen werden \u2014 Rezept wird ohne Thumbnail gesendet",
        'conv.bg_waiting': "Wird an MC gesendet \u2014 Sie k\xf6nnen die Seite schlie\xdfen:",
        'conv.bg_done': 'Fertig auf MC:',
        'conv.paste_label': "Rezept in beliebiger Form einf\xfcgen",
        'conv.paste_placeholder': `Eigenes Rezept einf\xfcgen oder in eigenen Worten schreiben...

z.B.
'Tomatensuppe mit Basilikum
1 Zwiebel, 2 Knoblauchzehen, 500g Dosentomaten, 500ml Br\xfche
Zwiebel und Knoblauch in Oliven\xf6l anschwitzen. Tomaten, Br\xfche dazugeben, 20 Min. kochen. Mixen. Basilikum hinzuf\xfcgen.'`,
        'conv.limit_exhausted': 'Limit erreicht',
        'conv.limit_renews': 'erneuert sich',
        'conv.limit_usage': 'Konvertierungen diesen Monat',
        'conv.limit_left': 'verbleibend',
        'conv.converting': 'Konvertiere...',
        'conv.convert_btn': 'In MC-Format konvertieren',
        'conv.reset': 'Neu beginnen',
        'conv.warning': "\xdcberpr\xfcfen Sie das Rezept immer vor der Verwendung am Ger\xe4t.",
        'conv.error_empty': "Bitte f\xfcgen Sie ein Rezept ein, bevor Sie konvertieren.",
        'conv.error_conv': 'Konvertierungsfehler',
        'conv.error_net': 'Netzwerkfehler',
        'conv.error_ext': 'Keine Best\xe4tigung von der Erweiterung \u2014 das Rezept wurde m\xf6glicherweise trotzdem an MC gesendet. Pr\xfcfe \u201EMeine Rezepte" auf monsieur-cuisine.com, bevor du es erneut sendest.',
        'conv.error_send': 'Fehler beim Senden an MC.',
        'conv.checking_mc': "Die Erweiterung hat das Zeitlimit \xfcberschritten, aber MC kann langsam sein \u2014 ich pr\xfcfe, ob das Rezept trotzdem erstellt wurde. Bitte Seite offen lassen.",
        'conv.checking_srv': "Senden l\xe4uft \u2014 die Monsieur-Cuisine-Server brauchen ca. 2 Minuten zum Erstellen des Rezepts. Wir behalten es im Blick: Sie k\xf6nnen die Seite schlie\xdfen, der Link wartet nach Ihrer R\xfcckkehr.",
        'conv.checking_mc_btn': "Pr\xfcfe MC\u2026",
        'conv.recovered': "Gesendet! Die Erweiterung meldete eine Zeit\xfcberschreitung, aber das Rezept ist auf deinem MC-Konto.",
        'conv.error_no_mc_session': 'MC-Konto nicht verbunden. Melden Sie sich auf monsieur-cuisine.com an einem Computer mit der Chrome-Erweiterung an.',
        'conv.error_save': 'Fehler beim Speichern',
        'conv.error_load': 'Fehler beim Laden des Rezepts',
        'conv.saved_mc': 'Rezept auf MC-Konto gespeichert!',
        'conv.sent_excl': 'Gesendet!',
        'conv.open_mc': "Rezept auf MC \xf6ffnen",
        'conv.save': 'Rezept speichern',
        'conv.save_ok': 'Rezept im Kochbuch gespeichert!',
        'conv.repair_hint': 'Optional: Schritt mit Fehler ankreuzen, Problem beschreiben, "Rezept korrigieren" klicken. Schritte mit \u2696\uFE0F sind MC-Wiegeschritte \u2014 sie haben keine Maschinenparameter.',
        'conv.repair_placeholder': 'Beschreibe das Problem. Z.B. "Schritt 4 fehlt Geschwindigkeit und Zeit" oder "Schritt 3 soll Mixen bei Stufe 5 f\xfcr 30s sein"',
        'conv.repair_btn': 'Rezept korrigieren',
        'conv.repairing': 'Korrigiere...',
        'conv.repair_ok': 'Rezept korrigiert!',
        'conv.repair_answer_placeholder': 'Deine Antwort...',
        'conv.repair_send': 'Senden',
        'conv.repair_cancel': 'Abbrechen',
        'conv.repair_save_ask': 'Korrigierte Version speichern?',
        'conv.repair_save_yes': 'Ja, speichern (vorherige ersetzen)',
        'conv.repair_save_no': "Nein, \xfcberspringen",
        'conv.step_weigh': 'MC-Waage',
        'conv.step_manual': 'Manuell',
        'conv.empty_hint1': "Rezept einf\xfcgen und klicken",
        'conv.empty_hint2': '"In MC-Format konvertieren"',
        'conv.empty_hint3': "Die KI passt das Rezept an das MC Smart-Ger\xe4t an \u2014 f\xfcgt Temperaturen, Zeiten und Geschwindigkeiten hinzu.",
        'conv.empty_mc_note': 'Um Rezepte ans MC-Konto zu senden, installieren Sie die Chrome-Erweiterung und melden Sie sich auf monsieur-cuisine.com an.',
        'conv.mc_connect_note': 'Um Rezepte ans MC-Konto zu senden, verbinden Sie die App mit Ihrem Monsieur-Cuisine-Konto.',
        'conv.mc_connect_btn': 'Mit Monsieur Cuisine verbinden',
        'conv.mc_connect_hint': "Melden Sie sich bei Ihrem Monsieur-Cuisine-Konto an \u2014 die App verbindet sich automatisch.",
        'conv.mobile_no_session@app': "MC-Konto nicht verbunden \u2014 nutzen Sie die Schaltfl\xe4che \u201EMit Monsieur Cuisine verbinden\u201D, um Rezepte direkt aus der App zu senden.",
        'conv.image_hint@app': "Sie k\xf6nnen ein Rezept auch mit der Kamera fotografieren \u2014 der erkannte Text erscheint im Feld unten.",
        'conv.error_ext@app': "Keine Sendebest\xe4tigung \u2014 das Rezept kann trotzdem bei MC angekommen sein. Pr\xfcfen Sie \u201EMeine Rezepte\u201D auf monsieur-cuisine.com, bevor Sie erneut senden.",
        'conv.error_no_mc_session@app': "MC-Konto nicht verbunden. Tippen Sie im Konverter auf \u201EMit Monsieur Cuisine verbinden\u201D und melden Sie sich an.",
        'help.start.s3.desc_a@app': 'Verbinden Sie Ihr Monsieur-Cuisine-Konto (Tab',
        'help.start.s3.desc_tab@app': 'MC-Verbindung',
        'help.start.s3.desc_b@app': '), dann tippen Sie auf',
        'help.start.alert@app': "Ihr MC-Konto verbinden Sie direkt in der App \u2014 siehe Tab \u201EMC-Verbindung\u201D. Ohne Erweiterungen, ohne Computer.",
        'help.conv.l1@app': "Kopieren Sie den vollst\xe4ndigen Text Ihres Rezepts",
        'help.conv.l2@app': "F\xfcgen Sie ihn ins Konverterfeld ein \u2014 oder fotografieren Sie das Rezept mit der Kamera",
        'help.conv.h4@app': 'Speichern und Senden',
        'help.conv.share.l2_b@app': "\u2014 verbinden Sie Ihr Konto im Tab \u201EMC-Verbindung\u201D",
        'help.conv.share.l3@app': "Sie verbinden einmal \u2014 danach senden Sie Rezepte mit einem Tipp",
        'help.prob.h1@app': 'Probleme mit der MC-Verbindung',
        'help.prob.p3.l1@app': "Tippen Sie im Konverter auf \u201EMit Monsieur Cuisine verbinden\u201D und melden Sie sich erneut an",
        'help.prob.p3.l2@app': "Das Senden ist wieder aktiv \u2014 die App aktualisiert die Sitzung im Hintergrund",
        'help.prob.p9.q@app': 'Kann ich Rezepte ohne MC-Konto konvertieren?',
        'help.prob.p9.desc@app': "Ein MateMeal-Konto ist f\xfcr die Konvertierung erforderlich. Zum Senden von Rezepten verbinden Sie Ihr Monsieur-Cuisine-Konto in der App (Tab \u201EMC-Verbindung\u201D).",
        'conv.image_camera': 'Foto aufnehmen',
        'help.tab.app': 'MC-Verbindung',
        'help.app.lead': "In der App brauchen Sie keine Chrome-Erweiterung \u2014 Sie verbinden Ihr Monsieur-Cuisine-Konto direkt in der App.",
        'help.app.alert': 'Die Verbindung erfolgt nur einmal. Die App aktualisiert die Sitzung im Hintergrund.',
        'help.app.h1': 'So verbinden Sie Ihr MC-Konto',
        'help.app.s1.title': 'Bei Matemeal anmelden',
        'help.app.s1.desc': "Verwenden Sie Ihr normales Matemeal-Konto \u2014 dasselbe wie auf der Website.",
        'help.app.s2.title': "\u201EMit Monsieur Cuisine verbinden\u201D antippen",
        'help.app.s2.desc': "Die Schaltfl\xe4che finden Sie im Konverter. Es \xf6ffnet sich ein Anmeldefenster von Monsieur Cuisine (Lidl-Konto).",
        'help.app.s3.title': 'Beim MC-Konto anmelden',
        'help.app.s3.desc': "Nach erfolgreicher Anmeldung schlie\xdft sich das Fenster automatisch und das Senden von Rezepten ist aktiv.",
        'help.app.note': "Das Senden eines Rezepts ans MC-Konto dauert in der Regel etwa 2 Minuten \u2014 Sie k\xf6nnen die App w\xe4hrenddessen normal nutzen.",
        'help.app.sec.l1': "Ihre Lidl-Zugangsdaten geben Sie ausschlie\xdflich auf der Monsieur-Cuisine-Website ein \u2014 die App sieht und speichert sie nicht.",
        'help.app.sec.l2': 'Die App speichert nur die Sitzung (Cookies), genau wie ein Browser.',
        'help.app.sec.l3': "Sie k\xf6nnen Ihr MC-Konto jederzeit trennen, indem Sie sich von der Monsieur-Cuisine-Website abmelden.",
        'conv.safety': "Parameter vor dem Senden pr\xfcfen. Der Autor haftet nicht f\xfcr das Verhalten des Rezepts am Ger\xe4t.",
        'conv.recipe_default': 'MC-Rezept',
        'conv.difficulty_hard': 'Schwer',
        'conv.difficulty_medium': 'Mittel',
        'conv.difficulty_easy': 'Einfach',
        'conv.save_changes': "\xc4nderungen speichern",
        'conv.editing': 'Rezept bearbeiten',
        'conv.unsaved': "nicht gespeicherte \xc4nderungen",
        'conv.edit': 'Bearbeiten',
        'conv.send_mc': 'An MC senden',
        'conv.sending_mc': "Wird gesendet\u2026",
        'conv.sent_mc': 'An MC gesendet',
        'conv.servings': 'Portionen',
        'conv.steps_count': 'Schritte',
        'conv.ingredients': 'Zutaten',
        'conv.add': "+ Hinzuf\xfcgen",
        'conv.steps_title': 'Monsieur Cuisine Schritte',
        'conv.step_title_ph': 'Schritttitel',
        'conv.step_desc_ph': 'Schrittbeschreibung',
        'conv.temp': 'Temp.',
        'conv.speed': 'Geschw.',
        'conv.time': 'Zeit',
        'conv.fix_selected': "Ausgew\xe4hlte korrigieren",
        'conv.fixing': 'Korrigiere...',
        'conv.fix_placeholder': 'Was stimmt nicht? (optional) z.B. fehlender Backschritt, falsche Temperatur...',
        'conv.fix_selected_label': "Ausgew\xe4hlt",
        'conv.fix_step': 'Schritt',
        'conv.fix_steps_few': 'Schritte',
        'conv.fix_steps_many': 'Schritte',
        'conv.fix_to_fix': 'zu korrigieren',
        'conv.nutrients': "N\xe4hrwerte (pro Portion)",
        'conv.protein': "Eiwei\xdf",
        'conv.carbs': 'Kohlenhydr.',
        'conv.fat': 'Fett',
        'conv.tips': 'Tipps:',
        'conv.ing_name_ph': 'Name',
        'conv.ing_qty_ph': 'Menge',
        'saved.title': 'Gespeicherte Rezepte',
        'saved.title_short': 'Gespeichert',
        'saved.preview': 'Vorschau',
        'saved.load': 'Laden',
        'saved.load_to_conv': 'In Konverter laden',
        'saved.open_mc': "Auf MC \xf6ffnen",
        'saved.no_data': 'Rezeptdaten konnten nicht geladen werden.',
        'ext.title': 'Chrome-Erweiterung installieren',
        'ext.step1': 'Klicke unten auf \u201EZu Chrome hinzuf\xfcgen" und best\xe4tige die Installation',
        'ext.step2': 'Melde dich auf monsieur-cuisine.com in Chrome an',
        'ext.step3': "Kehre zu MateMeal zur\xfcck und lade die Seite neu \u2014 der gr\xfcne Verbindungsstatus erscheint",
        'ext.security': "Die Erweiterung ruft ausschlie\xdflich die f\xfcr die API-Kommunikation erforderlichen MC-Sitzungscookies ab. Es werden keine Daten au\xdferhalb Ihres Browsers \xfcbertragen.",
        'ext.banner_text': "Instaliere Matemeal Connector \u2014 sende Rezepte mit einem Klick an dein Monsieur Cuisine-Konto.",
        'ext.banner_cta': "Zu Chrome hinzuf\xfcgen",
        'cookie.text': "Diese App verwendet lokalen Speicher f\xfcr Monsieur Cuisine-Sitzungscookies ausschlie\xdflich zum Senden von Rezepten an Ihr MC-Konto. Es werden keine Daten an Dritte weitergegeben.",
        'cookie.accept': 'Verstanden',
        'copyright.text': "Konvertieren Sie nur eigene Rezepte oder solche, die Sie im Rahmen der erlaubten Privatnutzung verwenden (Richtlinie 2001/29/EG und nationales Recht). MateMeal ermutigt nicht zum Kopieren oder Verbreiten von Rezepten Dritter \u2014 f\xfcr \xfcbermittelte Inhalte sind Sie selbst verantwortlich.",
        'copyright.accept': 'Verstanden',
        'help.title': 'Wie benutze ich MateMeal?',
        'help.tab.start': 'Erste Schritte',
        'help.tab.extension': 'Chrome-Erweiterung',
        'help.tab.convert': 'Rezeptkonvertierung',
        'help.tab.problems': 'Probleme?',
        'help.start.lead': "MateMeal wandelt beliebige Rezepte in das Monsieur Cuisine Smart-Format um \u2014 mit Temperaturen, Geschwindigkeiten und Zeiten. Das fertige Rezept k\xf6nnen Sie mit einem Klick an Ihr MC-Konto senden.",
        'help.start.h1': 'Drei Schritte zum ersten Rezept',
        'help.start.s1.title': 'Konto erstellen und anmelden',
        'help.start.s1.desc_a': 'Klicken Sie auf',
        'help.start.s1.desc_strong': 'Registrieren',
        'help.start.s1.desc_b': 'oben rechts. Ein Konto ist zum Speichern von Rezepten und zur Synchronisierung mit MC erforderlich.',
        'help.start.s2.title': 'Rezept einf\xfcgen und auf \u201EIn MC-Format konvertieren" klicken',
        'help.start.s2.desc': "Eigenes Rezept einf\xfcgen \u2014 oder in eigenen Worten schreiben. Die KI f\xfcgt alle Ger\xe4teparameter hinzu.",
        'help.start.s3.title': 'Rezept an Ihr Monsieur Cuisine-Konto senden',
        'help.start.s3.desc_a': 'Installieren Sie die Chrome-Erweiterung (Registerkarte',
        'help.start.s3.desc_tab': 'Chrome-Erweiterung',
        'help.start.s3.desc_b': '), melden Sie sich auf monsieur-cuisine.com an und klicken Sie auf',
        'help.start.s3.desc_strong': 'An MC senden',
        'help.start.alert': "Die Chrome-Erweiterung wird ben\xf6tigt, um das MC-Konto zu verbinden und Rezepte zu senden. Funktioniert nur am Computer.",
        'help.start.h2': "Was k\xf6nnen Sie einf\xfcgen?",
        'help.start.l1': 'Eigene Rezepte in beliebiger Form',
        'help.start.l2': 'Familienrezepte aus dem Notizbuch (abgetippt)',
        'help.start.l3': 'Andere Rezepte nur im Rahmen der erlaubten Privatnutzung',
        'help.start.l4': 'Eigene Rezeptbeschreibung in Ihrer Sprache',
        'help.start.l5': "Zutaten und Schritte frei beschrieben \u2014 die KI erkennt die Struktur selbst",
        'help.ext.lead': "Die Chrome-Erweiterung verbindet MateMeal mit Ihrem Monsieur Cuisine-Konto. Nach der Installation werden Rezepte mit einem Klick gesendet \u2014 ohne Kopieren und Einf\xfcgen.",
        'help.ext.alert': "Matemeal Connector ist im Chrome Web Store verf\xfcgbar. Mit einem Klick installieren \u2014 kein Entwicklermodus erforderlich.",
        'help.ext.mobile.title': 'Nutzen Sie ein Smartphone?',
        'help.ext.mobile.desc_a': 'Chrome auf Android und iOS',
        'help.ext.mobile.desc_strong': "unterst\xfctzt keine Erweiterungen",
        'help.ext.mobile.desc_b': "\u2014 auf dem Smartphone k\xf6nnen Sie:",
        'help.ext.mobile.l1_a': 'Rezepte umwandeln',
        'help.ext.mobile.l1_strong': "f\xfcr MC Smart",
        'help.ext.mobile.l1_b': ' und im Profil speichern',
        'help.ext.mobile.l2': "Rezepte an MC senden nur am Computer mit Chrome-Erweiterung m\xf6glich",
        'help.ext.h1': "Schritt-f\xfcr-Schritt-Installation",
        'help.ext.s1.title': 'Erweiterungsordner finden',
        'help.ext.s1.desc': 'Im MateMeal-App-Verzeichnis den Ordner finden:',
        'help.ext.s2.title': 'Matemeal Connector aus dem Chrome Web Store installieren',
        'help.ext.s2.desc_a': "Klicke auf den Link unten und best\xe4tige die Installation:",
        'help.ext.s2.desc_b': "und Enter dr\xfccken.",
        'help.ext.s3.title': 'Entwicklermodus aktivieren',
        'help.ext.s3.desc_a': 'Oben rechts auf der Seite chrome://extensions den Schalter',
        'help.ext.s3.desc_strong': 'Entwicklermodus',
        'help.ext.s3.desc_b': '(Developer mode) aktivieren.',
        'help.ext.s4.title': 'Entpackte Erweiterung laden',
        'help.ext.s4.desc_a': "Auf die Schaltfl\xe4che",
        'help.ext.s4.desc_strong': 'Entpackte Erweiterung laden',
        'help.ext.s4.desc_b': 'klicken und den Ordner',
        'help.ext.s4.desc_c': "ausw\xe4hlen. Die Erweiterung erscheint als MC Recipe Converter.",
        'help.ext.s5.title': 'Bei Monsieur Cuisine anmelden',
        'help.ext.s5.desc': "monsieur-cuisine.com in einem neuen Tab \xf6ffnen und am Konto anmelden. Das reicht \u2014 die Erweiterung erkennt die Sitzung automatisch.",
        'help.ext.s6.title': "Zu MateMeal zur\xfcckkehren und Seite aktualisieren",
        'help.ext.s6.desc_a': "Dr\xfccken Sie",
        'help.ext.s6.desc_b': "auf der MateMeal-Seite. Im Konverter sollte eine gr\xfcne Meldung erscheinen",
        'help.ext.s6.desc_c': '"Verbunden mit Monsieur Cuisine".',
        'help.ext.ok_alert': "Fertig! Bei jedem Browserstart synchronisiert die Erweiterung die Sitzung automatisch \u2014 Sie m\xfcssen nichts wiederholen.",
        'help.ext.security.title': 'Sicherheit',
        'help.ext.security.l1': "Die Erweiterung liest ausschlie\xdflich monsieur-cuisine.com-Sitzungscookies",
        'help.ext.security.l2': "Es werden keine Daten an externe Server au\xdfer MC und MateMeal gesendet",
        'help.ext.security.l3': 'Ihr MC-Passwort wird niemals gelesen oder gespeichert',
        'help.conv.lead': "Die KI analysiert das Rezept und \xfcbersetzt jeden Schritt in Monsieur Cuisine Smart-Operationen: Zutaten abwiegen, zerkleinern, erhitzen, kochen, mixen.",
        'help.conv.h1': "Wie f\xfcge ich ein Rezept ein?",
        'help.conv.l1': 'Den gesamten Text Ihres eigenen Rezepts markieren und kopieren (Strg+C)',
        'help.conv.l2': "In das Textfeld des Konverters einf\xfcgen (Strg+V)",
        'help.conv.l3_a': 'Klicken Sie auf',
        'help.conv.l3_strong': 'In MC-Format konvertieren',
        'help.conv.h2': 'Was macht die KI mit dem Rezept?',
        'help.conv.card1.title': 'Wiegen',
        'help.conv.card1.desc': "Jede Zutat erh\xe4lt einen eigenen Wiegeschritt auf der MC-Waage",
        'help.conv.card2.title': 'Temperaturen',
        'help.conv.card2.desc': "Die KI w\xe4hlt die Temperatur je nach Vorgangsart (Braten, Kochen, Schmelzen)",
        'help.conv.card3.title': 'Geschwindigkeiten',
        'help.conv.card3.desc': "Mixgeschwindigkeit je nach Konsistenz: Hacken 7-8, R\xfchren 2-3",
        'help.conv.card4.title': 'Zeiten',
        'help.conv.card4.desc': 'Koch-, Mix- und Heizzeiten passend zum Gerichttyp',
        'help.conv.h3': 'Bearbeiten und korrigieren',
        'help.conv.edit.l1_a': 'Klicken Sie auf',
        'help.conv.edit.l1_strong': 'Bearbeiten',
        'help.conv.edit.l1_b': "um Titel, Zutaten oder Schrittbeschreibungen zu \xe4ndern",
        'help.conv.edit.l2_a': 'Fehlerhafte Schritte markieren (Checkbox neben jedem Schritt) und auf',
        'help.conv.edit.l2_strong': "Ausgew\xe4hlte korrigieren",
        'help.conv.edit.l2_b': "klicken \u2014 die KI generiert sie neu",
        'help.conv.edit.l3': "Im Bearbeitungsmodus k\xf6nnen Sie Schritte mit \u2191\u2193 neu anordnen",
        'help.conv.h4': 'Was tun ohne die Erweiterung?',
        'help.conv.share.l1_a': 'Das Rezept kann',
        'help.conv.share.l1_strong': 'im MateMeal-Konto gespeichert werden',
        'help.conv.share.l1_b': "\u2014 auf das Lesezeichen-Symbol neben dem Rezept klicken",
        'help.conv.share.l2_a': 'Um',
        'help.conv.share.l2_strong': "das Rezept ans MC-Ger\xe4t zu senden",
        'help.conv.share.l2_b': '\u2014 Chrome-Erweiterung installieren (Tab \u201EErweiterung")',
        'help.conv.share.l3': "Die Erweiterung ist kostenlos und l\xe4sst sich mit einem Klick aus dem Chrome Web Store installieren",
        'help.conv.alert': "\xdcberpr\xfcfen Sie das generierte Rezept immer vor der Verwendung am Ger\xe4t. Die KI versucht realistische Parameter zu w\xe4hlen, aber das Rezept kann kleinere Anpassungen erfordern.",
        'help.prob.lead': "H\xe4ufige Probleme und wie man sie l\xf6st.",
        'help.prob.h1': 'Probleme mit der Erweiterung',
        'help.prob.p1.q': '"Keine Best\xe4tigung von der Erweiterung"',
        'help.prob.p1.desc': "Die Erweiterung hat das Ergebnis nicht rechtzeitig zur\xfcckgemeldet \u2014 entweder antwortete der MC-Server langsam (das Rezept wurde m\xf6glicherweise trotzdem erstellt), oder der Erweiterungskontext ist nach einem Update oder Neuladen abgelaufen.",
        'help.prob.p1.l1': 'Pr\xfcfe zuerst \u201EMeine Rezepte" auf monsieur-cuisine.com \u2014 das Rezept wird manchmal trotz der Meldung gesendet',
        'help.prob.p1.l2': "Falls es dort nicht ist \u2014 F5 dr\xfccken und erneut senden",
        'help.prob.p1.l3_a': "Falls das Problem anh\xe4lt \u2014 zu",
        'help.prob.p1.l3_b': "gehen, \u21BB (Neu laden) neben Matemeal Connector klicken, dann Seite aktualisieren",
        'help.prob.p2.q': '"Verbunden mit MC" erscheint nach Installation der Erweiterung nicht',
        'help.prob.p2.l1_a': 'Sicherstellen, dass Sie bei',
        'help.prob.p2.l1_b': 'im selben Browser angemeldet sind',
        'help.prob.p2.l2': 'MateMeal-Seite aktualisieren (F5)',
        'help.prob.p2.l3': "Falls noch nicht vorhanden \u2014 zu MC gehen, ab- und wieder anmelden, dann zu MateMeal zur\xfcckkehren und aktualisieren",
        'help.prob.p3.q': '"MC-Token abgelaufen \u2014 bitte erneut anmelden"',
        'help.prob.p3.desc': "Die Monsieur Cuisine-Sitzung ist abgelaufen (in der Regel nach einigen Tagen Inaktivit\xe4t).",
        'help.prob.p3.l1': "monsieur-cuisine.com \xf6ffnen und erneut anmelden",
        'help.prob.p3.l2': "Zu MateMeal zur\xfcckkehren und Seite aktualisieren (F5)",
        'help.prob.p4.q': 'Wie installiere ich die Erweiterung neu?',
        'help.prob.p4.l1_a': "\xd6ffne",
        'help.prob.p4.l1_strong': 'chrome://extensions',
        'help.prob.p4.l1_b': 'und finde Matemeal Connector in der Liste',
        'help.prob.p4.l2_a': 'Klicke auf',
        'help.prob.p4.l2_strong': 'Entfernen',
        'help.prob.p4.l2_b': "\u2014 die Erweiterung wird deinstalliert",
        'help.prob.p4.l3': 'Installiere die Erweiterung erneut aus dem Chrome Web Store und melde dich auf monsieur-cuisine.com an',
        'help.prob.h2': 'KI-Konvertierungsprobleme',
        'help.prob.p5.q': '"KI-Konvertierungsfehler" / "Modell hat Token-Limit \xfcberschritten"',
        'help.prob.p5.desc': "Das Rezept ist zu lang oder zu komplex f\xfcr das KI-Modell.",
        'help.prob.p5.l1': "Rezept k\xfcrzen \u2014 unn\xf6tige Einleitungen und Autorenkommentare entfernen",
        'help.prob.p5.l2': 'Rezept in zwei Teile aufteilen und jeden Teil separat konvertieren',
        'help.prob.p5.l3': "Nach einer kurzen Pause erneut versuchen \u2014 m\xf6glicherweise tempor\xe4re API-\xdcberlastung",
        'help.prob.p6.q': 'Das generierte Rezept hat falsche Schritte oder Parameter',
        'help.prob.p6.l1': 'Fehlerhafte Schritte markieren (Checkbox neben jedem Schritt)',
        'help.prob.p6.l2': 'Optional im Notizfeld beschreiben, was nicht stimmt',
        'help.prob.p6.l3_a': 'Auf',
        'help.prob.p6.l3_strong': "Ausgew\xe4hlte korrigieren",
        'help.prob.p6.l3_b': "klicken \u2014 die KI generiert diese Schritte neu",
        'help.prob.p6.l4_a': "Falls immer noch nicht gut \u2014 den",
        'help.prob.p6.l4_strong': 'Bearbeiten',
        'help.prob.p6.l4_b': '-Modus nutzen und manuell korrigieren',
        'help.prob.p7.q': 'Zutaten werden falsch zusammengefasst oder Wiegeschritte fehlen',
        'help.prob.p7.desc': 'Die KI fasst manchmal mehrere Zutaten in einem Schritt zusammen. In MC sollte jede Zutat einzeln gewogen werden.',
        'help.prob.p7.l1': "Problematische Schritte markieren und auf Ausgew\xe4hlte korrigieren klicken",
        'help.prob.p7.l2': 'Im Notizfeld z.B. schreiben: \u201EZutaten in separate Wiegeschritte aufteilen"',
        'help.prob.h3': 'Sonstiges',
        'help.prob.p8.q': 'Rezept wurde gesendet, aber ich sehe es nicht auf meinem MC-Konto',
        'help.prob.p8.l1': "Den Bereich Meine Rezepte auf monsieur-cuisine.com pr\xfcfen",
        'help.prob.p8.l2': 'MC-Seite aktualisieren',
        'help.prob.p8.l3': "Falls das Senden erfolgreich war (gr\xfcne Meldung + Link), ist das Rezept auf dem Konto \u2014 es kann einen Moment dauern bis zur Synchronisierung",
        'help.prob.p9.q': 'Kann ich Rezepte ohne Konto / ohne Erweiterung konvertieren?',
        'help.prob.p9.desc': "Ein Konto ist f\xfcr die Konvertierung erforderlich. Die Chrome-Erweiterung wird nur f\xfcr die erste MC-Kontoverbindung ben\xf6tigt \u2014 nach der Verbindung am Computer k\xf6nnen Sie Rezepte von jedem Ger\xe4t senden, auch vom Smartphone.",
        'help.prob.contact': "Keine L\xf6sung gefunden?",
        'contact.form.title': 'Schreib uns',
        'contact.form.subject': 'Betreff',
        'contact.form.subject.bug': 'Fehlermeldung',
        'contact.form.subject.help': 'Hilfe',
        'contact.form.subject.other': 'Sonstiges',
        'contact.form.message': 'Nachricht',
        'contact.form.reply_email': "Deine E-Mail (optional, f\xfcr Antworten)",
        'contact.form.send': 'Senden',
        'contact.form.sending': "Wird gesendet\u2026",
        'contact.form.success': "Nachricht gesendet! Wir melden uns in K\xfcrze.",
        'contact.form.error': 'Sendefehler. Bitte versuche es gleich erneut.',
        'contact.form.error_short': 'Sendefehler. Bitte versuche es erneut.',
        'contact.form.rate_limit': 'Zu viele Nachrichten. Bitte warte eine Stunde.',
        converting_msgs: [
            'KI las \u201Ebraten bis fertig" und schwieg danach sehr lange.',
            '\xdcbersetze \u201Enach Augenma\xdf" in Zahlen. KI schaut skeptisch.',
            'Suche Definition von \u201Eetwas warmes Wasser". Datenbank schweigt.',
            'Konvertiere \u201Eeine Tasse" \u2014 den Messbecher oder Omas Teetasse?',
            "KI hat gerade festgestellt, dass Rezepte eher Vorschl\xe4ge als Anweisungen sind.",
            'Interpretiere \u201Enach Geschmack" als Standardwert. KI nickt unsicher.',
            'Verhandlung \xfcber Temperatur. Rezept sagt \u201Ehei\xdfer Ofen". Definition ausstehend.',
            'Messe \u201Eeine gro\xdfz\xfcgige Handvoll". Ich habe kleine H\xe4nde, rechne gro\xdfz\xfcgig.',
            'Pr\xfcfe ob das Rezept einen versteckten Schritt \u201Eintuitiv ersp\xfcren" hat.',
            "KI fragt, wie gro\xdf ein Essl\xf6ffel ist. Antwort h\xe4ngt vom Koch ab.",
            'Bringe KI bei, dass \u201Ekurz anbraten" 2 oder 20 Minuten bedeuten kann.',
            "K\xfcchenmaschine und KI diskutieren, wessen Schuld es ist, falls etwas schiefgeht.",
            'Konvertiere Prisen. Bei \u201Eeine Prise nach der anderen" hat KI etwas gerechnet.',
            'Pr\xfcfe ob das Rezept sagt \u201Eso viel wie n\xf6tig". Tut es.',
            "KI hat die Analyse abgeschlossen und erw\xe4rmt sich f\xfcr die Hausmannskost. L\xe4uft.",
            '\xdcbersetze aus Omas Notizbuch, wo jedes zweite Wort \u201Ewie immer" ist.',
            'Suche Sinn in \u201Er\xfchren bis alles verbunden ist". Verbunden womit genau?',
            'Pr\xfcfe \u201Egro\xdfe Eier" \u2014 keine Definition gefunden, nehme statistischen Durchschnitt.',
            'KI las gerade Schritt \u201Eden richtigen Moment ersp\xfcren". Verarbeitung l\xe4uft.',
            '\xdcberzeuge die Maschine, dass \u201Ebis goldbraun" keine Fehlermeldung ist.',
            "Pr\xfcfe Sch\xfcsselkapazit\xe4t. Der Optimist der das Rezept schrieb meinte, es passt.",
            '\xdcbersetze \u201Eviel Liebe" \u2014 KI schlug 150 ml vor. Klingt vern\xfcnftig.',
            'KI stie\xdf auf \u201Ezum Kochen bringen" und fragt: Kochen wovon genau?',
            'Suche die Grenze zwischen \u201Eleicht angebr\xe4unt" und \u201EKohle". Sie ist sehr schmal.',
            '\u201EAbk\xfchlen lassen" \u2014 KI trug 4 Stunden ein. Niemand widersprach.',
            'Rezept sagt \u201Efrische Zutaten". KI liest seit 3 Minuten \xfcber Photosynthese.',
            'Analysiere \u201Eeine Handvoll Petersilie". KI dachte kurz, es sei eine Ma\xdfeinheit.',
            'KI versucht \u201Ecremige Konsistenz" zu quantifizieren. Aktuelle Sch\xe4tzung: 83 % glatt.',
            'Schritt: \u201Eal dente kochen" \u2014 KI hat gerade Italienisch gelernt. W\xf6rtlich.',
            '\u201EMit Salz und Pfeffer abschmecken" \u2014 KI fragt wie viel Pfeffer. Gute Frage.',
            'Pr\xfcfe ob \u201EPfanne rauchend hei\xdf" Absicht oder Brandalarm ist.',
            'KI berechnete 3 Essl\xf6ffel Oliven\xf6l: 45 ml. Rezept sagte \u201Eeinen Schuss".',
            '\xdcbersetze \u201Eleicht schlagen" \u2014 KI schlug genau 37 Mal vor. Sehr pr\xe4zise.',
            "K\xfcchenmaschine wartet. KI schreibt Anleitung. Einer muss anfangen.",
            'Analysiere Zutat \u201EWasser" \u2014 KI pr\xfcft: Sprudel, still oder Leitungswasser?'
        ]
    }
};
// Map known backend Polish error messages to translation keys
const $45edc04dea201a66$var$ERROR_MAP = {
    "Nieprawid\u0142owe has\u0142o": {
        en: 'Invalid password',
        de: 'Falsches Passwort'
    },
    "U\u017Cytkownik nie istnieje": {
        en: 'User does not exist',
        de: 'Benutzer existiert nicht'
    },
    "Nazwa u\u017Cytkownika jest ju\u017C zaj\u0119ta": {
        en: 'Username is already taken',
        de: 'Benutzername ist bereits vergeben'
    },
    "Email jest ju\u017C zaj\u0119ty": {
        en: 'Email is already taken',
        de: 'E-Mail ist bereits vergeben'
    },
    'Konto zablokowane': {
        en: 'Account is blocked',
        de: 'Konto ist gesperrt'
    },
    'Konto zablokowane przez administratora': {
        en: 'Account blocked by administrator',
        de: 'Konto vom Administrator gesperrt'
    },
    "Has\u0142o musi mie\u0107 co najmniej 6 znak\xf3w": {
        en: 'Password must be at least 6 characters',
        de: 'Passwort muss mindestens 6 Zeichen lang sein'
    },
    "Has\u0142a nie s\u0105 identyczne": {
        en: 'Passwords do not match',
        de: "Passw\xf6rter stimmen nicht \xfcberein"
    },
    'Nie znaleziono konta z tym adresem email': {
        en: 'No account found with this email address',
        de: 'Kein Konto mit dieser E-Mail-Adresse gefunden'
    },
    "Nieprawid\u0142owy lub wygas\u0142y kod": {
        en: 'Invalid or expired code',
        de: "Ung\xfcltiger oder abgelaufener Code"
    },
    "Wymagane s\u0105 nazwa u\u017Cytkownika i has\u0142o": {
        en: 'Username and password are required',
        de: 'Benutzername und Passwort sind erforderlich'
    },
    "Rejestracja nie powiod\u0142a si\u0119": {
        en: 'Registration failed',
        de: 'Registrierung fehlgeschlagen'
    },
    'Limit konwersji wyczerpany': {
        en: 'Conversion limit reached',
        de: 'Konvertierungslimit erreicht'
    },
    "B\u0142\u0105d konwersji": {
        en: 'Conversion error',
        de: 'Konvertierungsfehler'
    },
    "B\u0142\u0105d sieci": {
        en: 'Network error',
        de: 'Netzwerkfehler'
    },
    "Obecne has\u0142o jest nieprawid\u0142owe": {
        en: 'Current password is incorrect',
        de: 'Aktuelles Passwort ist falsch'
    },
    "Wymagane jest has\u0142o": {
        en: 'Password is required',
        de: 'Passwort ist erforderlich'
    }
};
function $45edc04dea201a66$export$dbb77d813a78f040(msg, lang) {
    if (!msg || lang === 'pl') return msg;
    for (const [pl, translations] of Object.entries($45edc04dea201a66$var$ERROR_MAP)){
        if (msg.includes(pl)) return msg.replace(pl, translations[lang] || pl);
    }
    return msg;
}



const $0f85c0253a30f8b6$var$LangContext = /*#__PURE__*/ (0, $acw62.createContext)();
function $0f85c0253a30f8b6$export$b78e4fb81d317543({ children: children }) {
    const [lang, setLang] = (0, $acw62.useState)(()=>localStorage.getItem('lang') || 'pl');
    const t = (key)=>{
        // W aplikacji Android wariant "klucz@app" (jeśli istnieje) wygrywa z bazowym —
        // teksty o wtyczce Chrome / komputerze / Ctrl+V dostają wersje apkowe bez
        // dotykania komponentów. W przeglądarce sufiks nigdy nie jest sprawdzany.
        if ((0, $5a6742a4b36362a4$export$1efe58f5634014d1)()) {
            const appVal = (0, $45edc04dea201a66$export$150b732325d14d04)[lang]?.[key + '@app'] ?? (0, $45edc04dea201a66$export$150b732325d14d04).pl[key + '@app'];
            if (appVal !== undefined) return appVal;
        }
        const val = (0, $45edc04dea201a66$export$150b732325d14d04)[lang]?.[key] ?? (0, $45edc04dea201a66$export$150b732325d14d04).pl[key];
        return val !== undefined ? val : key;
    };
    const tErr = (msg)=>(0, $45edc04dea201a66$export$dbb77d813a78f040)(msg, lang);
    const changeLang = (l)=>{
        setLang(l);
        localStorage.setItem('lang', l);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0f85c0253a30f8b6$var$LangContext.Provider, {
        value: {
            lang: lang,
            t: t,
            tErr: tErr,
            changeLang: changeLang
        },
        children: children
    });
}
const $0f85c0253a30f8b6$export$b24a004ee43dce44 = ()=>(0, $acw62.useContext)($0f85c0253a30f8b6$var$LangContext);


const $042abebcecde25e2$var$CHROME_STORE_URL = 'https://chromewebstore.google.com/detail/ipjjoaopeimoooklbnjjkeaojjhenaig';
// Mapowanie kategorii display format → MC categoryIds
// Rozszerzenie Chrome czyta r.categories — uzupełniamy je tutaj żeby nie czekać na aktualizację w sklepie
const $042abebcecde25e2$var$MC_CATEGORY_IDS = {
    'sos': 222,
    'sosy i dipy': 222,
    'zupa': 230,
    'zupy': 230,
    "sa\u0142atka": 238,
    "sa\u0142atki": 238,
    'dodatek': 246,
    'dodatki': 246,
    "przek\u0105ska": 254,
    "przek\u0105ski": 254,
    'obiad': 262,
    "dania g\u0142\xf3wne": 262,
    "dla niemowl\u0105t": 270,
    "nap\xf3j": 278,
    'napoje': 278,
    'one-pot': 286,
    'all-in-one': 286,
    'deser': 310,
    'desery': 310,
    'wypieki': 318,
    'pieczywo': 318,
    'ciasto': 318,
    "\u015Bniadanie": 326,
    "\u015Bniadania": 326,
    'kolacja': 334,
    'kolacje': 334,
    'przystawka': 342,
    'przystawki': 342,
    "wegetaria\u0144skie": 586,
    "wega\u0144skie": 577
};
function $042abebcecde25e2$var$resolveCategoryIds(category) {
    const id = $042abebcecde25e2$var$MC_CATEGORY_IDS[(category || 'obiad').toLowerCase().trim()] ?? 262;
    return [
        id
    ];
}

function $042abebcecde25e2$var$RecipeConverter({ mcSession: mcSession, user: user, onUserUpdate: onUserUpdate, externalRecipe: externalRecipe, onMcConnect: onMcConnect }) {
    const { t: t, tErr: tErr, lang: lang, changeLang: changeLang } = (0, $0f85c0253a30f8b6$export$b24a004ee43dce44)();
    const convertingMsgs = t('converting_msgs');
    const [prompt, setPrompt] = (0, $acw62.useState)('');
    const [importUrl, setImportUrl] = (0, $acw62.useState)('');
    const [importing, setImporting] = (0, $acw62.useState)(false);
    const [importMsg, setImportMsg] = (0, $acw62.useState)('');
    const [ocrLoading, setOcrLoading] = (0, $acw62.useState)(false);
    const ocrInputRef = (0, $acw62.useRef)(null);
    // Osobny input z capture — w apce otwiera aparat zamiast galerii
    const cameraInputRef = (0, $acw62.useRef)(null);
    // Zdjęcie potrawy (miniatura na MC) — osobne od zdjęcia do OCR: tamto jest źródłem
    // tekstu przepisu, to trafia na konto MC jako thumbnail. dishMedia trzyma ID mediów
    // zwrócone przez MC, podpinane pod przepis dopiero po udanej wysyłce.
    const [dishPreview, setDishPreview] = (0, $acw62.useState)('');
    const [dishMedia, setDishMedia] = (0, $acw62.useState)(null);
    const [dishUploading, setDishUploading] = (0, $acw62.useState)(false);
    const [dishError, setDishError] = (0, $acw62.useState)('');
    const dishInputRef = (0, $acw62.useRef)(null);
    // Wysyłka w tle przeżywa zamknięcie karty — trzymamy jej ślad w localStorage,
    // żeby po powrocie na stronę dowiedzieć się o wyniku i pokazać link do przepisu.
    const [bgJob, setBgJob] = (0, $acw62.useState)(null);
    const [converting, setConverting] = (0, $acw62.useState)(false);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [result, setResult] = (0, $acw62.useState)(null);
    const [warnings, setWarnings] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)('');
    const [pushSuccess, setPushSuccess] = (0, $acw62.useState)('');
    // Trwa dopytywanie MC czy przepis powstał mimo timeoutu wtyczki — osobno od `pushing`,
    // bo komunikat i etykieta przycisku muszą mówić co innego niż przy zwykłej wysyłce
    const [pushChecking, setPushChecking] = (0, $acw62.useState)(false);
    // Blokada wielokrotnego wysłania: pushing = trwa wysyłka, pushedResult = obiekt
    // przepisu już wysłanego (każda edycja tworzy nowy obiekt, więc porównanie
    // referencji samo odblokowuje przycisk po zmianie przepisu)
    const [pushing, setPushing] = (0, $acw62.useState)(false);
    const [pushedResult, setPushedResult] = (0, $acw62.useState)(null);
    const [pushedUrl, setPushedUrl] = (0, $acw62.useState)(null);
    const pushingRef = (0, $acw62.useRef)(false);
    const [saveSuccess, setSaveSuccess] = (0, $acw62.useState)('');
    const [copiedJSON, setCopiedJSON] = (0, $acw62.useState)(false);
    const [copiedText, setCopiedText] = (0, $acw62.useState)(false);
    const [editing, setEditing] = (0, $acw62.useState)(false);
    const [dirty, setDirty] = (0, $acw62.useState)(false);
    const [showExtModal, setShowExtModal] = (0, $acw62.useState)(false);
    const [cookieBanner, setCookieBanner] = (0, $acw62.useState)(!localStorage.getItem('cookie-accepted'));
    const [copyrightBanner, setCopyrightBanner] = (0, $acw62.useState)(!localStorage.getItem('copyright-accepted'));
    const [extBannerDismissed, setExtBannerDismissed] = (0, $acw62.useState)(!!localStorage.getItem('ext_banner_dismissed'));
    // Banner rozszerzenia wjeżdża z opóźnieniem — przy pierwszym wejściu konkuruje
    // z "Zalogowano!", notką cookies i ostrzeżeniem AI (przegląd UI 2026-06-12)
    const [extBannerReady, setExtBannerReady] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>setExtBannerReady(true), 12000);
        return ()=>clearTimeout(timer);
    }, []);
    const [selectedSteps, setSelectedSteps] = (0, $acw62.useState)(new Set());
    const [fixing, setFixing] = (0, $acw62.useState)(false);
    const [fixNotes, setFixNotes] = (0, $acw62.useState)('');
    const [repairing, setRepairing] = (0, $acw62.useState)(false);
    const [repairInstruction, setRepairInstruction] = (0, $acw62.useState)('');
    const [repairQuestion, setRepairQuestion] = (0, $acw62.useState)('');
    const [repairAnswer, setRepairAnswer] = (0, $acw62.useState)('');
    const [repairHistory, setRepairHistory] = (0, $acw62.useState)([]);
    const [repairSavePrompt, setRepairSavePrompt] = (0, $acw62.useState)(false);
    const [currentSavedId, setCurrentSavedId] = (0, $acw62.useState)(null);
    const [mcPayload, setMcPayload] = (0, $acw62.useState)(null);
    const [funMsgIdx, setFunMsgIdx] = (0, $acw62.useState)(0);
    const [funMsgVisible, setFunMsgVisible] = (0, $acw62.useState)(true);
    const [progress, setProgress] = (0, $acw62.useState)(0);
    const [stageMsg, setStageMsg] = (0, $acw62.useState)('');
    const [savedRecipes, setSavedRecipes] = (0, $acw62.useState)([]);
    const [savedPreview, setSavedPreview] = (0, $acw62.useState)(null);
    const [activeTab, setActiveTab] = (0, $acw62.useState)('converter');
    const [usage, setUsage] = (0, $acw62.useState)(null);
    const resultRef = (0, $acw62.useRef)(null);
    const scrollPendingRef = (0, $acw62.useRef)(false);
    // Scroll to result when it appears in DOM (handles tab-switch delay)
    (0, $acw62.useEffect)(()=>{
        if (result && activeTab === 'converter' && scrollPendingRef.current) {
            scrollPendingRef.current = false;
            setTimeout(()=>resultRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                }), 80);
        }
    }, [
        result,
        activeTab
    ]);
    const loadSavedRecipes = async ()=>{
        try {
            const res = await (0, $dkmhp.aiAPI).getSavedRecipes();
            const list = res.data;
            setSavedRecipes(Array.isArray(list) ? list : []);
        } catch  {}
    };
    const loadUsage = async ()=>{
        try {
            const r = await (0, $dkmhp.aiAPI).getConversionStatus();
            setUsage(r.data);
        } catch  {}
    };
    (0, $acw62.useEffect)(()=>{
        loadSavedRecipes();
        loadUsage();
    }, []);
    // Wznowienie śledzenia wysyłki po przeładowaniu strony. Serwer i tak doprowadzi
    // przepis do końca, ale link musi trafić do użytkownika i do przepiśnika —
    // bez tego zamknięcie karty gubiło wynik gotowej wysyłki.
    (0, $acw62.useEffect)(()=>{
        let stored = null;
        try {
            stored = JSON.parse(localStorage.getItem('mc_push_job') || 'null');
        } catch  {}
        if (!stored?.jobId) return;
        let cancelled = false;
        setBgJob({
            ...stored,
            status: 'waiting'
        });
        (async ()=>{
            const until = Date.now() + 600000;
            while(!cancelled && Date.now() < until){
                try {
                    const st = (await (0, $dkmhp.aiAPI).mcPushStatus(stored.jobId))?.data;
                    if (st?.status === 'done') {
                        localStorage.removeItem('mc_push_job');
                        if (!cancelled) setBgJob({
                            ...stored,
                            status: 'done',
                            url: st.url
                        });
                        if (stored.savedId) try {
                            await (0, $dkmhp.aiAPI).updateSavedRecipe(stored.savedId, {
                                mc_url: st.url,
                                mc_recipe_id: String(st.recipeId || '')
                            });
                            loadSavedRecipes();
                        } catch  {}
                        return;
                    }
                    if (st?.status === 'error' || st?.status === 'unknown') {
                        localStorage.removeItem('mc_push_job');
                        if (!cancelled) setBgJob(null);
                        return;
                    }
                } catch  {}
                await new Promise((r)=>setTimeout(r, 3000));
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, []);
    // Sync app language → mc_locale preference in DB (merge — nie nadpisuje mc_session)
    (0, $acw62.useEffect)(()=>{
        if (!user) return;
        (0, $dkmhp.authAPI).updateProfile({
            preferences: {
                mc_locale: lang
            }
        }).catch(()=>{});
    }, [
        lang
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $acw62.useEffect)(()=>{
        if (!converting) return;
        setFunMsgIdx(Math.floor(Math.random() * convertingMsgs.length));
        setFunMsgVisible(true);
        const interval = setInterval(()=>{
            setFunMsgVisible(false);
            setTimeout(()=>{
                setFunMsgIdx((i)=>(i + 1) % convertingMsgs.length);
                setFunMsgVisible(true);
            }, 400);
        }, 6500);
        return ()=>clearInterval(interval);
    }, [
        converting
    ]);
    const handleConvert = async ()=>{
        if (!prompt.trim()) {
            setError(t('conv.error_empty'));
            return;
        }
        setConverting(true);
        setError('');
        setResult(null);
        setPushSuccess('');
        setSaveSuccess('');
        setCurrentSavedId(null);
        setRepairSavePrompt(false);
        setProgress(0);
        try {
            const res = await (0, $dkmhp.mcAPI).convertRecipe({
                text: prompt,
                lang: lang
            }, (event)=>{
                if (typeof event.progress === 'number') setProgress(event.progress);
                if (event.message) setStageMsg(event.message);
            });
            setProgress(100);
            if (res.success) {
                setResult(res.recipe);
                setMcPayload(res.mc_payload || null);
                setWarnings(res.warnings?.length > 0 ? res.warnings : null);
                if (res.usage) setUsage(res.usage);
                setEditing(false);
                scrollPendingRef.current = true;
                handleSave(res.recipe, res.mc_payload || null);
            } else {
                setError(tErr(res.error) || t('conv.error_conv'));
                if (res.limit_reached) loadUsage();
            }
        } catch (err) {
            setError(tErr(err.message) || t('conv.error_net'));
        } finally{
            setConverting(false);
            setTimeout(()=>setProgress(0), 600);
        }
    };
    const handleImportUrl = async ()=>{
        const url = importUrl.trim();
        if (!url || importing) return;
        setImporting(true);
        setImportMsg('');
        setError('');
        try {
            const res = await (0, $dkmhp.aiAPI).importUrl(url);
            if (res?.data?.text) {
                setPrompt(res.data.text);
                setImportMsg(t('conv.url_ok'));
                setTimeout(()=>setImportMsg(''), 6000);
            } else setError(t('conv.url_error'));
        } catch (err) {
            setError(err.response?.data?.error || t('conv.url_error'));
        } finally{
            setImporting(false);
        }
    };
    const handleOcrFile = async (file)=>{
        if (!file || ocrLoading || converting) return;
        if (!file.type.startsWith('image/')) {
            setError(t('conv.image_err'));
            return;
        }
        setOcrLoading(true);
        setImportMsg('');
        setError('');
        try {
            const res = await (0, $dkmhp.aiAPI).ocrImage(file);
            if (res?.data?.text) {
                setPrompt((prev)=>(prev.trim() ? prev.trim() + '\n\n' : '') + res.data.text);
                setImportMsg(t('conv.image_ok'));
                setTimeout(()=>setImportMsg(''), 6000);
            } else setError(t('conv.image_err'));
        } catch (err) {
            setError(err.response?.data?.error || t('conv.image_err'));
        } finally{
            setOcrLoading(false);
        }
    };
    // Zdjęcie potrawy leci na MC od razu po wybraniu — dzięki temu w chwili wysyłki
    // przepisu miniatura jest już gotowa i nie wydłuża i tak wolnego POST-a.
    const handleDishFile = async (file)=>{
        if (!file || dishUploading) return;
        if (!file.type.startsWith('image/')) {
            setDishError(t('conv.dish_err'));
            return;
        }
        setDishUploading(true);
        setDishError('');
        const localPreview = URL.createObjectURL(file);
        try {
            const res = await (0, $dkmhp.aiAPI).uploadMcImage(file, lang);
            if (res?.data?.success) {
                setDishMedia({
                    detailsMediaId: res.data.detailsMediaId,
                    thumbnailMediaId: res.data.thumbnailMediaId
                });
                setDishPreview(localPreview);
            } else setDishError(res?.data?.error || t('conv.dish_err'));
        } catch (err) {
            setDishError(err.response?.data?.error || t('conv.dish_err'));
        } finally{
            setDishUploading(false);
            if (dishInputRef.current) dishInputRef.current.value = '';
        }
    };
    const clearDishImage = ()=>{
        setDishMedia(null);
        setDishPreview('');
        setDishError('');
        if (dishInputRef.current) dishInputRef.current.value = '';
    };
    const handleImagePaste = (e)=>{
        const item = [
            ...e.clipboardData?.items || []
        ].find((i)=>i.type.startsWith('image/'));
        if (item) {
            e.preventDefault();
            handleOcrFile(item.getAsFile());
        }
    };
    const updateField = (field, value)=>{
        setMcPayload(null);
        setDirty(true);
        setResult((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    const updateIngredient = (idx, field, value)=>{
        setMcPayload(null);
        setDirty(true);
        setResult((prev)=>{
            const ings = [
                ...prev.ingredients
            ];
            ings[idx] = {
                ...ings[idx],
                [field]: value
            };
            return {
                ...prev,
                ingredients: ings
            };
        });
    };
    const addIngredient = ()=>{
        setMcPayload(null);
        setDirty(true);
        setResult((prev)=>({
                ...prev,
                ingredients: [
                    ...prev.ingredients || [],
                    {
                        name: '',
                        quantity: ''
                    }
                ]
            }));
    };
    const removeIngredient = (idx)=>{
        setMcPayload(null);
        setDirty(true);
        setResult((prev)=>({
                ...prev,
                ingredients: prev.ingredients.filter((_, i)=>i !== idx)
            }));
    };
    const updateStep = (idx, field, value)=>{
        setMcPayload(null);
        setDirty(true);
        setResult((prev)=>{
            const steps = [
                ...prev.steps
            ];
            steps[idx] = {
                ...steps[idx],
                [field]: value
            };
            return {
                ...prev,
                steps: steps
            };
        });
    };
    const addStep = ()=>{
        setMcPayload(null);
        setDirty(true);
        setResult((prev)=>({
                ...prev,
                steps: [
                    ...prev.steps || [],
                    {
                        type: 'manual',
                        title: '',
                        description: '',
                        speed: null,
                        temperature: null,
                        time_seconds: null
                    }
                ]
            }));
    };
    const removeStep = (idx)=>{
        setMcPayload(null);
        setDirty(true);
        setResult((prev)=>({
                ...prev,
                steps: prev.steps.filter((_, i)=>i !== idx)
            }));
    };
    const moveStep = (idx, dir)=>{
        setMcPayload(null);
        setDirty(true);
        setResult((prev)=>{
            const steps = [
                ...prev.steps
            ];
            const newIdx = idx + dir;
            if (newIdx < 0 || newIdx >= steps.length) return prev;
            [steps[idx], steps[newIdx]] = [
                steps[newIdx],
                steps[idx]
            ];
            return {
                ...prev,
                steps: steps
            };
        });
    };
    const handlePush = async ()=>{
        // pushingRef chroni przed podwójnym kliknięciem zanim React zdąży przerenderować
        if (!result || pushingRef.current || result === pushedResult) return;
        pushingRef.current = true;
        setPushing(true);
        setPushSuccess('');
        setError('');
        const recipe = result;
        const startedAt = Date.now();
        const finishPush = ()=>{
            pushingRef.current = false;
            setPushing(false);
        };
        // Payload do wysyłki: świeży z konwersji, a po edycji przebudowany przez backend
        // (/ai/mc-rebuild-payload zachowuje tryby dedykowane dzięki ukrytemu mc_mode w krokach).
        // Fallback gdy rebuild padnie: display recipe — wtyczka zbuduje payload sama
        // (tryby dedykowane degradują się wtedy do customized).
        let payloadToSend = mcPayload && mcPayload.servingSizes ? mcPayload : null;
        if (!payloadToSend) try {
            const res = await (0, $dkmhp.aiAPI).rebuildMcPayload(recipe, lang);
            if (res?.data?.mc_payload?.servingSizes) {
                payloadToSend = res.data.mc_payload;
                setMcPayload(payloadToSend);
            }
        } catch  {}
        // Gdy wysyłkę poprowadził serwer, miniatura poszła razem z publikacją —
        // powtórny PUT z przeglądarki byłby tylko zbędnym żądaniem
        let mediaDoneByServer = false;
        // Wspólne zakończenie sukcesem — używane zarówno gdy wtyczka odda wynik,
        // jak i gdy ID przepisu odzyskamy z MC po jej błędzie
        const applyPushSuccess = async (recipeId, extUrl, message)=>{
            setPushedResult(recipe);
            // Link do edytora przepisu (create-recipe), nie do listy moich przepisów —
            // wtyczka zwraca w extUrl ten drugi, więc budujemy URL sami z recipeId
            const url = recipeId ? `https://www.monsieur-cuisine.com/${lang}/create-recipe?recipe-id=${recipeId}` : extUrl;
            // Przycisk "Wyślij na MC" zamienia się w "Otwórz przepis na MC" (render w actions),
            // tu zostaje tylko krótki komunikat
            setPushedUrl(url || null);
            setError('');
            setPushSuccess(message || (url ? t('conv.sent_excl') : t('conv.saved_mc')));
            // Miniatura idzie osobnym PUT-em dopiero teraz, gdy przepis na pewno istnieje.
            // Cicho na porażkę: przepis jest już na koncie, brak zdjęcia nie jest błędem
            // wysyłki i nie ma prawa zamienić sukcesu w komunikat o błędzie.
            if (recipeId && dishMedia && !mediaDoneByServer) try {
                await (0, $dkmhp.aiAPI).attachMcImage(recipeId, payloadToSend || mcPayload, dishMedia, lang);
            } catch  {}
            try {
                const savePayload = {
                    title: recipe.title,
                    recipe: {
                        ...recipe,
                        _mc_payload: payloadToSend || mcPayload,
                        mc_url: url,
                        mc_recipe_id: recipeId
                    },
                    mc_url: url,
                    mc_recipe_id: String(recipeId || '')
                };
                // Bez duplikatu w przepiśniku: gdy przepis ma już zapis, nadpisz go wersją wysłaną
                if (currentSavedId) await (0, $dkmhp.aiAPI).updateSavedRecipe(currentSavedId, savePayload);
                else {
                    const res = await (0, $dkmhp.aiAPI).saveRecipe(savePayload);
                    setCurrentSavedId(res?.data?.id || null);
                }
                loadSavedRecipes();
            } catch  {}
        };
        // ── Wyścig: wtyczka vs. wyszukiwanie przepisu na MC ──────────────────────
        // Wtyczka nie dostaje od MC odpowiedzi z ID (POST create dostaje 502 po 30 s po
        // stronie MC), więc czekanie na nią to czysta strata czasu. Dlatego szukamy
        // przepisu na koncie MC RÓWNOLEGLE z wysyłką, od pierwszych sekund. Kto pierwszy
        // ma ID — wtyczka czy nasze odpytywanie — ten pokazuje link.
        // Offsety w ms od startu wysyłki: gęsto na początku (gdy przepis pojawia się
        // od razu), potem coraz rzadziej, do 5 minut.
        const RECOVER_AT = [];
        for(let ms = 2000; ms <= 30000; ms += 2000)RECOVER_AT.push(ms);
        for(let ms = 35000; ms <= 90000; ms += 5000)RECOVER_AT.push(ms);
        for(let ms = 100000; ms <= 300000; ms += 10000)RECOVER_AT.push(ms);
        // Wynik bierze tylko jedna ścieżka — druga musi się wycofać bez ruszania UI
        let settled = false;
        const claim = ()=>settled ? false : settled = true;
        const succeed = async (recipeId, extUrl, message)=>{
            if (!claim()) return;
            clearTimeout(deadline);
            document.removeEventListener('MC_SEND_RECIPE_RESULT', onResult);
            await applyPushSuccess(recipeId, extUrl, message);
            setPushChecking(false);
            finishPush();
        };
        const fail = (message)=>{
            if (!claim()) return;
            clearTimeout(deadline);
            document.removeEventListener('MC_SEND_RECIPE_RESULT', onResult);
            setPushChecking(false);
            setError(message);
            finishPush();
        };
        const pollForRecipe = async ()=>{
            for (const at of RECOVER_AT){
                const wait = at - (Date.now() - startedAt);
                if (wait > 0) await new Promise((r)=>setTimeout(r, wait));
                if (settled) return;
                // Okno szukania = czas od startu wysyłki + minuta zapasu, żeby nie podłapać
                // starszej kopii tego samego przepisu sprzed godziny
                const within = Math.max(2, Math.ceil((Date.now() - startedAt) / 60000) + 1);
                try {
                    const res = await (0, $dkmhp.aiAPI).recoverMcPush(recipe.title, payloadToSend || mcPayload, lang, within);
                    if (res?.data?.found && res.data.recipeId) {
                        await succeed(res.data.recipeId, res.data.url, t('conv.sent_excl'));
                        return;
                    }
                } catch  {}
            }
            fail(t('conv.error_ext'));
        };
        // Ostateczny bezpiecznik — odpytywanie kończy się samo, to tylko siatka pod nim
        const deadline = setTimeout(()=>fail(t('conv.error_ext')), 320000);
        const onResult = (e)=>{
            if (e.detail?.success) {
                succeed(e.detail.recipeId, e.detail.url);
                return;
            }
            // Błąd wtyczki NIE kończy wysyłki — przepis zwykle i tak powstaje na MC,
            // więc oddajemy sprawę odpytywaniu i zmieniamy tylko komunikat
            if (!settled) setPushChecking('ext');
        };
        // ── Ścieżka główna: wysyłka w tle po stronie serwera ─────────────────────
        // MC i tak potrzebuje ~2 minut na utworzenie przepisu, a odpowiedź POST-a nigdy
        // nie przynosi ID (MC zrywa połączenie po 30 s). Serwer robi to za nas i pilnuje
        // sprawy do końca — użytkownik odzyskuje stronę od razu i może ją zamknąć.
        if (payloadToSend) try {
            const res = await (0, $dkmhp.aiAPI).pushMcAsync(payloadToSend, lang, dishMedia);
            const jobId = res?.data?.job_id;
            if (jobId) {
                mediaDoneByServer = !!dishMedia;
                // 'server' = inny komunikat: tu wolno zamknąć stronę, wtyczka nie brała udziału
                setPushChecking('server');
                // Ślad przeżyje zamknięcie karty — po powrocie odbierzemy link
                try {
                    localStorage.setItem('mc_push_job', JSON.stringify({
                        jobId: jobId,
                        title: recipe.title,
                        savedId: currentSavedId
                    }));
                } catch  {}
                const untilMs = Date.now() + 480000;
                const watchJob = async ()=>{
                    while(Date.now() < untilMs && !settled){
                        await new Promise((r)=>setTimeout(r, 2000));
                        if (settled) return;
                        try {
                            const st = (await (0, $dkmhp.aiAPI).mcPushStatus(jobId))?.data;
                            if (st?.status === 'done') {
                                try {
                                    localStorage.removeItem('mc_push_job');
                                } catch  {}
                                await succeed(st.recipeId, st.url, t('conv.sent_excl'));
                                return;
                            }
                            if (st?.status === 'error') {
                                try {
                                    localStorage.removeItem('mc_push_job');
                                } catch  {}
                                break;
                            }
                        } catch  {}
                    }
                    // Serwer nie dowiózł — oddajemy sprawę wtyczce i odpytywaniu jak dawniej
                    if (!settled) {
                        setPushChecking('ext');
                        document.addEventListener('MC_SEND_RECIPE_RESULT', onResult);
                        pollForRecipe();
                        document.dispatchEvent(new CustomEvent('MC_SEND_RECIPE', {
                            detail: {
                                recipe: payloadToSend,
                                lang: lang
                            }
                        }));
                    }
                };
                watchJob();
                return;
            }
        } catch  {}
        document.addEventListener('MC_SEND_RECIPE_RESULT', onResult);
        pollForRecipe();
        // Gotowy payload — rozszerzenie wykrywa go po polu servingSizes i wysyła bez przebudowy
        if (payloadToSend) {
            document.dispatchEvent(new CustomEvent('MC_SEND_RECIPE', {
                detail: {
                    recipe: payloadToSend,
                    lang: lang
                }
            }));
            return;
        }
        // Dodaj categories żeby rozszerzenie Chrome wybrało właściwy ID (r.categories || [262])
        const recipeWithCategory = {
            ...recipe,
            categories: $042abebcecde25e2$var$resolveCategoryIds(recipe.category)
        };
        document.dispatchEvent(new CustomEvent('MC_SEND_RECIPE', {
            detail: {
                recipe: recipeWithCategory,
                lang: lang
            }
        }));
    };
    const handleSave = async (recipeOverride, payloadOverride, replaceId = null)=>{
        const recipeData = recipeOverride || result;
        const payloadData = payloadOverride !== undefined ? payloadOverride : mcPayload;
        if (!recipeData) return;
        setSaving(true);
        setSaveSuccess('');
        try {
            const payload = {
                title: recipeData.title,
                recipe: {
                    ...recipeData,
                    _mc_payload: payloadData
                }
            };
            // replaceId = stary zapis do usunięcia (wywołanie z repair-save-prompt)
            if (replaceId) {
                await (0, $dkmhp.aiAPI).deleteSavedRecipe(replaceId);
                const res = await (0, $dkmhp.aiAPI).saveRecipe(payload);
                setCurrentSavedId(res?.data?.id || null);
            } else if (currentSavedId) // Przepis już zapisany — aktualizuj zamiast tworzyć duplikat
            await (0, $dkmhp.aiAPI).updateSavedRecipe(currentSavedId, payload);
            else {
                // Pierwszy zapis
                const res = await (0, $dkmhp.aiAPI).saveRecipe(payload);
                setCurrentSavedId(res?.data?.id || null);
            }
            setSaveSuccess(t('conv.save_ok'));
            setTimeout(()=>setSaveSuccess(''), 4000);
            loadSavedRecipes();
        } catch (err) {
            setError(tErr(err.response?.data?.error) || t('conv.error_save'));
        } finally{
            setSaving(false);
        }
    };
    // Przepis wczytany przez admina z panelu (cudzy) — id zerowane, żeby
    // "Zapisz" utworzył kopię na koncie admina zamiast PUT-ować cudzy rekord
    (0, $acw62.useEffect)(()=>{
        if (externalRecipe) handleLoadSaved({
            ...externalRecipe,
            id: null
        });
    }, [
        externalRecipe
    ]);
    const handleLoadSaved = (saved)=>{
        setSavedPreview(null);
        try {
            const raw = saved.recipe || (typeof saved.recipe_data === 'string' ? JSON.parse(saved.recipe_data) : saved.recipe_data);
            const { _mc_payload: _mc_payload, ...recipe } = raw;
            setResult(recipe);
            setMcPayload(_mc_payload || null);
            setCurrentSavedId(saved.id || null);
            setRepairSavePrompt(false);
            setEditing(false);
            setPrompt('');
            setError('');
            setPushSuccess('');
            setSaveSuccess('');
            setSelectedSteps(new Set());
            clearDishImage();
            scrollPendingRef.current = true;
            setActiveTab('converter');
        } catch  {
            setError(t('conv.error_load'));
        }
    };
    const handleDeleteSaved = async (id, e)=>{
        e.stopPropagation();
        try {
            const { aiAPI: aiAPI } = await Promise.resolve((parcelRequire("dkmhp")));
            await aiAPI.deleteSavedRecipe(id);
            setSavedRecipes((prev)=>prev.filter((r)=>r.id !== id));
            if (savedPreview?.id === id) setSavedPreview(null);
        } catch  {}
    };
    const resetAll = ()=>{
        setPrompt('');
        setResult(null);
        setMcPayload(null);
        setEditing(false);
        setError('');
        setPushSuccess('');
        setSaveSuccess('');
        setSelectedSteps(new Set());
        setFixNotes('');
        setCurrentSavedId(null);
        setPushedResult(null);
        setPushedUrl(null);
        clearDishImage();
    };
    const toggleStep = (idx)=>{
        setSelectedSteps((prev)=>{
            const next = new Set(prev);
            if (next.has(idx)) next.delete(idx);
            else next.add(idx);
            return next;
        });
    };
    const handleFixSteps = async ()=>{
        if (!result || selectedSteps.size === 0) return;
        setFixing(true);
        setError('');
        try {
            const res = await (0, $dkmhp.mcAPI).fixSteps({
                recipe: result,
                fix_indices: [
                    ...selectedSteps
                ],
                notes: fixNotes
            });
            if (res.success && res.new_steps) {
                setMcPayload(null);
                setResult((prev)=>{
                    const newSteps = [
                        ...prev.steps
                    ];
                    res.new_steps.forEach((ns, i)=>{
                        const idx = res.fix_indices?.[i];
                        if (idx != null && idx < newSteps.length) newSteps[idx] = ns;
                    });
                    return {
                        ...prev,
                        steps: newSteps
                    };
                });
                setSelectedSteps(new Set());
                setFixNotes('');
            } else setError(tErr(res.error) || t('conv.error_conv'));
        } catch (err) {
            setError(tErr(err.message) || t('conv.error_net'));
        } finally{
            setFixing(false);
        }
    };
    const handleRepair = async (isAnswer = false)=>{
        if (!result) return;
        const instruction = isAnswer ? repairAnswer : repairInstruction;
        if (!instruction.trim()) return;
        setRepairing(true);
        setError('');
        setSaveSuccess('');
        try {
            // Historia: gdy odpowiadamy na pytanie AI, budujemy pełny dialog
            // [user: oryginalna instrukcja, assistant: pytanie, user: odpowiedź]
            // Backend oczekuje że history[0] to oryginalna instrukcja użytkownika
            const history = isAnswer ? [
                ...repairHistory,
                {
                    role: 'assistant',
                    content: repairQuestion
                }
            ] : [];
            const res = await (0, $dkmhp.mcAPI).repairRecipe({
                recipe: result,
                instruction: isAnswer ? repairAnswer : instruction,
                selected_steps: isAnswer ? [] : [
                    ...selectedSteps
                ],
                history: history
            });
            if (!res || typeof res !== 'object') {
                setError("Serwer nie odpowiedzia\u0142 poprawnie");
                return;
            }
            if (res.action === 'question') {
                setRepairQuestion(res.question || '?');
                if (!isAnswer) setRepairHistory([
                    {
                        role: 'user',
                        content: instruction
                    }
                ]);
                setRepairAnswer('');
            } else if (res.action === 'fix' && res.recipe) {
                setResult(res.recipe);
                setMcPayload(null);
                setRepairInstruction('');
                setRepairQuestion('');
                setRepairAnswer('');
                setRepairHistory([]);
                setSelectedSteps(new Set());
                setRepairSavePrompt(true);
            } else setError(res.error || `Nieoczekiwana odpowied\u{17A}: ${JSON.stringify(res).slice(0, 100)}`);
        } catch (err) {
            setError(err.message || t('conv.error_net'));
        } finally{
            setRepairing(false);
        }
    };
    const copyJSON = async ()=>{
        if (!result) return;
        await navigator.clipboard.writeText(JSON.stringify(result, null, 2));
        setCopiedJSON(true);
        setTimeout(()=>setCopiedJSON(false), 2000);
    };
    const copyText = async ()=>{
        if (!result) return;
        const d = result;
        let txt = `${d.title}\n${'='.repeat((d.title || '').length || 10)}\n\n${t('conv.ingredients')}:\n`;
        txt += (d.ingredients || []).map((i)=>`\u{2022} ${i.name}: ${i.quantity}`).join('\n');
        txt += `\n\n${t('conv.steps_title')}:\n` + (d.steps || []).map((s, i)=>{
            let l = `${i + 1}. [${(s.type || 'MANUAL').toUpperCase()}] ${s.title}`;
            if (s.temperature) l += ` | ${s.temperature}\xb0C`;
            if (s.speed != null) l += ` | ${t('conv.speed')} ${s.speed}`;
            if (s.time_seconds) l += ` | ${s.time_seconds >= 60 ? `${Math.floor(s.time_seconds / 60)} min ${s.time_seconds % 60}s` : `${s.time_seconds}s`}`;
            return l;
        }).join('\n');
        await navigator.clipboard.writeText(txt);
        setCopiedText(true);
        setTimeout(()=>setCopiedText(false), 2000);
    };
    const typeIcon = (type)=>{
        switch(type){
            case 'cook':
                return 'fas fa-fire';
            case 'mix':
                return 'fas fa-blender';
            case 'weigh':
                return 'fas fa-weight';
            default:
                return 'fas fa-hand-point-right';
        }
    };
    const cycleStepType = (idx)=>{
        setMcPayload(null);
        setDirty(true);
        setResult((prev)=>{
            const steps = [
                ...prev.steps
            ];
            const types = [
                'manual',
                'mix',
                'cook',
                'weigh'
            ];
            const cur = types.indexOf(steps[idx].type);
            steps[idx] = {
                ...steps[idx],
                type: types[(cur + 1) % types.length]
            };
            return {
                ...prev,
                steps: steps
            };
        });
    };
    const difficultyLabel = (d)=>{
        if (d === 'hard') return t('conv.difficulty_hard');
        if (d === 'medium') return t('conv.difficulty_medium');
        return t('conv.difficulty_easy');
    };
    const fixStepsLabel = (n)=>{
        if (n === 1) return t('conv.fix_step');
        if (n < 5) return t('conv.fix_steps_few');
        return t('conv.fix_steps_many');
    };
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const dismissExtBanner = ()=>{
        localStorage.setItem('ext_banner_dismissed', '1');
        setExtBannerDismissed(true);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "convert-v2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "convert-tabs",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: `convert-tab ${activeTab === 'converter' ? 'convert-tab--active' : ''}`,
                        onClick: ()=>setActiveTab('converter'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-blender"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "convert-tab-label--full",
                                children: t('conv.title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "convert-tab-label--short",
                                children: t('conv.title_short')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: `convert-tab ${activeTab === 'saved' ? 'convert-tab--active' : ''}`,
                        onClick: ()=>setActiveTab('saved'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-bookmark"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "convert-tab-label--full",
                                children: t('saved.title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "convert-tab-label--short",
                                children: t('saved.title_short')
                            }),
                            savedRecipes.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "convert-tab-badge",
                                children: savedRecipes.length
                            })
                        ]
                    })
                ]
            }),
            activeTab === 'saved' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "saved-tab-view",
                children: savedRecipes.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "saved-empty",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: "fas fa-bookmark"
                        }),
                        " ",
                        t('saved.empty')
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "saved-recipes-list",
                    children: savedRecipes.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "saved-recipe-card",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "saved-recipe-info",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "saved-recipe-name",
                                            children: r.title
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "saved-recipe-date",
                                            children: new Date(r.created_at).toLocaleDateString()
                                        }),
                                        r.mc_url && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                            className: "saved-recipe-mc-link",
                                            href: r.mc_url,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-external-link-alt"
                                                }),
                                                " MC"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "saved-recipe-actions",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            className: "btn btn-xs btn-outline",
                                            onClick: ()=>setSavedPreview(r),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-eye"
                                                }),
                                                " ",
                                                t('saved.preview')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            className: "btn btn-xs btn-primary",
                                            onClick: ()=>handleLoadSaved(r),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-upload"
                                                }),
                                                " ",
                                                t('saved.load')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "btn btn-xs btn-danger",
                                            onClick: (e)=>handleDeleteSaved(r.id, e),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-trash"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, r.id))
                })
            }),
            user && !mcSession && onMcConnect && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ext-store-banner",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-link ext-store-banner__icon"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ext-store-banner__text",
                        children: t('conv.mc_connect_note')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: "btn btn-primary ext-store-banner__cta",
                        onClick: onMcConnect,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-link"
                            }),
                            " ",
                            t('conv.mc_connect_btn')
                        ]
                    })
                ]
            }),
            !mcSession && !isMobile && !extBannerDismissed && extBannerReady && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ext-store-banner",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-puzzle-piece ext-store-banner__icon"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ext-store-banner__text",
                        children: t('ext.banner_text')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                        className: "btn btn-primary ext-store-banner__cta",
                        href: $042abebcecde25e2$var$CHROME_STORE_URL,
                        target: "_blank",
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fab fa-chrome"
                            }),
                            " ",
                            t('ext.banner_cta')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "ext-store-banner__close",
                        onClick: dismissExtBanner,
                        "aria-label": "Zamknij",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: "fas fa-times"
                        })
                    })
                ]
            }),
            bgJob && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `convert-bgjob ${bgJob.status === 'done' ? 'convert-bgjob--done' : ''}`,
                children: [
                    bgJob.status === 'done' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-check-circle"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    t('conv.bg_done'),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: bgJob.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                className: "btn btn-primary btn-xs",
                                href: bgJob.url,
                                target: "_blank",
                                rel: "noreferrer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-external-link-alt"
                                    }),
                                    " ",
                                    t('conv.open_mc')
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-spinner fa-spin"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    t('conv.bg_waiting'),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: bgJob.title
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "convert-bgjob-x",
                        onClick: ()=>setBgJob(null),
                        "aria-label": "X",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: "fas fa-times"
                        })
                    })
                ]
            }),
            activeTab === 'converter' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "convert-v2-inner",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "convert-v2-left",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "convert-v2-header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-blender"
                                            }),
                                            " ",
                                            t('conv.title')
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "convert-v2-sub",
                                        children: t('conv.sub')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mc-session-bar",
                                children: mcSession ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mc-session-connected",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-check-circle"
                                                }),
                                                " ",
                                                t('conv.mc_connected')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            className: "mc-locale-select",
                                            value: lang,
                                            onChange: (e)=>changeLang(e.target.value),
                                            title: t('conv.mc_locale_title'),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "pl",
                                                    children: "\uD83C\uDDF5\uD83C\uDDF1 PL"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "en",
                                                    children: "\uD83C\uDDEC\uD83C\uDDE7 EN"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "de",
                                                    children: "\uD83C\uDDE9\uD83C\uDDEA DE"
                                                })
                                            ]
                                        })
                                    ]
                                }) : isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mc-session-disconnected",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-mobile-alt"
                                            }),
                                            " ",
                                            t('conv.mobile_no_session')
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mc-session-disconnected",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-plug"
                                            }),
                                            " ",
                                            t('conv.install_ext'),
                                            " \u2014 ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "ext-install-link",
                                                onClick: ()=>setShowExtModal(true),
                                                children: t('ext.title').split(' ')[0]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "convert-prompt-stage",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "convert-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "convert-label",
                                                children: t('conv.url_label')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "convert-url-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        className: "convert-input",
                                                        type: "url",
                                                        value: importUrl,
                                                        onChange: (e)=>setImportUrl(e.target.value),
                                                        onKeyDown: (e)=>{
                                                            if (e.key === 'Enter') handleImportUrl();
                                                        },
                                                        placeholder: t('conv.url_placeholder'),
                                                        disabled: importing || converting
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "btn btn-secondary",
                                                        onClick: handleImportUrl,
                                                        disabled: importing || converting || !importUrl.trim(),
                                                        children: importing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "fas fa-spinner fa-spin"
                                                                }),
                                                                " ",
                                                                t('conv.url_loading')
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "fas fa-link"
                                                                }),
                                                                " ",
                                                                t('conv.url_btn')
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            importMsg && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "convert-url-ok",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                        className: "fas fa-check"
                                                    }),
                                                    " ",
                                                    importMsg
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "convert-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "convert-label",
                                                children: t('conv.image_label')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                ref: ocrInputRef,
                                                type: "file",
                                                accept: "image/*",
                                                style: {
                                                    display: 'none'
                                                },
                                                onChange: (e)=>{
                                                    handleOcrFile(e.target.files?.[0]);
                                                    e.target.value = '';
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "btn btn-secondary",
                                                onClick: ()=>ocrInputRef.current?.click(),
                                                disabled: ocrLoading || converting,
                                                children: ocrLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-spinner fa-spin"
                                                        }),
                                                        " ",
                                                        t('conv.image_loading')
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-image"
                                                        }),
                                                        " ",
                                                        t('conv.image_btn')
                                                    ]
                                                })
                                            }),
                                            (0, $5a6742a4b36362a4$export$1efe58f5634014d1)() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        ref: cameraInputRef,
                                                        type: "file",
                                                        accept: "image/*",
                                                        capture: "environment",
                                                        style: {
                                                            display: 'none'
                                                        },
                                                        onChange: (e)=>{
                                                            handleOcrFile(e.target.files?.[0]);
                                                            e.target.value = '';
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        className: "btn btn-secondary",
                                                        onClick: ()=>cameraInputRef.current?.click(),
                                                        disabled: ocrLoading || converting,
                                                        style: {
                                                            marginTop: '8px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                className: "fas fa-camera"
                                                            }),
                                                            " ",
                                                            t('conv.image_camera')
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "convert-hint",
                                                children: t('conv.image_hint')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "convert-field",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "convert-label",
                                                children: t('conv.paste_label')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                className: "convert-textarea convert-textarea--lg",
                                                value: prompt,
                                                onChange: (e)=>setPrompt(e.target.value),
                                                onPaste: handleImagePaste,
                                                placeholder: t('conv.paste_placeholder'),
                                                rows: 10,
                                                disabled: converting
                                            })
                                        ]
                                    }),
                                    usage && !usage.unlimited && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `conversion-usage ${usage.remaining === 0 ? 'conversion-usage-full' : usage.remaining <= 2 ? 'conversion-usage-warn' : ''}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "conversion-usage-bar-wrap",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "conversion-usage-bar",
                                                    style: {
                                                        width: `${Math.min(100, Math.round(usage.count / usage.limit * 100))}%`
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "conversion-usage-text",
                                                children: usage.remaining === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-lock"
                                                        }),
                                                        " ",
                                                        t('conv.limit_exhausted'),
                                                        " (",
                                                        usage.count,
                                                        "/",
                                                        usage.limit,
                                                        ")",
                                                        usage.reset_at ? ` \u{2014} ${t('conv.limit_renews')} ${new Date(usage.reset_at).toLocaleDateString()}` : ''
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-chart-bar"
                                                        }),
                                                        " ",
                                                        usage.count,
                                                        "/",
                                                        usage.limit,
                                                        " ",
                                                        t('conv.limit_usage'),
                                                        " (",
                                                        usage.remaining,
                                                        " ",
                                                        t('conv.limit_left'),
                                                        ")"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "btn btn-primary convert-btn",
                                        onClick: handleConvert,
                                        disabled: converting || usage && !usage.unlimited && usage.remaining === 0,
                                        children: converting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-spinner fa-spin"
                                                }),
                                                " ",
                                                t('conv.converting')
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-robot"
                                                }),
                                                " ",
                                                t('conv.convert_btn')
                                            ]
                                        })
                                    }),
                                    converting && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "convert-progress-wrap",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "convert-progress-bar",
                                                style: {
                                                    width: `${progress}%`
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "convert-progress-pct",
                                                children: [
                                                    progress,
                                                    "%"
                                                ]
                                            }),
                                            stageMsg && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "convert-progress-stage",
                                                children: stageMsg
                                            })
                                        ]
                                    }),
                                    converting && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `convert-fun-msg ${funMsgVisible ? 'convert-fun-msg--in' : 'convert-fun-msg--out'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-hat-chef"
                                            }),
                                            " ",
                                            convertingMsgs[funMsgIdx]
                                        ]
                                    }),
                                    result && !converting && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: "convert-link",
                                        onClick: resetAll,
                                        style: {
                                            textAlign: 'center',
                                            display: 'block',
                                            marginTop: 6
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-undo"
                                            }),
                                            " ",
                                            t('conv.reset')
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "convert-warning",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-exclamation-triangle"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: t('conv.warning')
                                            })
                                        ]
                                    }),
                                    error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mc-error",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-exclamation-circle"
                                            }),
                                            " ",
                                            error
                                        ]
                                    })
                                ]
                            }),
                            saveSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "convert-push-ok",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-bookmark"
                                    }),
                                    " ",
                                    saveSuccess
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "convert-v2-right",
                        ref: resultRef,
                        children: !result ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "convert-empty",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "fas fa-robot"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        t('conv.empty_hint1'),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: t('conv.empty_hint2')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "convert-empty-hint",
                                    children: t('conv.empty_hint3')
                                }),
                                !mcSession && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "convert-empty-mc-note",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-info-circle"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: onMcConnect ? t('conv.mc_connect_note') : t('conv.empty_mc_note')
                                        })
                                    ]
                                }),
                                !mcSession && onMcConnect && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "btn btn-primary btn-xs",
                                    onClick: onMcConnect,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-link"
                                        }),
                                        " ",
                                        t('conv.mc_connect_btn')
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: `convert-result ${editing ? 'is-editing' : ''}`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "convert-result-header",
                                    children: [
                                        editing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            className: "convert-edit-title",
                                            value: result.title || '',
                                            onChange: (e)=>updateField('title', e.target.value)
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            children: result.title || t('conv.recipe_default')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "convert-result-meta-tags",
                                            children: [
                                                result.category && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "convert-tag convert-tag--category",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-tag"
                                                        }),
                                                        " ",
                                                        result.category
                                                    ]
                                                }),
                                                result.complexity && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: `convert-tag convert-tag--${result.complexity}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-signal"
                                                        }),
                                                        " ",
                                                        difficultyLabel(result.complexity)
                                                    ]
                                                })
                                            ]
                                        }),
                                        warnings && warnings.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "convert-warnings",
                                            children: warnings.map((w, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-exclamation-circle"
                                                        }),
                                                        " ",
                                                        w
                                                    ]
                                                }, i))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "convert-result-actions",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    className: "btn btn-secondary btn-xs",
                                                    onClick: ()=>{
                                                        setEditing(!editing);
                                                        setDirty(false);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: `fas ${editing ? 'fa-check' : 'fa-edit'}`
                                                        }),
                                                        " ",
                                                        editing ? t('conv.save_changes') : t('conv.edit')
                                                    ]
                                                }),
                                                user?.is_admin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            className: `btn btn-secondary btn-xs ${copiedJSON ? 'btn-copied' : ''}`,
                                                            onClick: copyJSON,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: copiedJSON ? 'fas fa-check' : 'fas fa-copy'
                                                                }),
                                                                " JSON"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            className: `btn btn-secondary btn-xs ${copiedText ? 'btn-copied' : ''}`,
                                                            onClick: copyText,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: copiedText ? 'fas fa-check' : 'fas fa-clipboard'
                                                                }),
                                                                " ",
                                                                t('saved.preview').split('')[0] === 'P' ? 'Tekst' : 'Text'
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    className: "btn btn-secondary btn-xs",
                                                    onClick: ()=>handleSave(),
                                                    disabled: saving,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: saving ? 'fas fa-spinner fa-spin' : 'fas fa-bookmark'
                                                        }),
                                                        " ",
                                                        t('conv.save')
                                                    ]
                                                }),
                                                !mcSession && onMcConnect && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    className: "btn btn-primary btn-xs",
                                                    onClick: onMcConnect,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-link"
                                                        }),
                                                        " ",
                                                        t('conv.mc_connect_btn')
                                                    ]
                                                }),
                                                mcSession && (result === pushedResult && pushedUrl ? // Po wysłaniu przycisk wysyłki zamienia się w link do przepisu na MC
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                    className: "btn btn-primary btn-xs btn-open-mc",
                                                    href: pushedUrl,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-external-link-alt"
                                                        }),
                                                        " ",
                                                        t('conv.open_mc')
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    className: `btn btn-primary btn-xs btn-push-mc ${!pushing && result !== pushedResult ? 'btn-push-mc--pulse' : ''}`,
                                                    onClick: handlePush,
                                                    disabled: pushing || result === pushedResult,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: pushing ? 'fas fa-spinner fa-spin' : result === pushedResult ? 'fas fa-check' : 'fas fa-upload'
                                                        }),
                                                        ' ',
                                                        pushChecking ? t('conv.checking_mc_btn') : pushing ? t('conv.sending_mc') : result === pushedResult ? t('conv.sent_mc') : t('conv.send_mc')
                                                    ]
                                                }))
                                            ]
                                        }),
                                        pushChecking && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "convert-push-ok convert-push-ok--result",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-spinner fa-spin"
                                                }),
                                                ' ',
                                                t(pushChecking === 'server' ? 'conv.checking_srv' : 'conv.checking_mc')
                                            ]
                                        }),
                                        pushSuccess && !pushChecking && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "convert-push-ok convert-push-ok--result",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-check-circle"
                                                }),
                                                " ",
                                                pushSuccess
                                            ]
                                        })
                                    ]
                                }),
                                mcSession && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "convert-dish",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "file",
                                            ref: dishInputRef,
                                            accept: "image/*",
                                            style: {
                                                display: 'none'
                                            },
                                            onChange: (e)=>handleDishFile(e.target.files?.[0])
                                        }),
                                        dishPreview ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "convert-dish-set",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "convert-dish-thumb",
                                                    src: dishPreview,
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "convert-dish-ok",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-check-circle"
                                                        }),
                                                        " ",
                                                        t('conv.dish_ok')
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    className: "btn btn-secondary btn-xs",
                                                    onClick: clearDishImage,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-times"
                                                        }),
                                                        " ",
                                                        t('conv.dish_remove')
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            className: "btn btn-secondary btn-xs",
                                            onClick: ()=>dishInputRef.current?.click(),
                                            disabled: dishUploading,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: dishUploading ? 'fas fa-spinner fa-spin' : 'fas fa-camera'
                                                }),
                                                ' ',
                                                dishUploading ? t('conv.dish_loading') : t('conv.dish_btn')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "convert-dish-hint",
                                            children: dishError || t('conv.dish_hint')
                                        })
                                    ]
                                }),
                                mcSession && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "convert-safety",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-shield-alt"
                                        }),
                                        " ",
                                        t('conv.safety')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "convert-result-meta",
                                    children: [
                                        result.servings && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-users"
                                                }),
                                                " ",
                                                result.servings,
                                                " ",
                                                t('conv.servings')
                                            ]
                                        }),
                                        result.total_time_minutes && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "far fa-clock"
                                                }),
                                                " ",
                                                result.total_time_minutes,
                                                " min"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-robot"
                                                }),
                                                " ",
                                                result.steps?.length || 0,
                                                " ",
                                                t('conv.steps_count')
                                            ]
                                        })
                                    ]
                                }),
                                result.ingredients?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "convert-ing-block",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                            children: [
                                                t('conv.ingredients'),
                                                " ",
                                                editing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "btn btn-xs btn-secondary",
                                                    onClick: addIngredient,
                                                    style: {
                                                        marginLeft: 8
                                                    },
                                                    children: t('conv.add')
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                            children: result.ingredients.map((ing, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: editing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                className: "convert-edit-ing-name",
                                                                value: ing.name || '',
                                                                onChange: (e)=>updateIngredient(i, 'name', e.target.value),
                                                                placeholder: t('conv.ing_name_ph')
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                className: "convert-edit-ing-qty",
                                                                value: ing.quantity || '',
                                                                onChange: (e)=>updateIngredient(i, 'quantity', e.target.value),
                                                                placeholder: t('conv.ing_qty_ph')
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: "convert-edit-remove",
                                                                onClick: ()=>removeIngredient(i),
                                                                title: t('delete'),
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "fas fa-times"
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: ing.name
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "convert-ing-qty",
                                                                children: ing.quantity
                                                            })
                                                        ]
                                                    })
                                                }, i))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                    children: [
                                        t('conv.steps_title'),
                                        " ",
                                        editing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "btn btn-xs btn-secondary",
                                            onClick: addStep,
                                            style: {
                                                marginLeft: 8
                                            },
                                            children: t('conv.add')
                                        })
                                    ]
                                }),
                                result.steps?.map((step, i)=>{
                                    const typeCls = step.type === 'cook' ? 'cook' : step.type === 'mix' ? 'mix' : step.type === 'weigh' ? 'weigh' : 'manual';
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `convert-step convert-step--${typeCls}`,
                                        children: editing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "convert-step-edit",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "convert-step-edit-top",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            className: "convert-edit-type",
                                                            onClick: ()=>cycleStepType(i),
                                                            title: t('conv.edit'),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: typeIcon(step.type)
                                                                }),
                                                                " ",
                                                                step.type
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            className: "convert-edit-title",
                                                            value: step.title || '',
                                                            onChange: (e)=>updateStep(i, 'title', e.target.value),
                                                            placeholder: t('conv.step_title_ph')
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "convert-step-edit-arrows",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    onClick: ()=>moveStep(i, -1),
                                                                    disabled: i === 0,
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                        className: "fas fa-chevron-up"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    onClick: ()=>moveStep(i, 1),
                                                                    disabled: i === result.steps.length - 1,
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                        className: "fas fa-chevron-down"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: "convert-edit-remove",
                                                                    onClick: ()=>removeStep(i),
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                        className: "fas fa-times"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                    className: "convert-edit-desc",
                                                    value: step.description || '',
                                                    onChange: (e)=>updateStep(i, 'description', e.target.value),
                                                    placeholder: t('conv.step_desc_ph'),
                                                    rows: 2
                                                }),
                                                (step.type === 'cook' || step.type === 'mix') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "convert-edit-params",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            children: [
                                                                t('conv.temp'),
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    type: "number",
                                                                    value: step.temperature || '',
                                                                    onChange: (e)=>updateStep(i, 'temperature', e.target.value ? parseInt(e.target.value) : null),
                                                                    placeholder: "\xb0C"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            children: [
                                                                t('conv.speed'),
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    type: "number",
                                                                    value: step.speed != null ? step.speed : '',
                                                                    onChange: (e)=>updateStep(i, 'speed', e.target.value ? parseInt(e.target.value) : null),
                                                                    placeholder: "1-10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                            children: [
                                                                t('conv.time'),
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    type: "number",
                                                                    value: step.time_seconds || '',
                                                                    onChange: (e)=>updateStep(i, 'time_seconds', e.target.value ? parseInt(e.target.value) : null),
                                                                    placeholder: "s"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "convert-step-head",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            className: "convert-step-check",
                                                            onClick: (e)=>e.stopPropagation(),
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "checkbox",
                                                                checked: selectedSteps.has(i),
                                                                onChange: ()=>toggleStep(i)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "convert-step-num",
                                                            children: i + 1
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "convert-step-title",
                                                            children: step.title || step.description
                                                        })
                                                    ]
                                                }),
                                                step.description && step.description !== step.title && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "convert-step-desc",
                                                    children: step.description
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "convert-step-params",
                                                    children: [
                                                        step.type === 'weigh' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "convert-pill convert-pill--weigh",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "fas fa-weight"
                                                                }),
                                                                " ",
                                                                t('conv.step_weigh'),
                                                                step.weight ? ` \xb7 ${step.weight} g` : ''
                                                            ]
                                                        }),
                                                        step.type === 'manual' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "convert-pill convert-pill--manual",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "fas fa-hand-paper"
                                                                }),
                                                                " ",
                                                                t('conv.step_manual')
                                                            ]
                                                        }),
                                                        step.temperature && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "convert-pill convert-pill--temp",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "fas fa-thermometer-half"
                                                                }),
                                                                " ",
                                                                step.temperature,
                                                                "\xb0C"
                                                            ]
                                                        }),
                                                        step.speed != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "convert-pill convert-pill--speed",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "fas fa-tachometer-alt"
                                                                }),
                                                                " ",
                                                                t('conv.speed'),
                                                                " ",
                                                                step.speed
                                                            ]
                                                        }),
                                                        step.time_seconds && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "convert-pill convert-pill--time",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "far fa-clock"
                                                                }),
                                                                " ",
                                                                step.time_seconds >= 60 ? `${Math.floor(step.time_seconds / 60)}m ${step.time_seconds % 60 > 0 ? step.time_seconds % 60 + 's' : ''}`.trim() : `${step.time_seconds}s`
                                                            ]
                                                        }),
                                                        step.direction === 'clockwise' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "convert-pill convert-pill--dir",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "fas fa-redo"
                                                                }),
                                                                " w prawo"
                                                            ]
                                                        }),
                                                        step.direction === 'counter_clockwise' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "convert-pill convert-pill--dir-rev",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "fas fa-undo"
                                                                }),
                                                                " reverse"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, i);
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "convert-repair-bar",
                                    children: repairSavePrompt ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "convert-repair-save-prompt",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                        className: "fas fa-check-circle",
                                                        style: {
                                                            color: 'var(--success)'
                                                        }
                                                    }),
                                                    " ",
                                                    t('conv.repair_ok'),
                                                    " ",
                                                    t('conv.repair_save_ask')
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    gap: '6px',
                                                    marginTop: 6
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        className: "btn btn-primary btn-xs",
                                                        onClick: ()=>{
                                                            handleSave(null, undefined, currentSavedId);
                                                            setRepairSavePrompt(false);
                                                        },
                                                        disabled: saving,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                className: "fas fa-bookmark"
                                                            }),
                                                            " ",
                                                            t('conv.repair_save_yes')
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "btn btn-ghost btn-xs",
                                                        onClick: ()=>setRepairSavePrompt(false),
                                                        children: t('conv.repair_save_no')
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : repairQuestion ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "convert-repair-question",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                        className: "fas fa-question-circle"
                                                    }),
                                                    " ",
                                                    repairQuestion
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                className: "convert-input",
                                                rows: 2,
                                                value: repairAnswer,
                                                onChange: (e)=>setRepairAnswer(e.target.value),
                                                placeholder: t('conv.repair_answer_placeholder'),
                                                onKeyDown: (e)=>{
                                                    if (e.key === 'Enter' && !e.shiftKey) {
                                                        e.preventDefault();
                                                        handleRepair(true);
                                                    }
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    gap: '6px'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "btn btn-primary btn-xs",
                                                        onClick: ()=>handleRepair(true),
                                                        disabled: repairing || !repairAnswer.trim(),
                                                        children: repairing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "fas fa-spinner fa-spin"
                                                                }),
                                                                " ",
                                                                t('conv.repairing')
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "fas fa-paper-plane"
                                                                }),
                                                                " ",
                                                                t('conv.repair_send')
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "btn btn-ghost btn-xs",
                                                        onClick: ()=>{
                                                            setRepairQuestion('');
                                                            setRepairHistory([]);
                                                            setRepairAnswer('');
                                                        },
                                                        children: t('conv.repair_cancel')
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "convert-repair-hint",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                        className: "fas fa-info-circle"
                                                    }),
                                                    " ",
                                                    t('conv.repair_hint')
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                className: "convert-input",
                                                rows: 2,
                                                value: repairInstruction,
                                                onChange: (e)=>setRepairInstruction(e.target.value),
                                                placeholder: t('conv.repair_placeholder'),
                                                onKeyDown: (e)=>{
                                                    if (e.key === 'Enter' && !e.shiftKey) {
                                                        e.preventDefault();
                                                        handleRepair(false);
                                                    }
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "btn btn-secondary btn-xs",
                                                onClick: ()=>handleRepair(false),
                                                disabled: repairing || !repairInstruction.trim(),
                                                children: repairing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-spinner fa-spin"
                                                        }),
                                                        " ",
                                                        t('conv.repairing')
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-magic"
                                                        }),
                                                        " ",
                                                        t('conv.repair_btn')
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                result.nutrients && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "convert-nutrients",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                            children: t('conv.nutrients')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "convert-nutrients-grid",
                                            children: [
                                                result.nutrients.kcal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "convert-nutrient",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "convert-nutrient-val",
                                                            children: result.nutrients.kcal
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "convert-nutrient-label",
                                                            children: "kcal"
                                                        })
                                                    ]
                                                }),
                                                result.nutrients.protein && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "convert-nutrient",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "convert-nutrient-val",
                                                            children: [
                                                                result.nutrients.protein,
                                                                "g"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "convert-nutrient-label",
                                                            children: t('conv.protein')
                                                        })
                                                    ]
                                                }),
                                                result.nutrients.carbs && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "convert-nutrient",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "convert-nutrient-val",
                                                            children: [
                                                                result.nutrients.carbs,
                                                                "g"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "convert-nutrient-label",
                                                            children: t('conv.carbs')
                                                        })
                                                    ]
                                                }),
                                                result.nutrients.fat && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "convert-nutrient",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "convert-nutrient-val",
                                                            children: [
                                                                result.nutrients.fat,
                                                                "g"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "convert-nutrient-label",
                                                            children: t('conv.fat')
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                result.tips && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "convert-tips",
                                    children: editing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                        className: "convert-edit-desc",
                                        value: result.tips || '',
                                        onChange: (e)=>updateField('tips', e.target.value),
                                        rows: 2
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "convert-tips-header",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                        className: "fas fa-lightbulb"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: t('conv.tips')
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: result.tips
                                            })
                                        ]
                                    })
                                }),
                                editing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "convert-save-bar",
                                    role: "region",
                                    "aria-label": t('conv.editing'),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "convert-save-bar-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-pen"
                                                }),
                                                " ",
                                                t('conv.editing'),
                                                dirty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "convert-save-bar-dirty",
                                                    children: [
                                                        " \xb7 ",
                                                        t('conv.unsaved')
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            className: `btn btn-primary btn-sm convert-save-bar-btn ${dirty ? 'convert-save-bar-btn--pulse' : ''}`,
                                            onClick: ()=>{
                                                setEditing(false);
                                                setDirty(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-check"
                                                }),
                                                " ",
                                                t('conv.save_changes')
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            savedPreview && (()=>{
                let recipe = null;
                try {
                    recipe = savedPreview.recipe || (typeof savedPreview.recipe_data === 'string' ? JSON.parse(savedPreview.recipe_data) : savedPreview.recipe_data);
                } catch  {}
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "modal-overlay",
                    onClick: ()=>setSavedPreview(null),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "modal saved-preview-modal",
                        onClick: (e)=>e.stopPropagation(),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "modal-header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-eye"
                                            }),
                                            " ",
                                            savedPreview.title
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "modal-close-btn",
                                        onClick: ()=>setSavedPreview(null),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-times"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "modal-body",
                                children: recipe ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "saved-preview-meta",
                                            children: [
                                                recipe.servings && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-users"
                                                        }),
                                                        " ",
                                                        recipe.servings,
                                                        " ",
                                                        t('conv.servings')
                                                    ]
                                                }),
                                                recipe.total_time_minutes && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "far fa-clock"
                                                        }),
                                                        " ",
                                                        recipe.total_time_minutes,
                                                        " min"
                                                    ]
                                                }),
                                                recipe.category && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-tag"
                                                        }),
                                                        " ",
                                                        recipe.category
                                                    ]
                                                })
                                            ]
                                        }),
                                        recipe.ingredients?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    children: t('conv.ingredients')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                    className: "saved-preview-ingredients",
                                                    children: recipe.ingredients.map((ing, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: ing.quantity
                                                                }),
                                                                " ",
                                                                ing.name
                                                            ]
                                                        }, i))
                                                })
                                            ]
                                        }),
                                        recipe.steps?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    children: t('conv.steps_title')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ol", {
                                                    className: "saved-preview-steps",
                                                    children: recipe.steps.map((s, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    children: s.title
                                                                }),
                                                                " \u2014 ",
                                                                s.description
                                                            ]
                                                        }, i))
                                                })
                                            ]
                                        }),
                                        recipe.tips && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "saved-preview-tips",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-lightbulb"
                                                }),
                                                " ",
                                                recipe.tips
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: t('saved.no_data')
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "modal-footer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: "btn btn-primary",
                                        onClick: ()=>handleLoadSaved(savedPreview),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-upload"
                                            }),
                                            " ",
                                            t('saved.load_to_conv')
                                        ]
                                    }),
                                    savedPreview.mc_url && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        className: "btn btn-outline",
                                        href: savedPreview.mc_url,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-external-link-alt"
                                            }),
                                            " ",
                                            t('saved.open_mc')
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                });
            })(),
            showExtModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "modal-overlay",
                onClick: ()=>setShowExtModal(false),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "modal ext-modal",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-puzzle-piece"
                                        }),
                                        " ",
                                        t('ext.title')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "modal-close-btn",
                                    onClick: ()=>setShowExtModal(false),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-times"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-body",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                                    className: "ext-steps",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: t('ext.step1')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: t('ext.step2')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: t('ext.step3')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        textAlign: 'center',
                                        margin: '1.2rem 0'
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: $042abebcecde25e2$var$CHROME_STORE_URL,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        className: "btn btn-primary",
                                        style: {
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '0.5rem'
                                        },
                                        onClick: ()=>setShowExtModal(false),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fab fa-chrome"
                                            }),
                                            " ",
                                            t('ext.banner_cta')
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "ext-note",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-shield-alt"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: t('ext.security')
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            cookieBanner && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "cookie-banner",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-cookie-bite"
                            }),
                            " ",
                            t('cookie.text')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>{
                            localStorage.setItem('cookie-accepted', '1');
                            setCookieBanner(false);
                        },
                        children: t('cookie.accept')
                    })
                ]
            }),
            !cookieBanner && copyrightBanner && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "cookie-banner cookie-banner--copyright",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-balance-scale"
                            }),
                            " ",
                            t('copyright.text')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>{
                            localStorage.setItem('copyright-accepted', '1');
                            setCopyrightBanner(false);
                        },
                        children: t('copyright.accept')
                    })
                ]
            })
        ]
    });
}
var $042abebcecde25e2$export$2e2bcd8739ae039 = $042abebcecde25e2$var$RecipeConverter;




var $acw62 = parcelRequire("acw62");


const $cf86d3c04e63e9f6$var$API_BASE = "https://www.matemeal.com/api";
function $cf86d3c04e63e9f6$var$Step({ n: n, title: title, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "hg-step",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "hg-step-num",
                children: n
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "hg-step-body",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "hg-step-desc",
                        children: children
                    })
                ]
            })
        ]
    });
}
function $cf86d3c04e63e9f6$var$Alert({ type: type, children: children }) {
    const icons = {
        info: 'fa-info-circle',
        warn: 'fa-exclamation-triangle',
        ok: 'fa-check-circle'
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `hg-alert hg-alert--${type}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                className: `fas ${icons[type] || icons.info}`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: children
            })
        ]
    });
}
function $cf86d3c04e63e9f6$var$Problem({ title: title, children: children }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `hg-problem ${open ? 'hg-problem--open' : ''}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                className: "hg-problem-q",
                onClick: ()=>setOpen((o)=>!o),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-chevron-right hg-chevron"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: title
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "hg-problem-a",
                children: children
            })
        ]
    });
}
function $cf86d3c04e63e9f6$var$TabStart() {
    const { t: t } = (0, $0f85c0253a30f8b6$export$b24a004ee43dce44)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "hg-tab-content",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "hg-lead",
                children: t('help.start.lead')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-map-signs"
                    }),
                    " ",
                    t('help.start.h1')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($cf86d3c04e63e9f6$var$Step, {
                n: "1",
                title: t('help.start.s1.title'),
                children: [
                    t('help.start.s1.desc_a'),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: t('help.start.s1.desc_strong')
                    }),
                    " ",
                    t('help.start.s1.desc_b')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Step, {
                n: "2",
                title: t('help.start.s2.title'),
                children: t('help.start.s2.desc')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($cf86d3c04e63e9f6$var$Step, {
                n: "3",
                title: t('help.start.s3.title'),
                children: [
                    t('help.start.s3.desc_a'),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: t('help.start.s3.desc_tab')
                    }),
                    t('help.start.s3.desc_b'),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: t('help.start.s3.desc_strong')
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Alert, {
                type: "info",
                children: t('help.start.alert')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                style: {
                    marginTop: '1.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-lightbulb"
                    }),
                    " ",
                    t('help.start.h2')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                className: "hg-list",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-globe"
                            }),
                            " ",
                            t('help.start.l1')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-blender"
                            }),
                            " ",
                            t('help.start.l2')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-book"
                            }),
                            " ",
                            t('help.start.l3')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-pen"
                            }),
                            " ",
                            t('help.start.l4')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-photo-video"
                            }),
                            " ",
                            t('help.start.l5')
                        ]
                    })
                ]
            })
        ]
    });
}
const $cf86d3c04e63e9f6$var$CHROME_STORE_URL = 'https://chromewebstore.google.com/detail/ipjjoaopeimoooklbnjjkeaojjhenaig';
function $cf86d3c04e63e9f6$var$TabExtension() {
    const { t: t } = (0, $0f85c0253a30f8b6$export$b24a004ee43dce44)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "hg-tab-content",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "hg-lead",
                children: t('help.ext.lead')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Alert, {
                type: "ok",
                children: t('help.ext.alert')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    textAlign: 'center',
                    margin: '1.4rem 0'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                    href: $cf86d3c04e63e9f6$var$CHROME_STORE_URL,
                    target: "_blank",
                    rel: "noreferrer",
                    className: "btn btn-primary",
                    style: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        fontSize: '1rem',
                        padding: '0.7rem 1.4rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: "fab fa-chrome"
                        }),
                        " ",
                        t('ext.banner_cta')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "hg-mobile-note",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hg-mobile-note-title",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-mobile-alt"
                            }),
                            " ",
                            t('help.ext.mobile.title')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            t('help.ext.mobile.desc_a'),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: t('help.ext.mobile.desc_strong')
                            }),
                            " ",
                            t('help.ext.mobile.desc_b')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        className: "hg-list",
                        style: {
                            marginTop: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-clipboard"
                                    }),
                                    " ",
                                    t('help.ext.mobile.l1_a'),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: t('help.ext.mobile.l1_strong')
                                    }),
                                    t('help.ext.mobile.l1_b')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-desktop"
                                    }),
                                    " ",
                                    t('help.ext.mobile.l2')
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                style: {
                    marginTop: '1.2rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-list-ol"
                    }),
                    " ",
                    t('help.ext.h1')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($cf86d3c04e63e9f6$var$Step, {
                n: "1",
                title: t('help.ext.s2.title'),
                children: [
                    t('help.ext.s2.desc_a'),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: $cf86d3c04e63e9f6$var$CHROME_STORE_URL,
                        target: "_blank",
                        rel: "noreferrer",
                        className: "hg-code",
                        style: {
                            textDecoration: 'none'
                        },
                        children: "Chrome Web Store \u2014 Matemeal Connector"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Step, {
                n: "2",
                title: t('help.ext.s5.title'),
                children: t('help.ext.s5.desc')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($cf86d3c04e63e9f6$var$Step, {
                n: "3",
                title: t('help.ext.s6.title'),
                children: [
                    t('help.ext.s6.desc_a'),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "F5"
                    }),
                    " ",
                    t('help.ext.s6.desc_b'),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                        children: t('help.ext.s6.desc_c')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Alert, {
                type: "ok",
                children: t('help.ext.ok_alert')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                style: {
                    marginTop: '1.2rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-shield-alt"
                    }),
                    " ",
                    t('help.ext.security.title')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                className: "hg-list",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-lock"
                            }),
                            " ",
                            t('help.ext.security.l1')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-ban"
                            }),
                            " ",
                            t('help.ext.security.l2')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-eye-slash"
                            }),
                            " ",
                            t('help.ext.security.l3')
                        ]
                    })
                ]
            })
        ]
    });
}
// Wariant zakładki „extension" dla aplikacji Android — zamiast instrukcji
// wtyczki Chrome opisuje wbudowane łączenie konta Monsieur Cuisine.
function $cf86d3c04e63e9f6$var$TabAppConnect() {
    const { t: t } = (0, $0f85c0253a30f8b6$export$b24a004ee43dce44)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "hg-tab-content",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "hg-lead",
                children: t('help.app.lead')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Alert, {
                type: "ok",
                children: t('help.app.alert')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                style: {
                    marginTop: '1.2rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-list-ol"
                    }),
                    " ",
                    t('help.app.h1')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Step, {
                n: "1",
                title: t('help.app.s1.title'),
                children: t('help.app.s1.desc')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Step, {
                n: "2",
                title: t('help.app.s2.title'),
                children: t('help.app.s2.desc')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Step, {
                n: "3",
                title: t('help.app.s3.title'),
                children: t('help.app.s3.desc')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Alert, {
                type: "info",
                children: t('help.app.note')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                style: {
                    marginTop: '1.2rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-shield-alt"
                    }),
                    " ",
                    t('help.ext.security.title')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                className: "hg-list",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-lock"
                            }),
                            " ",
                            t('help.app.sec.l1')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-eye-slash"
                            }),
                            " ",
                            t('help.app.sec.l2')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-unlink"
                            }),
                            " ",
                            t('help.app.sec.l3')
                        ]
                    })
                ]
            })
        ]
    });
}
function $cf86d3c04e63e9f6$var$TabConvert() {
    const { t: t } = (0, $0f85c0253a30f8b6$export$b24a004ee43dce44)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "hg-tab-content",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "hg-lead",
                children: t('help.conv.lead')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-paste"
                    }),
                    " ",
                    t('help.conv.h1')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                className: "hg-list",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-copy"
                            }),
                            " ",
                            t('help.conv.l1')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-paste"
                            }),
                            " ",
                            t('help.conv.l2')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-magic"
                            }),
                            " ",
                            t('help.conv.l3_a'),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: t('help.conv.l3_strong')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                style: {
                    marginTop: '1.2rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-cogs"
                    }),
                    " ",
                    t('help.conv.h2')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "hg-cards",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hg-card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-weight"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: t('help.conv.card1.title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t('help.conv.card1.desc')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hg-card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-thermometer-half"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: t('help.conv.card2.title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t('help.conv.card2.desc')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hg-card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-tachometer-alt"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: t('help.conv.card3.title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t('help.conv.card3.desc')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hg-card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-clock"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: t('help.conv.card4.title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t('help.conv.card4.desc')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                style: {
                    marginTop: '1.2rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-edit"
                    }),
                    " ",
                    t('help.conv.h3')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                className: "hg-list",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-pencil-alt"
                            }),
                            " ",
                            t('help.conv.edit.l1_a'),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: t('help.conv.edit.l1_strong')
                            }),
                            " ",
                            t('help.conv.edit.l1_b')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-check-square"
                            }),
                            " ",
                            t('help.conv.edit.l2_a'),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: t('help.conv.edit.l2_strong')
                            }),
                            " ",
                            t('help.conv.edit.l2_b')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-arrows-alt-v"
                            }),
                            " ",
                            t('help.conv.edit.l3')
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                style: {
                    marginTop: '1.2rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-share-alt"
                    }),
                    " ",
                    t('help.conv.h4')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                className: "hg-list",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-clipboard"
                            }),
                            " ",
                            t('help.conv.share.l1_a'),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: t('help.conv.share.l1_strong')
                            }),
                            " ",
                            t('help.conv.share.l1_b')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-code"
                            }),
                            " ",
                            t('help.conv.share.l2_a'),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: t('help.conv.share.l2_strong')
                            }),
                            " ",
                            t('help.conv.share.l2_b')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-bookmark"
                            }),
                            " ",
                            t('help.conv.share.l3')
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Alert, {
                type: "info",
                children: t('help.conv.alert')
            })
        ]
    });
}
function $cf86d3c04e63e9f6$var$TabProblems() {
    const { t: t } = (0, $0f85c0253a30f8b6$export$b24a004ee43dce44)();
    // W apce nie ma wtyczki Chrome — pytania o nią (p1, p2, p4) znikają,
    // pozostałe dostają wersje @app przez warstwę nadpisań w t()
    const native = (0, $5a6742a4b36362a4$export$1efe58f5634014d1)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "hg-tab-content",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "hg-lead",
                children: t('help.prob.lead')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-plug"
                    }),
                    " ",
                    t('help.prob.h1')
                ]
            }),
            !native && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($cf86d3c04e63e9f6$var$Problem, {
                title: t('help.prob.p1.q'),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: t('help.prob.p1.desc')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                        className: "hg-ol",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: t('help.prob.p1.l1')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: t('help.prob.p1.l2')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    t('help.prob.p1.l3_a'),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                        children: "chrome://extensions"
                                    }),
                                    t('help.prob.p1.l3_b')
                                ]
                            })
                        ]
                    })
                ]
            }),
            !native && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Problem, {
                title: t('help.prob.p2.q'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                    className: "hg-ol",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                t('help.prob.p2.l1_a'),
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "monsieur-cuisine.com"
                                }),
                                " ",
                                t('help.prob.p2.l1_b')
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: t('help.prob.p2.l2')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: t('help.prob.p2.l3')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($cf86d3c04e63e9f6$var$Problem, {
                title: t('help.prob.p3.q'),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: t('help.prob.p3.desc')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                        className: "hg-ol",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: t('help.prob.p3.l1')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: t('help.prob.p3.l2')
                            })
                        ]
                    })
                ]
            }),
            !native && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Problem, {
                title: t('help.prob.p4.q'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                    className: "hg-ol",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                t('help.prob.p4.l1_a'),
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: t('help.prob.p4.l1_strong')
                                }),
                                " ",
                                t('help.prob.p4.l1_b')
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                t('help.prob.p4.l2_a'),
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: t('help.prob.p4.l2_strong')
                                }),
                                " ",
                                t('help.prob.p4.l2_b')
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: t('help.prob.p4.l3')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                style: {
                    marginTop: '1.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-robot"
                    }),
                    " ",
                    t('help.prob.h2')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($cf86d3c04e63e9f6$var$Problem, {
                title: t('help.prob.p5.q'),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: t('help.prob.p5.desc')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                        className: "hg-ol",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: t('help.prob.p5.l1')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: t('help.prob.p5.l2')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: t('help.prob.p5.l3')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Problem, {
                title: t('help.prob.p6.q'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                    className: "hg-ol",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: t('help.prob.p6.l1')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: t('help.prob.p6.l2')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                t('help.prob.p6.l3_a'),
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: t('help.prob.p6.l3_strong')
                                }),
                                " ",
                                t('help.prob.p6.l3_b')
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                t('help.prob.p6.l4_a'),
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: t('help.prob.p6.l4_strong')
                                }),
                                " ",
                                t('help.prob.p6.l4_b')
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($cf86d3c04e63e9f6$var$Problem, {
                title: t('help.prob.p7.q'),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: t('help.prob.p7.desc')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                        className: "hg-ol",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: t('help.prob.p7.l1')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: t('help.prob.p7.l2')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                style: {
                    marginTop: '1.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-question-circle"
                    }),
                    " ",
                    t('help.prob.h3')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Problem, {
                title: t('help.prob.p8.q'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                    className: "hg-ol",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: t('help.prob.p8.l1')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: t('help.prob.p8.l2')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: t('help.prob.p8.l3')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Problem, {
                title: t('help.prob.p9.q'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: t('help.prob.p9.desc')
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$ContactForm, {})
        ]
    });
}
function $cf86d3c04e63e9f6$var$ContactForm() {
    const { t: t } = (0, $0f85c0253a30f8b6$export$b24a004ee43dce44)();
    const [subject, setSubject] = (0, $acw62.useState)('');
    const [message, setMessage] = (0, $acw62.useState)('');
    const [replyEmail, setReplyEmail] = (0, $acw62.useState)('');
    const [status, setStatus] = (0, $acw62.useState)('idle'); // idle | sending | success | error | rate_limit
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!subject || !message.trim()) return;
        setStatus('sending');
        try {
            const res = await fetch(`${$cf86d3c04e63e9f6$var$API_BASE}/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    subject_type: subject,
                    message: message.trim(),
                    reply_email: replyEmail.trim()
                })
            });
            if (res.status === 429) {
                setStatus('rate_limit');
                return;
            }
            if (!res.ok) {
                setStatus('error');
                return;
            }
            setStatus('success');
            setMessage('');
            setReplyEmail('');
        } catch  {
            setStatus('error');
        }
    };
    if (status === 'success') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "hg-contact-form",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Alert, {
            type: "ok",
            children: t('contact.form.success')
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "hg-contact-form",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "fas fa-envelope"
                    }),
                    " ",
                    t('contact.form.title')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "hg-form",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hg-form-row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "hg-label",
                                children: t('contact.form.subject')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                className: "hg-select",
                                value: subject,
                                onChange: (e)=>setSubject(e.target.value),
                                required: true,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "\u2014"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "bug",
                                        children: t('contact.form.subject.bug')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "help",
                                        children: t('contact.form.subject.help')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "other",
                                        children: t('contact.form.subject.other')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hg-form-row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "hg-label",
                                children: t('contact.form.message')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                className: "hg-textarea",
                                rows: 5,
                                value: message,
                                onChange: (e)=>setMessage(e.target.value),
                                required: true,
                                maxLength: 5000
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hg-form-row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "hg-label",
                                children: t('contact.form.reply_email')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                className: "hg-input",
                                type: "email",
                                value: replyEmail,
                                onChange: (e)=>setReplyEmail(e.target.value),
                                placeholder: "you@example.com"
                            })
                        ]
                    }),
                    (status === 'error' || status === 'rate_limit') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cf86d3c04e63e9f6$var$Alert, {
                        type: "warn",
                        children: t(status === 'rate_limit' ? 'contact.form.rate_limit' : 'contact.form.error')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: "btn btn-primary hg-form-submit",
                        type: "submit",
                        disabled: status === 'sending',
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-paper-plane"
                            }),
                            ' ',
                            status === 'sending' ? t('contact.form.sending') : t('contact.form.send')
                        ]
                    })
                ]
            })
        ]
    });
}
const $cf86d3c04e63e9f6$var$TAB_COMPONENTS = {
    start: $cf86d3c04e63e9f6$var$TabStart,
    extension: $cf86d3c04e63e9f6$var$TabExtension,
    convert: $cf86d3c04e63e9f6$var$TabConvert,
    problems: $cf86d3c04e63e9f6$var$TabProblems
};
function $cf86d3c04e63e9f6$var$HelpGuide({ onClose: onClose }) {
    const { t: t } = (0, $0f85c0253a30f8b6$export$b24a004ee43dce44)();
    const [activeTab, setActiveTab] = (0, $acw62.useState)('start');
    const native = (0, $5a6742a4b36362a4$export$1efe58f5634014d1)();
    const TabComponent = native && activeTab === 'extension' ? $cf86d3c04e63e9f6$var$TabAppConnect : $cf86d3c04e63e9f6$var$TAB_COMPONENTS[activeTab];
    const TABS = [
        {
            id: 'start',
            icon: 'fas fa-rocket',
            label: t('help.tab.start')
        },
        {
            id: 'extension',
            icon: native ? 'fas fa-link' : 'fas fa-puzzle-piece',
            label: native ? t('help.tab.app') : t('help.tab.extension')
        },
        {
            id: 'convert',
            icon: 'fas fa-blender',
            label: t('help.tab.convert')
        },
        {
            id: 'problems',
            icon: 'fas fa-exclamation-circle',
            label: t('help.tab.problems')
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "modal-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "hg-modal",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "hg-header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "hg-header-title",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "fas fa-book-open"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: t('help.title')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "hg-close",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-times"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "hg-tabs",
                    children: TABS.map((tab)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            className: `hg-tab ${activeTab === tab.id ? 'hg-tab--active' : ''}`,
                            onClick: ()=>setActiveTab(tab.id),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: tab.icon
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: tab.label
                                })
                            ]
                        }, tab.id))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "hg-body",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TabComponent, {})
                })
            ]
        })
    });
}
var $cf86d3c04e63e9f6$export$2e2bcd8739ae039 = $cf86d3c04e63e9f6$var$HelpGuide;




var $acw62 = parcelRequire("acw62");

var $dkmhp = parcelRequire("dkmhp");
function $0075c5ef3314e518$var$RecipePreview({ recipe: recipe }) {
    const data = typeof recipe.recipe === 'object' ? recipe.recipe : recipe.recipe_data || {};
    const ing = data.ingredients || [];
    const steps = data.steps || [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "recipe-preview",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                className: "recipe-preview-title",
                children: recipe.title
            }),
            (data.servings || data.total_time_minutes) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "recipe-preview-meta",
                children: [
                    data.servings && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-users"
                            }),
                            " ",
                            data.servings,
                            " porcji"
                        ]
                    }),
                    data.total_time_minutes && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-clock"
                            }),
                            " ",
                            data.total_time_minutes,
                            " min"
                        ]
                    })
                ]
            }),
            ing.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "recipe-preview-section",
                        children: "Sk\u0142adniki"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        className: "recipe-preview-list",
                        children: ing.map((x, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    x.amount,
                                    " ",
                                    x.unit,
                                    " ",
                                    x.name
                                ]
                            }, i))
                    })
                ]
            }),
            steps.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "recipe-preview-section",
                        children: "Kroki"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ol", {
                        className: "recipe-preview-steps",
                        children: steps.map((s, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: typeof s === 'string' ? s : s.description || s.text || JSON.stringify(s)
                            }, i))
                    })
                ]
            })
        ]
    });
}
function $0075c5ef3314e518$var$fmtDate(iso) {
    if (!iso) return "\u2014";
    const d = new Date(iso);
    return d.toLocaleDateString('pl-PL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }) + ' ' + d.toLocaleTimeString('pl-PL', {
        hour: '2-digit',
        minute: '2-digit'
    });
}
const $0075c5ef3314e518$var$EMPTY_NEW = {
    username: '',
    email: '',
    password: '',
    is_admin: false
};
function $0075c5ef3314e518$export$2e2bcd8739ae039({ currentUserId: currentUserId, onClose: onClose, onLoadRecipe: onLoadRecipe }) {
    const [stats, setStats] = (0, $acw62.useState)(null);
    const [users, setUsers] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)('');
    const [success, setSuccess] = (0, $acw62.useState)('');
    // Add-user modal
    const [showAdd, setShowAdd] = (0, $acw62.useState)(false);
    const [newUser, setNewUser] = (0, $acw62.useState)($0075c5ef3314e518$var$EMPTY_NEW);
    const [addError, setAddError] = (0, $acw62.useState)('');
    // Edit modal
    const [editUser, setEditUser] = (0, $acw62.useState)(null);
    const [editError, setEditError] = (0, $acw62.useState)('');
    // Reset-password modal
    const [resetUser, setResetUser] = (0, $acw62.useState)(null);
    const [newPass, setNewPass] = (0, $acw62.useState)('');
    const [resetError, setResetError] = (0, $acw62.useState)('');
    // Recipes modal
    const [importFile, setImportFile] = (0, $acw62.useState)(null); // { name, data }
    const [importMode, setImportMode] = (0, $acw62.useState)('merge');
    const [importing, setImporting] = (0, $acw62.useState)(false);
    const [exporting, setExporting] = (0, $acw62.useState)(false);
    const [recipesUser, setRecipesUser] = (0, $acw62.useState)(null);
    const [recipesList, setRecipesList] = (0, $acw62.useState)([]);
    const [recipesLoading, setRecipesLoading] = (0, $acw62.useState)(false);
    const [recipePreview, setRecipePreview] = (0, $acw62.useState)(null);
    const [deleteRecipeTarget, setDeleteRecipeTarget] = (0, $acw62.useState)(null);
    // Delete confirm
    const [deleteTarget, setDeleteTarget] = (0, $acw62.useState)(null);
    // Inline limit edit
    const [editingLimitId, setEditingLimitId] = (0, $acw62.useState)(null);
    const [limitDraft, setLimitDraft] = (0, $acw62.useState)('');
    const flash = (msg, isError = false)=>{
        if (isError) {
            setError(msg);
            setSuccess('');
        } else {
            setSuccess(msg);
            setError('');
        }
        setTimeout(()=>{
            setError('');
            setSuccess('');
        }, 4000);
    };
    const load = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        try {
            const [s, u] = await Promise.all([
                (0, $dkmhp.adminAPI).getStats(),
                (0, $dkmhp.adminAPI).listUsers()
            ]);
            setStats(s.data);
            setUsers(u.data.users);
        } catch (e) {
            flash(e.response?.data?.error || "B\u0142\u0105d \u0142adowania danych", true);
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    // ── Add user ──────────────────────────────────────────────────────────────────
    const handleAddUser = async (e)=>{
        e.preventDefault();
        setAddError('');
        try {
            const r = await (0, $dkmhp.adminAPI).createUser(newUser);
            setUsers((prev)=>[
                    r.data.user,
                    ...prev
                ]);
            setStats((prev)=>prev ? {
                    ...prev,
                    total_users: prev.total_users + 1,
                    active_users: prev.active_users + 1,
                    admin_users: newUser.is_admin ? prev.admin_users + 1 : prev.admin_users
                } : prev);
            setShowAdd(false);
            setNewUser($0075c5ef3314e518$var$EMPTY_NEW);
            flash("U\u017Cytkownik utworzony");
        } catch (e) {
            setAddError(e.response?.data?.error || "B\u0142\u0105d tworzenia u\u017Cytkownika");
        }
    };
    // ── Edit user ─────────────────────────────────────────────────────────────────
    const handleEditSave = async (e)=>{
        e.preventDefault();
        setEditError('');
        try {
            const r = await (0, $dkmhp.adminAPI).updateUser(editUser.id, {
                email: editUser.email,
                is_admin: editUser.is_admin,
                is_active: editUser.is_active
            });
            setUsers((prev)=>prev.map((u)=>u.id === editUser.id ? r.data.user : u));
            setEditUser(null);
            flash('Zapisano zmiany');
            load(); // refresh stats
        } catch (e) {
            setEditError(e.response?.data?.error || "B\u0142\u0105d zapisu");
        }
    };
    // ── Reset password ────────────────────────────────────────────────────────────
    const handleReset = async (e)=>{
        e.preventDefault();
        setResetError('');
        try {
            await (0, $dkmhp.adminAPI).resetPassword(resetUser.id, newPass);
            setResetUser(null);
            setNewPass('');
            flash("Has\u0142o zresetowane");
        } catch (e) {
            setResetError(e.response?.data?.error || "B\u0142\u0105d resetowania has\u0142a");
        }
    };
    // ── Delete user ───────────────────────────────────────────────────────────────
    const handleDelete = async ()=>{
        try {
            await (0, $dkmhp.adminAPI).deleteUser(deleteTarget.id);
            setUsers((prev)=>prev.filter((u)=>u.id !== deleteTarget.id));
            setDeleteTarget(null);
            flash("U\u017Cytkownik usuni\u0119ty");
            load();
        } catch (e) {
            flash(e.response?.data?.error || "B\u0142\u0105d usuwania", true);
            setDeleteTarget(null);
        }
    };
    // ── Inline limit save ─────────────────────────────────────────────────────────
    const saveLimitInline = async (userId)=>{
        const val = limitDraft.trim();
        const monthly_limit = val === '' || val === "\u221E" ? null : parseInt(val, 10);
        if (monthly_limit !== null && (isNaN(monthly_limit) || monthly_limit < 1)) {
            flash("Podaj liczb\u0119 \u2265 1 lub pozostaw puste (bez limitu)", true);
            return;
        }
        try {
            const r = await (0, $dkmhp.adminAPI).updateUser(userId, {
                monthly_limit: monthly_limit
            });
            setUsers((prev)=>prev.map((u)=>u.id === userId ? r.data.user : u));
            setEditingLimitId(null);
            flash('Limit zaktualizowany');
        } catch (e) {
            flash(e.response?.data?.error || "B\u0142\u0105d", true);
        }
    };
    // ── Reset conversions counter ─────────────────────────────────────────────────
    const resetConversions = async (user)=>{
        try {
            const r = await (0, $dkmhp.adminAPI).resetConversions(user.id);
            setUsers((prev)=>prev.map((u)=>u.id === user.id ? r.data.user : u));
            flash(`Licznik konwersji dla "${user.username}" zresetowany`);
        } catch (e) {
            flash(e.response?.data?.error || "B\u0142\u0105d", true);
        }
    };
    // ── Quick toggle block ────────────────────────────────────────────────────────
    const toggleActive = async (user)=>{
        try {
            const r = await (0, $dkmhp.adminAPI).updateUser(user.id, {
                is_active: !user.is_active
            });
            setUsers((prev)=>prev.map((u)=>u.id === user.id ? r.data.user : u));
            flash(r.data.user.is_active ? 'Konto odblokowane' : 'Konto zablokowane');
            load();
        } catch (e) {
            flash(e.response?.data?.error || "B\u0142\u0105d", true);
        }
    };
    // ── Eksport / import bazy przepisów ──────────────────────────────────────────
    const handleExport = async ()=>{
        setExporting(true);
        try {
            const r = await (0, $dkmhp.adminAPI).exportRecipes();
            const blob = new Blob([
                JSON.stringify(r.data, null, 2)
            ], {
                type: 'application/json'
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `matemeal-przepisy-${new Date().toISOString().slice(0, 10)}.json`;
            a.click();
            URL.revokeObjectURL(url);
            flash(`Wyeksportowano ${r.data.count} przepis\xf3w`);
        } catch (e) {
            flash(e.response?.data?.error || "B\u0142\u0105d eksportu", true);
        } finally{
            setExporting(false);
        }
    };
    const handleImportFile = (e)=>{
        const f = e.target.files[0];
        e.target.value = '';
        if (!f) return;
        const reader = new FileReader();
        reader.onload = ()=>{
            try {
                const data = JSON.parse(reader.result);
                if (data.format !== 'matemeal-recipes' || !Array.isArray(data.recipes)) throw new Error();
                setImportMode('merge');
                setImportFile({
                    name: f.name,
                    data: data
                });
            } catch  {
                flash("Nieprawid\u0142owy plik \u2014 wybierz wcze\u015Bniejszy eksport przepis\xf3w", true);
            }
        };
        reader.readAsText(f);
    };
    const handleImportConfirm = async ()=>{
        if (!importFile || importing) return;
        setImporting(true);
        try {
            const r = await (0, $dkmhp.adminAPI).importRecipes(importFile.data, importMode);
            const d = r.data;
            flash(`Zaimportowano ${d.imported} przepis\xf3w` + (d.skipped_existing ? `, pomini\u{119}to ${d.skipped_existing} ju\u{17C} istniej\u{105}cych` : '') + (d.skipped_no_user ? `, ${d.skipped_no_user} bez pasuj\u{105}cego u\u{17C}ytkownika` : ''));
            setImportFile(null);
            load();
        } catch (e) {
            flash(e.response?.data?.error || "B\u0142\u0105d importu", true);
        } finally{
            setImporting(false);
        }
    };
    // ── User recipes ──────────────────────────────────────────────────────────────
    const openRecipes = async (user)=>{
        setRecipesUser(user);
        setRecipesLoading(true);
        try {
            const r = await (0, $dkmhp.adminAPI).getUserRecipes(user.id);
            setRecipesList(r.data.recipes);
        } catch  {
            setRecipesList([]);
        } finally{
            setRecipesLoading(false);
        }
    };
    const handleDeleteRecipe = async ()=>{
        if (!deleteRecipeTarget) return;
        try {
            const r = await (0, $dkmhp.adminAPI).deleteRecipe(deleteRecipeTarget.id);
            setRecipesList((prev)=>prev.filter((x)=>x.id !== deleteRecipeTarget.id));
            setUsers((prev)=>prev.map((u)=>u.id === recipesUser.id ? {
                        ...u,
                        recipe_count: r.data.recipe_count
                    } : u));
            setStats((prev)=>prev ? {
                    ...prev,
                    total_recipes: prev.total_recipes - 1
                } : prev);
            setDeleteRecipeTarget(null);
            if (recipePreview?.id === deleteRecipeTarget.id) setRecipePreview(null);
        } catch (e) {
            flash(e.response?.data?.error || "B\u0142\u0105d usuwania przepisu", true);
            setDeleteRecipeTarget(null);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "admin-overlay",
        onClick: onClose,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "admin-panel",
                onClick: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "admin-header",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "admin-title",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-shield-alt"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Panel Administratora"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "admin-close",
                                onClick: onClose,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "fas fa-times"
                                })
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "admin-flash admin-flash-error",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-exclamation-triangle"
                            }),
                            " ",
                            error
                        ]
                    }),
                    success && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "admin-flash admin-flash-success",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-check-circle"
                            }),
                            " ",
                            success
                        ]
                    }),
                    loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "admin-loading",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "spinner"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "\u0141adowanie..."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            stats && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "admin-stats",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "admin-stat",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "stat-val",
                                                children: stats.total_users
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "stat-lbl",
                                                children: "U\u017Cytkownicy"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "admin-stat admin-stat-green",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "stat-val",
                                                children: stats.active_users
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "stat-lbl",
                                                children: "Aktywni"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "admin-stat admin-stat-red",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "stat-val",
                                                children: stats.blocked_users
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "stat-lbl",
                                                children: "Zablokowani"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "admin-stat admin-stat-gold",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "stat-val",
                                                children: stats.admin_users
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "stat-lbl",
                                                children: "Adminowie"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "admin-stat admin-stat-blue",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "stat-val",
                                                children: stats.total_recipes
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "stat-lbl",
                                                children: "Przepisy"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "admin-toolbar",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: "btn-primary admin-add-btn",
                                        onClick: ()=>{
                                            setNewUser($0075c5ef3314e518$var$EMPTY_NEW);
                                            setAddError('');
                                            setShowAdd(true);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-user-plus"
                                            }),
                                            " Dodaj u\u017Cytkownika"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "btn-secondary",
                                        onClick: load,
                                        title: "Od\u015Bwie\u017C",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-sync-alt"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "admin-toolbar-spacer"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: "btn-secondary",
                                        onClick: handleExport,
                                        disabled: exporting,
                                        title: "Pobierz wszystkie przepisy u\u017Cytkownik\xf3w jako plik JSON",
                                        children: [
                                            exporting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-spinner fa-spin"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-download"
                                            }),
                                            " Eksport przepis\xf3w"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "btn-secondary admin-import-label",
                                        title: "Wczytaj przepisy z wcze\u015Bniejszego eksportu",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-upload"
                                            }),
                                            " Import przepis\xf3w",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "file",
                                                accept: "application/json,.json",
                                                onChange: handleImportFile,
                                                style: {
                                                    display: 'none'
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "admin-table-wrap",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                    className: "admin-table",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "U\u017Cytkownik"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Email / konto MC"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Przepisy"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Konwersje"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Limit/mies."
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Reset limitu"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Rejestracja"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                        children: "Akcje"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: users.map((u)=>{
                                                const isUnlimited = u.is_admin || u.monthly_limit === null;
                                                const usagePct = isUnlimited ? 0 : Math.min(100, Math.round(u.conversions_count / u.monthly_limit * 100));
                                                const usageColor = usagePct >= 100 ? '#f87171' : usagePct >= 80 ? '#fbbf24' : '#4ade80';
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    className: !u.is_active ? 'row-blocked' : '',
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "td-id",
                                                            "data-label": "ID",
                                                            children: u.id
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "td-name",
                                                            children: [
                                                                u.is_admin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "badge-admin",
                                                                    title: "Administrator",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                        className: "fas fa-shield-alt"
                                                                    })
                                                                }),
                                                                u.username,
                                                                u.id === currentUserId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "badge-me",
                                                                    children: " (Ty)"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "td-email",
                                                            "data-label": "Email / konto MC",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    children: u.email || "\u2014"
                                                                }),
                                                                u.mc_account_id && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "td-mc-id",
                                                                    title: "Powi\u0105zane konto MC",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                            className: "fas fa-link"
                                                                        }),
                                                                        " ",
                                                                        u.mc_account_id
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "td-center",
                                                            "data-label": "Przepisy",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: "btn-link",
                                                                onClick: ()=>openRecipes(u),
                                                                title: "Poka\u017C przepisy",
                                                                children: u.recipe_count
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "td-center",
                                                            "data-label": "Konwersje",
                                                            children: isUnlimited ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "usage-unlimited",
                                                                title: "Bez limitu",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "fas fa-infinity"
                                                                })
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "usage-wrap",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "usage-num",
                                                                        style: {
                                                                            color: usageColor
                                                                        },
                                                                        children: u.conversions_count
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "usage-bar-bg",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            className: "usage-bar-fill",
                                                                            style: {
                                                                                width: `${usagePct}%`,
                                                                                background: usageColor
                                                                            }
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "td-center",
                                                            "data-label": "Limit/mies.",
                                                            children: editingLimitId === u.id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "limit-edit-inline",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                        type: "number",
                                                                        min: "1",
                                                                        value: limitDraft,
                                                                        onChange: (e)=>setLimitDraft(e.target.value),
                                                                        onKeyDown: (e)=>{
                                                                            if (e.key === 'Enter') saveLimitInline(u.id);
                                                                            if (e.key === 'Escape') setEditingLimitId(null);
                                                                        },
                                                                        placeholder: "\u221E",
                                                                        autoFocus: true
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        className: "action-btn action-ok",
                                                                        onClick: ()=>saveLimitInline(u.id),
                                                                        title: "Zapisz",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                            className: "fas fa-check"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        className: "action-btn",
                                                                        onClick: ()=>setEditingLimitId(null),
                                                                        title: "Anuluj",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                            className: "fas fa-times"
                                                                        })
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: "btn-link limit-badge",
                                                                onClick: ()=>{
                                                                    setEditingLimitId(u.id);
                                                                    setLimitDraft(u.monthly_limit ?? '');
                                                                },
                                                                children: isUnlimited ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                        className: "fas fa-infinity"
                                                                    })
                                                                }) : u.monthly_limit
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "td-date",
                                                            "data-label": "Reset limitu",
                                                            children: u.limit_reset_at ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        children: $0075c5ef3314e518$var$fmtDate(u.limit_reset_at).split(' ')[0]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                        className: "btn-link reset-counter-btn",
                                                                        onClick: ()=>resetConversions(u),
                                                                        title: "Zresetuj licznik teraz",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                                className: "fas fa-redo-alt"
                                                                            }),
                                                                            " reset"
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : isUnlimited ? "\u2014" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                className: "btn-link reset-counter-btn",
                                                                onClick: ()=>resetConversions(u),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                        className: "fas fa-redo-alt"
                                                                    }),
                                                                    " ustaw"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "td-date",
                                                            "data-label": "Rejestracja",
                                                            children: $0075c5ef3314e518$var$fmtDate(u.created_at)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            className: "td-center",
                                                            "data-label": "Status",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: `badge-status ${u.is_active ? 'badge-active' : 'badge-blocked'}`,
                                                                children: u.is_active ? 'Aktywny' : 'Zablokowany'
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                            className: "td-actions",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: "action-btn",
                                                                    title: "Edytuj",
                                                                    onClick: ()=>{
                                                                        setEditError('');
                                                                        setEditUser({
                                                                            ...u
                                                                        });
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                        className: "fas fa-edit"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: "action-btn",
                                                                    title: "Resetuj has\u0142o",
                                                                    onClick: ()=>{
                                                                        setResetError('');
                                                                        setNewPass('');
                                                                        setResetUser(u);
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                        className: "fas fa-key"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: `action-btn ${u.is_active ? 'action-warn' : 'action-ok'}`,
                                                                    title: u.is_active ? 'Zablokuj konto' : 'Odblokuj konto',
                                                                    onClick: ()=>toggleActive(u),
                                                                    disabled: u.id === currentUserId,
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                        className: `fas ${u.is_active ? 'fa-ban' : 'fa-unlock'}`
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: "action-btn action-danger",
                                                                    title: "Usu\u0144 u\u017Cytkownika",
                                                                    onClick: ()=>setDeleteTarget(u),
                                                                    disabled: u.id === currentUserId,
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                        className: "fas fa-trash"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, u.id);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            showAdd && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "admin-modal-overlay",
                onClick: ()=>setShowAdd(false),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "admin-modal",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "admin-modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-user-plus"
                                        }),
                                        " Nowy u\u017Cytkownik"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>setShowAdd(false),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-times"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                            onSubmit: handleAddUser,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "admin-modal-body",
                                    children: [
                                        addError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "admin-flash admin-flash-error",
                                            children: addError
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Nazwa u\u017Cytkownika *"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    value: newUser.username,
                                                    onChange: (e)=>setNewUser((p)=>({
                                                                ...p,
                                                                username: e.target.value
                                                            })),
                                                    required: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Email"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "email",
                                                    value: newUser.email,
                                                    onChange: (e)=>setNewUser((p)=>({
                                                                ...p,
                                                                email: e.target.value
                                                            }))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Has\u0142o * (min. 6 znak\xf3w)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "password",
                                                    value: newUser.password,
                                                    onChange: (e)=>setNewUser((p)=>({
                                                                ...p,
                                                                password: e.target.value
                                                            })),
                                                    required: true,
                                                    minLength: 6
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "form-group form-group-check",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: newUser.is_admin,
                                                        onChange: (e)=>setNewUser((p)=>({
                                                                    ...p,
                                                                    is_admin: e.target.checked
                                                                }))
                                                    }),
                                                    "Uprawnienia administratora"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "admin-modal-footer",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "submit",
                                            className: "btn-primary",
                                            children: "Utw\xf3rz"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn-secondary",
                                            onClick: ()=>setShowAdd(false),
                                            children: "Anuluj"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            editUser && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "admin-modal-overlay",
                onClick: ()=>setEditUser(null),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "admin-modal",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "admin-modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-edit"
                                        }),
                                        " Edytuj: ",
                                        editUser.username
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>setEditUser(null),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-times"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                            onSubmit: handleEditSave,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "admin-modal-body",
                                    children: [
                                        editError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "admin-flash admin-flash-error",
                                            children: editError
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Email"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "email",
                                                    value: editUser.email || '',
                                                    onChange: (e)=>setEditUser((p)=>({
                                                                ...p,
                                                                email: e.target.value
                                                            }))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "form-group form-group-check",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: editUser.is_admin,
                                                        onChange: (e)=>setEditUser((p)=>({
                                                                    ...p,
                                                                    is_admin: e.target.checked
                                                                })),
                                                        disabled: editUser.id === currentUserId
                                                    }),
                                                    "Uprawnienia administratora"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "form-group form-group-check",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: editUser.is_active,
                                                        onChange: (e)=>setEditUser((p)=>({
                                                                    ...p,
                                                                    is_active: e.target.checked
                                                                })),
                                                        disabled: editUser.id === currentUserId
                                                    }),
                                                    "Konto aktywne"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "admin-modal-footer",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "submit",
                                            className: "btn-primary",
                                            children: "Zapisz"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn-secondary",
                                            onClick: ()=>setEditUser(null),
                                            children: "Anuluj"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            resetUser && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "admin-modal-overlay",
                onClick: ()=>setResetUser(null),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "admin-modal",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "admin-modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-key"
                                        }),
                                        " Reset has\u0142a: ",
                                        resetUser.username
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>setResetUser(null),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-times"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                            onSubmit: handleReset,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "admin-modal-body",
                                    children: [
                                        resetError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "admin-flash admin-flash-error",
                                            children: resetError
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: "Nowe has\u0142o * (min. 6 znak\xf3w)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "password",
                                                    value: newPass,
                                                    onChange: (e)=>setNewPass(e.target.value),
                                                    required: true,
                                                    minLength: 6,
                                                    autoFocus: true
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "admin-modal-footer",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "submit",
                                            className: "btn-primary",
                                            children: "Ustaw has\u0142o"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn-secondary",
                                            onClick: ()=>setResetUser(null),
                                            children: "Anuluj"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            deleteTarget && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "admin-modal-overlay",
                onClick: ()=>setDeleteTarget(null),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "admin-modal admin-modal-confirm",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "admin-modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-exclamation-triangle"
                                        }),
                                        " Usu\u0144 u\u017Cytkownika"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>setDeleteTarget(null),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-times"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "admin-modal-body",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        "Czy na pewno chcesz usun\u0105\u0107 u\u017Cytkownika ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: deleteTarget.username
                                        }),
                                        "?"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "confirm-warning",
                                    children: [
                                        "Ta operacja jest nieodwracalna. Usuni\u0119te zostan\u0105 r\xf3wnie\u017C wszystkie przepisy tego u\u017Cytkownika (",
                                        deleteTarget.recipe_count,
                                        ")."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "admin-modal-footer",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "btn-danger",
                                    onClick: handleDelete,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-trash"
                                        }),
                                        " Usu\u0144"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "btn-secondary",
                                    onClick: ()=>setDeleteTarget(null),
                                    children: "Anuluj"
                                })
                            ]
                        })
                    ]
                })
            }),
            recipesUser && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "admin-modal-overlay",
                onClick: ()=>{
                    setRecipesUser(null);
                    setRecipePreview(null);
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "admin-modal admin-modal-recipes",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "admin-modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-book"
                                        }),
                                        " Przepisy: ",
                                        recipesUser.username
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>{
                                        setRecipesUser(null);
                                        setRecipePreview(null);
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-times"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "admin-modal-body admin-modal-body-split",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "recipes-list-col",
                                    children: recipesLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "admin-loading",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "spinner"
                                        })
                                    }) : recipesList.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "admin-empty",
                                        children: "Brak zapisanych przepis\xf3w."
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "recipes-list",
                                        children: recipesList.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: `recipe-row ${recipePreview?.id === r.id ? 'recipe-row-active' : ''}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "recipe-row-title",
                                                        children: r.title
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "recipe-row-meta",
                                                        children: [
                                                            $0075c5ef3314e518$var$fmtDate(r.created_at),
                                                            r.mc_url && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                href: r.mc_url,
                                                                target: "_blank",
                                                                rel: "noreferrer",
                                                                className: "recipe-row-link",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                        className: "fas fa-external-link-alt"
                                                                    }),
                                                                    " MC"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "recipe-row-actions",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: "action-btn",
                                                                title: "Podgl\u0105d",
                                                                onClick: ()=>setRecipePreview(recipePreview?.id === r.id ? null : r),
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "fas fa-eye"
                                                                })
                                                            }),
                                                            onLoadRecipe && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: "action-btn",
                                                                title: "Wczytaj do mojego konwertera (mo\u017Cesz potem wys\u0142a\u0107 na swoje konto MC)",
                                                                onClick: ()=>{
                                                                    onLoadRecipe(r);
                                                                    onClose();
                                                                },
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "fas fa-file-import"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: "action-btn action-danger",
                                                                title: "Usu\u0144 przepis",
                                                                onClick: ()=>setDeleteRecipeTarget(r),
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                    className: "fas fa-trash"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, r.id))
                                    })
                                }),
                                recipePreview && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "recipe-preview-col",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0075c5ef3314e518$var$RecipePreview, {
                                        recipe: recipePreview
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "admin-modal-footer",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "btn-secondary",
                                onClick: ()=>{
                                    setRecipesUser(null);
                                    setRecipePreview(null);
                                },
                                children: "Zamknij"
                            })
                        })
                    ]
                })
            }),
            importFile && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "admin-modal-overlay",
                onClick: ()=>!importing && setImportFile(null),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "admin-modal",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "admin-modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-upload"
                                        }),
                                        " Import przepis\xf3w"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>!importing && setImportFile(null),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-times"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "admin-modal-body",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        "Plik ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: importFile.name
                                        }),
                                        " zawiera ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: importFile.data.count ?? importFile.data.recipes.length
                                        }),
                                        " przepis\xf3w",
                                        importFile.data.exported_at && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                " (eksport z ",
                                                $0075c5ef3314e518$var$fmtDate(importFile.data.exported_at),
                                                ")"
                                            ]
                                        }),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "checkbox-label",
                                    style: {
                                        marginTop: '0.75rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "radio",
                                            name: "import-mode",
                                            checked: importMode === 'merge',
                                            onChange: ()=>setImportMode('merge')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Dopisz brakuj\u0105ce"
                                                }),
                                                " \u2014 istniej\u0105ce przepisy zostaj\u0105, duplikaty s\u0105 pomijane"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                    className: "checkbox-label",
                                    style: {
                                        marginTop: '0.5rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "radio",
                                            name: "import-mode",
                                            checked: importMode === 'replace',
                                            onChange: ()=>setImportMode('replace')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            style: {
                                                color: '#f87171'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: "Zast\u0105p ca\u0142\u0105 baz\u0119"
                                                }),
                                                " \u2014 wszystkie obecne przepisy zostan\u0105 usuni\u0119te i zast\u0105pione plikiem"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "admin-empty",
                                    style: {
                                        marginTop: '0.75rem'
                                    },
                                    children: "Przepisy s\u0105 przypisywane do u\u017Cytkownik\xf3w po adresie email \u2014 wpisy nieistniej\u0105cych ju\u017C kont zostan\u0105 pomini\u0119te."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "admin-modal-footer",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: importMode === 'replace' ? 'btn-danger' : 'btn-primary',
                                    onClick: handleImportConfirm,
                                    disabled: importing,
                                    children: importing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-spinner fa-spin"
                                            }),
                                            " Importowanie..."
                                        ]
                                    }) : importMode === 'replace' ? "Zast\u0105p baz\u0119" : 'Importuj'
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "btn-secondary",
                                    onClick: ()=>setImportFile(null),
                                    disabled: importing,
                                    children: "Anuluj"
                                })
                            ]
                        })
                    ]
                })
            }),
            deleteRecipeTarget && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "admin-modal-overlay",
                onClick: ()=>setDeleteRecipeTarget(null),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "admin-modal admin-modal-confirm",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "admin-modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-exclamation-triangle"
                                        }),
                                        " Usu\u0144 przepis"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>setDeleteRecipeTarget(null),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-times"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "admin-modal-body",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        "Czy na pewno chcesz usun\u0105\u0107 przepis ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: deleteRecipeTarget.title
                                        }),
                                        "?"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "confirm-warning",
                                    children: "Ta operacja jest nieodwracalna."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "admin-modal-footer",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "btn-danger",
                                    onClick: handleDeleteRecipe,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-trash"
                                        }),
                                        " Usu\u0144"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "btn-secondary",
                                    onClick: ()=>setDeleteRecipeTarget(null),
                                    children: "Anuluj"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $dkmhp = parcelRequire("dkmhp");



const $1b8e0994176c9ade$var$LANGS = [
    {
        code: 'pl',
        label: 'PL'
    },
    {
        code: 'en',
        label: 'EN'
    },
    {
        code: 'de',
        label: 'DE'
    }
];
function $1b8e0994176c9ade$var$App() {
    const { t: t, tErr: tErr, lang: lang, changeLang: changeLang } = (0, $0f85c0253a30f8b6$export$b24a004ee43dce44)();
    const [user, setUser] = (0, $acw62.useState)((0, $dkmhp.getCurrentUser)());
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [theme, setTheme] = (0, $acw62.useState)(()=>localStorage.getItem('theme') || 'dark');
    const [showLoginModal, setShowLoginModal] = (0, $acw62.useState)(false);
    const [showRegisterModal, setShowRegisterModal] = (0, $acw62.useState)(false);
    const [authError, setAuthError] = (0, $acw62.useState)('');
    const [authSuccess, setAuthSuccess] = (0, $acw62.useState)('');
    const [loginData, setLoginData] = (0, $acw62.useState)({
        username: '',
        password: ''
    });
    const [registerData, setRegisterData] = (0, $acw62.useState)({
        name: '',
        email: '',
        password: '',
        confirmPassword: ''
    });
    const [mcSession, setMcSession] = (0, $acw62.useState)(null);
    const [showHelpGuide, setShowHelpGuide] = (0, $acw62.useState)(false);
    const [showAdminPanel, setShowAdminPanel] = (0, $acw62.useState)(false);
    // Przepis innego użytkownika wczytany przez admina ("Wczytaj do konwertera")
    const [adminRecipe, setAdminRecipe] = (0, $acw62.useState)(null);
    const [showContactModal, setShowContactModal] = (0, $acw62.useState)(false);
    const [showResetModal, setShowResetModal] = (0, $acw62.useState)(false);
    const [resetStep, setResetStep] = (0, $acw62.useState)(1);
    const [resetEmail, setResetEmail] = (0, $acw62.useState)('');
    const [resetCode, setResetCode] = (0, $acw62.useState)('');
    const [resetNewPass, setResetNewPass] = (0, $acw62.useState)('');
    const [resetConfirmPass, setResetConfirmPass] = (0, $acw62.useState)('');
    const [resetError, setResetError] = (0, $acw62.useState)('');
    const [resetLoading, setResetLoading] = (0, $acw62.useState)(false);
    const [contactTab, setContactTab] = (0, $acw62.useState)('contact');
    const [contactForm, setContactForm] = (0, $acw62.useState)({
        topic: '',
        email: '',
        message: ''
    });
    const [contactSent, setContactSent] = (0, $acw62.useState)(false);
    const [contactSending, setContactSending] = (0, $acw62.useState)(false);
    const [contactError, setContactError] = (0, $acw62.useState)('');
    // „Jak zacząć?" pulsuje dla nowych userów, dopóki nie połączą MC ani nie otworzą przewodnika
    const [helpSeen, setHelpSeen] = (0, $acw62.useState)(()=>localStorage.getItem('mm_help_seen') === '1');
    const openHelpGuide = ()=>{
        setShowHelpGuide(true);
        setHelpSeen(true);
        localStorage.setItem('mm_help_seen', '1');
    };
    // Usuwanie konta
    const [showAccountModal, setShowAccountModal] = (0, $acw62.useState)(false);
    const [deleteConfirm, setDeleteConfirm] = (0, $acw62.useState)(false);
    const [deletePassword, setDeletePassword] = (0, $acw62.useState)('');
    const [deleteError, setDeleteError] = (0, $acw62.useState)('');
    const [deleteLoading, setDeleteLoading] = (0, $acw62.useState)(false);
    const closeAccountModal = ()=>{
        setShowAccountModal(false);
        setDeleteConfirm(false);
        setDeletePassword('');
        setDeleteError('');
    };
    const handleDeleteAccount = async (e)=>{
        e.preventDefault();
        setDeleteError('');
        setDeleteLoading(true);
        try {
            await (0, $dkmhp.authAPI).deleteAccount(deletePassword);
            (0, $dkmhp.authAPI).logout();
            setUser(null);
            setMcSession(null);
            (0, $dkmhp.setLiveMcSession)(null);
            closeAccountModal();
            setAuthSuccess(t('account.deleted'));
            setTimeout(()=>setAuthSuccess(''), 5000);
        } catch (error) {
            setDeleteError(tErr(error.response?.data?.error) || t('account.delete_error'));
        } finally{
            setDeleteLoading(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('theme', theme);
    }, [
        theme
    ]);
    const toggleTheme = ()=>setTheme((t)=>t === 'dark' ? 'light' : 'dark');
    (0, $acw62.useEffect)(()=>{
        const token = localStorage.getItem('token');
        if (token && !user) (0, $dkmhp.authAPI).profile().then((r)=>{
            (0, $dkmhp.setCurrentUser)(r.data.user);
            setUser(r.data.user);
        }).catch(()=>{
            localStorage.removeItem('token');
        }).finally(()=>setLoading(false));
        else setLoading(false);
    }, []);
    (0, $acw62.useEffect)(()=>{
        // W apce Android moduł natywny odpowiada na te same pingi co wtyczka —
        // rejestrujemy go przed startem handshake'u, reszta przepływu bez zmian.
        (0, $5a6742a4b36362a4$export$a7ac1466a98bfa17)();
        let lastSessionJson = null;
        function applySession(s) {
            if (!s || !s.wp_logged_in_value || !s.lidl_sso_token) return;
            const json = JSON.stringify(s);
            if (json === lastSessionJson) return; // ta sama sesja — bez ponownego zapisu do DB
            lastSessionJson = json;
            setMcSession(s);
            // Nagłówek X-MC-Session ma pierwszeństwo przed kopią w bazie — dzięki temu
            // backend rozmawia z MC na sesji sprzed sekund, a nie sprzed godzin
            (0, $dkmhp.setLiveMcSession)(s);
            const parts = [];
            if (s.gclb) parts.push(`GCLB=${s.gclb}`);
            if (s.php_session_id) parts.push(`PHPSESSID=${s.php_session_id}`);
            parts.push(`wp-wpml_current_language=pl`);
            parts.push(`${s.wp_logged_in_key}=${s.wp_logged_in_value}`);
            parts.push(`lidl_sso_id_token=${s.lidl_sso_token}`);
            (0, $dkmhp.aiAPI).saveMCSession(parts.join('; ')).catch(()=>{});
        }
        const ping = ()=>document.dispatchEvent(new CustomEvent('MC_EXT_GET_SESSION'));
        const handler = (e)=>applySession(e.detail?.session);
        document.addEventListener('MC_EXT_SESSION_RESULT', handler);
        // Handshake z wtyczką to wyścig w obie strony: jej content script może
        // wstrzyknąć się po nas (pojedynczy ping przepada), albo ogłosić sesję
        // zanim zarejestrujemy listener. Ponawiamy ping z rosnącym odstępem,
        // aż sesja dotrze — nasłuch po stronie wtyczki jest trwały.
        const timers = [
            500,
            1500,
            3000,
            6000,
            12000,
            25000
        ].map((d)=>setTimeout(()=>{
                if (!lastSessionJson) ping();
            }, d));
        // Powrót do karty = szansa na świeżą sesję (MC wygasza ją po ~5 min)
        const onVisible = ()=>{
            if (document.visibilityState === 'visible') ping();
        };
        document.addEventListener('visibilitychange', onVisible);
        return ()=>{
            timers.forEach(clearTimeout);
            document.removeEventListener('MC_EXT_SESSION_RESULT', handler);
            document.removeEventListener('visibilitychange', onVisible);
        };
    }, []);
    const handleLogin = async (e)=>{
        e.preventDefault();
        setAuthError('');
        try {
            const response = await (0, $dkmhp.authAPI).login(loginData);
            const { access_token: access_token, user: user } = response.data;
            (0, $dkmhp.setAuthToken)(access_token);
            (0, $dkmhp.setCurrentUser)(user);
            setUser(user);
            setShowLoginModal(false);
            setLoginData({
                username: '',
                password: ''
            });
            setAuthSuccess(t('login.success'));
            setTimeout(()=>setAuthSuccess(''), 3000);
        } catch (error) {
            setAuthError(tErr(error.response?.data?.error) || t('login.error'));
        }
    };
    const handleRegister = async (e)=>{
        e.preventDefault();
        setAuthError('');
        if (registerData.password !== registerData.confirmPassword) {
            setAuthError(t('register.passwords_mismatch'));
            return;
        }
        try {
            await (0, $dkmhp.authAPI).register({
                username: registerData.name,
                email: registerData.email,
                password: registerData.password
            });
            setAuthSuccess(t('register.success'));
            setRegisterData({
                name: '',
                email: '',
                password: '',
                confirmPassword: ''
            });
            setTimeout(()=>{
                setShowRegisterModal(false);
                setShowLoginModal(true);
                setAuthSuccess('');
            }, 2000);
        } catch (error) {
            setAuthError(tErr(error.response?.data?.error) || t('register.error'));
        }
    };
    const openResetModal = ()=>{
        setResetStep(1);
        setResetEmail('');
        setResetCode('');
        setResetNewPass('');
        setResetConfirmPass('');
        setResetError('');
        setShowLoginModal(false);
        setShowResetModal(true);
    };
    const handleResetStep1 = async (e)=>{
        e.preventDefault();
        setResetError('');
        setResetLoading(true);
        try {
            await (0, $dkmhp.authAPI).forgotPassword(resetEmail);
            setResetStep(2);
        } catch (err) {
            setResetError(tErr(err.response?.data?.error) || t('reset.error_email'));
        } finally{
            setResetLoading(false);
        }
    };
    const handleResetStep2 = async (e)=>{
        e.preventDefault();
        setResetError('');
        if (resetNewPass !== resetConfirmPass) {
            setResetError(t('reset.passwords_mismatch'));
            return;
        }
        if (resetNewPass.length < 6) {
            setResetError(t('reset.too_short'));
            return;
        }
        setResetLoading(true);
        try {
            const r = await (0, $dkmhp.authAPI).verifyResetCode(resetEmail, resetCode, resetNewPass);
            const { access_token: access_token, user: user } = r.data;
            (0, $dkmhp.setAuthToken)(access_token);
            (0, $dkmhp.setCurrentUser)(user);
            setUser(user);
            setShowResetModal(false);
            setAuthSuccess(t('reset.success'));
            setTimeout(()=>setAuthSuccess(''), 4000);
        } catch (err) {
            setResetError(tErr(err.response?.data?.error) || t('reset.error_code'));
        } finally{
            setResetLoading(false);
        }
    };
    const handleLogout = ()=>{
        (0, $dkmhp.authAPI).logout();
        setUser(null);
        setMcSession(null);
        (0, $dkmhp.setLiveMcSession)(null);
        setAuthSuccess(t('header.logout_success'));
        setTimeout(()=>setAuthSuccess(''), 3000);
    };
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app-loading",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "spinner"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: t('loading')
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app",
        children: [
            showHelpGuide && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf86d3c04e63e9f6$export$2e2bcd8739ae039), {
                onClose: ()=>setShowHelpGuide(false)
            }),
            showAdminPanel && user?.is_admin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0075c5ef3314e518$export$2e2bcd8739ae039), {
                currentUserId: user.id,
                onClose: ()=>setShowAdminPanel(false),
                onLoadRecipe: (r)=>{
                    setAdminRecipe({
                        ...r,
                        _loadedAt: Date.now()
                    });
                    setShowAdminPanel(false);
                }
            }),
            showLoginModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "modal-overlay",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "modal",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-sign-in-alt"
                                        }),
                                        " ",
                                        t('login.title')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "modal-close",
                                    onClick: ()=>setShowLoginModal(false),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-times"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                            onSubmit: handleLogin,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "modal-body",
                                    children: [
                                        authError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "auth-error",
                                            children: authError
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    htmlFor: "username",
                                                    children: t('login.username')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "email",
                                                    id: "username",
                                                    value: loginData.username,
                                                    onChange: (e)=>setLoginData({
                                                            ...loginData,
                                                            username: e.target.value
                                                        }),
                                                    required: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    htmlFor: "password",
                                                    children: t('login.password')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "password",
                                                    id: "password",
                                                    value: loginData.password,
                                                    onChange: (e)=>setLoginData({
                                                            ...loginData,
                                                            password: e.target.value
                                                        }),
                                                    required: true
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "modal-footer",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "submit",
                                            className: "btn-primary",
                                            children: t('login.submit')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn-secondary",
                                            onClick: ()=>setShowLoginModal(false),
                                            children: t('cancel')
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-switch",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    children: [
                                        t('login.no_account'),
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            onClick: ()=>{
                                                setShowLoginModal(false);
                                                setShowRegisterModal(true);
                                            },
                                            children: t('login.register_link')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "modal-link-subtle",
                                        onClick: openResetModal,
                                        children: t('login.forgot')
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            showRegisterModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "modal-overlay",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "modal",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-user-plus"
                                        }),
                                        " ",
                                        t('register.title')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "modal-close",
                                    onClick: ()=>setShowRegisterModal(false),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-times"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                            onSubmit: handleRegister,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "modal-body",
                                    children: [
                                        authError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "auth-error",
                                            children: authError
                                        }),
                                        authSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "auth-success",
                                            children: authSuccess
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: t('register.name')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    value: registerData.name,
                                                    onChange: (e)=>setRegisterData({
                                                            ...registerData,
                                                            name: e.target.value
                                                        }),
                                                    required: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: t('register.email')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "email",
                                                    value: registerData.email,
                                                    onChange: (e)=>setRegisterData({
                                                            ...registerData,
                                                            email: e.target.value
                                                        }),
                                                    required: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: t('register.password')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "password",
                                                    value: registerData.password,
                                                    onChange: (e)=>setRegisterData({
                                                            ...registerData,
                                                            password: e.target.value
                                                        }),
                                                    required: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: t('register.confirm_password')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "password",
                                                    value: registerData.confirmPassword,
                                                    onChange: (e)=>setRegisterData({
                                                            ...registerData,
                                                            confirmPassword: e.target.value
                                                        }),
                                                    required: true
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "modal-footer",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "submit",
                                            className: "btn-primary",
                                            children: t('register.submit')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn-secondary",
                                            onClick: ()=>setShowRegisterModal(false),
                                            children: t('cancel')
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "modal-switch",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    t('register.has_account'),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>{
                                            setShowRegisterModal(false);
                                            setShowLoginModal(true);
                                        },
                                        children: t('register.login_link')
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            showResetModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "modal-overlay",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "modal",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-key"
                                        }),
                                        " ",
                                        t('reset.title')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "modal-close",
                                    onClick: ()=>setShowResetModal(false),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-times"
                                    })
                                })
                            ]
                        }),
                        resetStep === 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                            onSubmit: handleResetStep1,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "modal-body",
                                    children: [
                                        resetError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "auth-error",
                                            children: resetError
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "reset-intro",
                                            children: t('reset.intro')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: t('reset.email_label')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "email",
                                                    value: resetEmail,
                                                    onChange: (e)=>setResetEmail(e.target.value),
                                                    placeholder: t('reset.email_placeholder'),
                                                    required: true,
                                                    autoFocus: true
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "modal-footer",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "submit",
                                            className: "btn-primary",
                                            disabled: resetLoading,
                                            children: resetLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                        className: "fas fa-spinner fa-spin"
                                                    }),
                                                    " ",
                                                    t('reset.sending')
                                                ]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                        className: "fas fa-paper-plane"
                                                    }),
                                                    " ",
                                                    t('reset.send_code')
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn-secondary",
                                            onClick: ()=>setShowResetModal(false),
                                            children: t('cancel')
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                            onSubmit: handleResetStep2,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "modal-body",
                                    children: [
                                        resetError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "auth-error",
                                            children: resetError
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "reset-sent-info",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-envelope-open-text"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        t('reset.code_sent'),
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                            children: resetEmail
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: t('reset.code_label')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    inputMode: "numeric",
                                                    pattern: "[0-9]{6}",
                                                    maxLength: 6,
                                                    value: resetCode,
                                                    onChange: (e)=>setResetCode(e.target.value.replace(/\D/g, '')),
                                                    placeholder: "123456",
                                                    required: true,
                                                    autoFocus: true,
                                                    className: "reset-code-input"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: t('reset.new_password')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "password",
                                                    value: resetNewPass,
                                                    onChange: (e)=>setResetNewPass(e.target.value),
                                                    placeholder: t('reset.min_chars'),
                                                    required: true,
                                                    minLength: 6
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    children: t('reset.confirm_password')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "password",
                                                    value: resetConfirmPass,
                                                    onChange: (e)=>setResetConfirmPass(e.target.value),
                                                    placeholder: t('reset.confirm_placeholder'),
                                                    required: true
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "modal-footer",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "submit",
                                            className: "btn-primary",
                                            disabled: resetLoading,
                                            children: resetLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                        className: "fas fa-spinner fa-spin"
                                                    }),
                                                    " ",
                                                    t('reset.changing')
                                                ]
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                        className: "fas fa-check"
                                                    }),
                                                    " ",
                                                    t('reset.change')
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            className: "btn-secondary",
                                            onClick: ()=>setResetStep(1),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-arrow-left"
                                                }),
                                                " ",
                                                t('back')
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "modal-switch",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "modal-link-subtle",
                                            onClick: handleResetStep1,
                                            disabled: resetLoading,
                                            children: t('reset.resend')
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            showAccountModal && user && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "modal-overlay",
                onClick: closeAccountModal,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "modal",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-user-cog"
                                        }),
                                        " ",
                                        t('account.title')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "modal-close",
                                    onClick: closeAccountModal,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-times"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-body",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "account-info-row",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "account-info-label",
                                            children: t('account.username')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "account-info-value",
                                            children: user.username
                                        })
                                    ]
                                }),
                                user.email && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "account-info-row",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "account-info-label",
                                            children: t('account.email')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "account-info-value",
                                            children: user.email
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "account-danger",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-triangle-exclamation"
                                                }),
                                                " ",
                                                t('account.danger_title')
                                            ]
                                        }),
                                        !deleteConfirm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "account-danger-desc",
                                                    children: t('account.delete_desc')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    className: "btn-danger-outline",
                                                    onClick: ()=>setDeleteConfirm(true),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                            className: "fas fa-trash"
                                                        }),
                                                        " ",
                                                        t('account.delete_btn')
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                            onSubmit: handleDeleteAccount,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "account-danger-warn",
                                                    children: t('account.delete_warn')
                                                }),
                                                deleteError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "auth-error",
                                                    children: deleteError
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "form-group",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            htmlFor: "delete-password",
                                                            children: t('account.delete_password_label')
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "password",
                                                            id: "delete-password",
                                                            value: deletePassword,
                                                            onChange: (e)=>setDeletePassword(e.target.value),
                                                            required: true,
                                                            autoFocus: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "account-danger-actions",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "submit",
                                                            className: "btn-danger",
                                                            disabled: deleteLoading || !deletePassword,
                                                            children: deleteLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                        className: "fas fa-spinner fa-spin"
                                                                    }),
                                                                    " ",
                                                                    t('account.deleting')
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                                        className: "fas fa-trash"
                                                                    }),
                                                                    " ",
                                                                    t('account.delete_confirm_btn')
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "btn-secondary",
                                                            onClick: ()=>{
                                                                setDeleteConfirm(false);
                                                                setDeletePassword('');
                                                                setDeleteError('');
                                                            },
                                                            children: t('cancel')
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                className: "header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "logo",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "logo-text",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "logo-mate",
                                    children: "Mate"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "logo-meal",
                                    children: "Meal"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "user-section",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "btn-theme",
                                onClick: toggleTheme,
                                title: theme === 'dark' ? 'Tryb jasny' : 'Tryb ciemny',
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: `fas ${theme === 'dark' ? 'fa-sun' : 'fa-moon'}`
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "lang-switcher",
                                children: $1b8e0994176c9ade$var$LANGS.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `lang-btn ${lang === l.code ? 'lang-btn--active' : ''}`,
                                        onClick: ()=>changeLang(l.code),
                                        children: l.label
                                    }, l.code))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                className: `btn-help ${user && !mcSession && !helpSeen ? 'btn-help--attn' : ''}`,
                                onClick: openHelpGuide,
                                title: t('header.help'),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-question-circle"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: t('header.help')
                                    })
                                ]
                            }),
                            user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "user-info",
                                children: [
                                    user.is_admin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: "btn-admin",
                                        onClick: ()=>setShowAdminPanel(true),
                                        title: t('header.admin'),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                className: "fas fa-shield-alt"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: t('header.admin')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "user-name",
                                        children: user.username
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "btn-account",
                                        onClick: ()=>setShowAccountModal(true),
                                        title: t('account.title'),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-user-cog"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "btn-logout",
                                        onClick: handleLogout,
                                        title: t('account.logout'),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-sign-out-alt"
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "auth-buttons",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "btn-login",
                                        onClick: ()=>setShowLoginModal(true),
                                        children: t('header.login')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "btn-register",
                                        onClick: ()=>setShowRegisterModal(true),
                                        children: t('header.register')
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                className: "main-content",
                children: [
                    authError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "global-error",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-exclamation-triangle"
                            }),
                            " ",
                            authError,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "close-error",
                                onClick: ()=>setAuthError(''),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "fas fa-times"
                                })
                            })
                        ]
                    }),
                    authSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "global-success",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "fas fa-check-circle"
                            }),
                            " ",
                            authSuccess,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "close-success",
                                onClick: ()=>setAuthSuccess(''),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "fas fa-times"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "content-area",
                        children: !user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "hero",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "hero-icon",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-robot"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-arrow-right hero-arrow"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-blender"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    children: t('hero.title')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "hero-sub",
                                    children: t('hero.sub')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "hero-features",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "hero-feat",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-paste"
                                                }),
                                                t('hero.feat1')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "hero-feat",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-magic"
                                                }),
                                                t('hero.feat2')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "hero-feat",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-paper-plane"
                                                }),
                                                t('hero.feat3')
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "hero-actions",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            className: "btn-primary btn-lg",
                                            onClick: ()=>setShowLoginModal(true),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-sign-in-alt"
                                                }),
                                                " ",
                                                t('hero.cta_login')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            className: "btn-secondary btn-lg",
                                            onClick: openHelpGuide,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-question-circle"
                                                }),
                                                " ",
                                                t('hero.cta_help')
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $042abebcecde25e2$export$2e2bcd8739ae039), {
                            mcSession: mcSession,
                            user: user,
                            externalRecipe: adminRecipe,
                            onUserUpdate: (u)=>{
                                (0, $dkmhp.setCurrentUser)(u);
                                setUser(u);
                            },
                            onMcConnect: (0, $5a6742a4b36362a4$export$1efe58f5634014d1)() ? ()=>(0, $5a6742a4b36362a4$export$2f67b24ad905835c)(lang, t('conv.mc_connect_hint')) : null
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("footer", {
                className: "footer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "footer-inner",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "footer-top",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "footer-brand",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "footer-logo",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "logo-mate",
                                                    children: "Mate"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "logo-meal",
                                                    children: "Meal"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "footer-tagline",
                                            children: t('footer.tagline')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "footer-nav",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            className: "footer-link",
                                            onClick: openHelpGuide,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-question-circle"
                                                }),
                                                " ",
                                                t('footer.help')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            className: "footer-link",
                                            onClick: ()=>{
                                                setContactTab('contact');
                                                setContactForm({
                                                    topic: '',
                                                    email: '',
                                                    message: ''
                                                });
                                                setContactSent(false);
                                                setShowContactModal(true);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-envelope"
                                                }),
                                                " ",
                                                t('footer.contact')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                            className: "footer-link",
                                            href: "/privacy",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-shield-alt"
                                                }),
                                                " ",
                                                t('footer.privacy')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                            className: "footer-link",
                                            href: "https://www.facebook.com/profile.php?id=61590254290685",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fab fa-facebook"
                                                }),
                                                " Facebook"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "footer-disclaimers",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "footer-disc",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-shield-alt"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: t('footer.security')
                                                }),
                                                " ",
                                                t('footer.security_text')
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "footer-disc",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "fas fa-tag"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: t('footer.affiliate')
                                                }),
                                                " ",
                                                t('footer.affiliate_text')
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "footer-copy",
                            children: [
                                "\xa9 ",
                                new Date().getFullYear(),
                                " MateMeal. ",
                                t('footer.rights')
                            ]
                        })
                    ]
                })
            }),
            showContactModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "modal-overlay",
                onClick: ()=>{
                    setShowContactModal(false);
                    setContactError('');
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "modal contact-modal",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modal-header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "contact-tabs",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            className: `contact-tab ${contactTab === 'contact' ? 'active' : ''}`,
                                            onClick: ()=>{
                                                setContactTab('contact');
                                                setContactForm((p)=>({
                                                        ...p,
                                                        topic: ''
                                                    }));
                                                setContactSent(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-envelope"
                                                }),
                                                " ",
                                                t('contact.tab_contact')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            className: `contact-tab ${contactTab === 'bug' ? 'active' : ''}`,
                                            onClick: ()=>{
                                                setContactTab('bug');
                                                setContactForm((p)=>({
                                                        ...p,
                                                        topic: t('contact.bug_topic')
                                                    }));
                                                setContactSent(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-bug"
                                                }),
                                                " ",
                                                t('contact.tab_bug')
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "modal-close-btn",
                                    onClick: ()=>{
                                        setShowContactModal(false);
                                        setContactError('');
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-times"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "modal-body",
                            children: contactSent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "contact-sent",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "fas fa-check-circle"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        children: t('contact.sent_title')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: t('contact.sent_text')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "btn-primary",
                                        onClick: ()=>{
                                            setShowContactModal(false);
                                            setContactError('');
                                        },
                                        children: t('close')
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: async (e)=>{
                                    e.preventDefault();
                                    setContactSending(true);
                                    setContactError('');
                                    const subjectType = contactForm.topic || (contactTab === 'bug' ? t('contact.bug_topic') : t('contact.generic_topic'));
                                    try {
                                        const res = await fetch('/api/contact', {
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json'
                                            },
                                            body: JSON.stringify({
                                                subject_type: subjectType,
                                                message: contactForm.message,
                                                reply_email: contactForm.email
                                            })
                                        });
                                        if (res.status === 429) {
                                            setContactError(t('contact.form.rate_limit'));
                                            return;
                                        }
                                        if (!res.ok) throw new Error();
                                        setContactSent(true);
                                    } catch  {
                                        setContactError(t('contact.form.error_short'));
                                    } finally{
                                        setContactSending(false);
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "contact-intro",
                                        children: contactTab === 'bug' ? t('contact.intro_bug') : t('contact.intro_contact')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: t('contact.topic')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "text",
                                                value: contactForm.topic,
                                                onChange: (e)=>setContactForm((p)=>({
                                                            ...p,
                                                            topic: e.target.value
                                                        })),
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                children: [
                                                    t('contact.email'),
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "optional",
                                                        children: t('contact.email_optional')
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "email",
                                                value: contactForm.email,
                                                onChange: (e)=>setContactForm((p)=>({
                                                            ...p,
                                                            email: e.target.value
                                                        })),
                                                placeholder: t('reset.email_placeholder')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                children: t('contact.message')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                value: contactForm.message,
                                                onChange: (e)=>setContactForm((p)=>({
                                                            ...p,
                                                            message: e.target.value
                                                        })),
                                                rows: 5,
                                                required: true
                                            })
                                        ]
                                    }),
                                    contactError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        style: {
                                            color: '#f87171',
                                            fontSize: '0.83rem',
                                            margin: '0 0 8px'
                                        },
                                        children: contactError
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "modal-footer",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "submit",
                                            className: "btn-primary",
                                            disabled: contactSending,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "fas fa-paper-plane"
                                                }),
                                                " ",
                                                contactSending ? t('contact.form.sending') : t('contact.send')
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $1b8e0994176c9ade$export$2e2bcd8739ae039 = $1b8e0994176c9ade$var$App;




const $34a83e38fb8b3bfc$var$container = document.getElementById('root');
const $34a83e38fb8b3bfc$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($34a83e38fb8b3bfc$var$container);
$34a83e38fb8b3bfc$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f85c0253a30f8b6$export$b78e4fb81d317543), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b8e0994176c9ade$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=frontend.d31144c4.js.map
